webpackJsonp([1],{

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b61b811",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    var goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa1c8f08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("b86dabf0", content, true, {});

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#download-popup[data-v-aa1c8f08]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;background-color:rgba(0,0,0,.6)}#download-popup .popup-body[data-v-aa1c8f08]{position:relative;width:75%;height:200px;margin:0 auto;margin-top:10rem;background-size:100%}#download-popup .popup-body-head[data-v-aa1c8f08]{display:block;width:140px;margin:0 auto}#download-popup .popup-body-content[data-v-aa1c8f08]{margin-top:-45px;padding-bottom:10px;border-radius:5px;background:#fff}#download-popup .popup-body-close[data-v-aa1c8f08]{position:absolute;top:-.5rem;right:-.5rem;width:2.6rem;height:2.6rem;line-height:1.6rem}#download-popup .popup-body-go[data-v-aa1c8f08]{display:block;width:90%;height:2.6rem;margin:0 auto;margin-top:5px;color:#fff;text-align:center;line-height:2.6rem;border-radius:5px;font-weight:800;background-color:#25c023}#download-popup .popup-body-text[data-v-aa1c8f08]{padding:0 10px;padding-top:50px;margin-bottom:15px;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/downloadPopup.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,+BAAqC,CACtC,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,oBAAsB,CACvB,AACD,kDACE,cAAe,AACf,YAAa,AACb,aAAe,CAChB,AACD,qDACE,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,gDACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kDACE,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadPopup.vue","sourcesContent":["\n#download-popup[data-v-aa1c8f08] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n#download-popup .popup-body[data-v-aa1c8f08] {\n  position: relative;\n  width: 75%;\n  height: 200px;\n  margin: 0 auto;\n  margin-top: 10rem;\n  background-size: 100%;\n}\n#download-popup .popup-body-head[data-v-aa1c8f08] {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n#download-popup .popup-body-content[data-v-aa1c8f08] {\n  margin-top: -45px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  background: #fff;\n}\n#download-popup .popup-body-close[data-v-aa1c8f08] {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 2.6rem;\n  height: 2.6rem;\n  line-height: 1.6rem;\n}\n#download-popup .popup-body-go[data-v-aa1c8f08] {\n  display: block;\n  width: 90%;\n  height: 2.6rem;\n  margin: 0 auto;\n  margin-top: 5px;\n  color: #fff;\n  text-align: center;\n  line-height: 2.6rem;\n  border-radius: 5px;\n  font-weight: 800;\n  background-color: #25c023;\n}\n#download-popup .popup-body-text[data-v-aa1c8f08] {\n  padding: 0 10px;\n  padding-top: 50px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            popup_show: false,
            popup_text: 'lihat 200+ data lebih rinci，silakan download app',
            popup_btn: true,
            now_local_date: new Date().toLocaleDateString()
        };
    },
    mounted: function mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
    },


    methods: {
        handleClose: function handleClose() {
            this.popup_show = false;
        },
        goDownload: function goDownload() {
            sessionStorage.setItem('loop_run', 'true');
            this.popup_show = false;
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                location.href = '/download';
            } else if (browers.iOS) {
                var utilObj = __webpack_require__(499);
                utilObj.jumpUrl();
            }
        }
    }
};

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": __webpack_require__(505),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_btn),
      expression: "popup_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": _vm.goDownload
    }
  }, [_vm._v("Tekan")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-close",
    attrs: {
      "src": __webpack_require__(506)
    },
    on: {
      "click": _vm.handleClose
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_icon.c1b2864.png";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close_icon.9c943d6.png";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(127)('meta');
var isObject = __webpack_require__(57);
var has = __webpack_require__(64);
var setDesc = __webpack_require__(56).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(86)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(510);


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(511);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ 511:
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(85);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(66);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(548), __esModule: true };

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191);
__webpack_require__(128);
__webpack_require__(193);
__webpack_require__(549);
__webpack_require__(555);
__webpack_require__(558);
__webpack_require__(560);
module.exports = __webpack_require__(32).Map;


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(550);
var validate = __webpack_require__(514);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(551)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(56).f;
var create = __webpack_require__(192);
var redefineAll = __webpack_require__(189);
var ctx = __webpack_require__(59);
var anInstance = __webpack_require__(188);
var forOf = __webpack_require__(186);
var $iterDefine = __webpack_require__(129);
var step = __webpack_require__(194);
var setSpecies = __webpack_require__(195);
var DESCRIPTORS = __webpack_require__(58);
var fastKey = __webpack_require__(507).fastKey;
var validate = __webpack_require__(514);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var $export = __webpack_require__(50);
var meta = __webpack_require__(507);
var fails = __webpack_require__(86);
var hide = __webpack_require__(51);
var redefineAll = __webpack_require__(189);
var forOf = __webpack_require__(186);
var anInstance = __webpack_require__(188);
var isObject = __webpack_require__(57);
var setToStringTag = __webpack_require__(89);
var dP = __webpack_require__(56).f;
var each = __webpack_require__(552)(0);
var DESCRIPTORS = __webpack_require__(58);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(59);
var IObject = __webpack_require__(130);
var toObject = __webpack_require__(88);
var toLength = __webpack_require__(90);
var asc = __webpack_require__(553);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(554);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
var isArray = __webpack_require__(545);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(50);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(556)('Map') });


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(131);
var from = __webpack_require__(557);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(186);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(559)('Map');


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(50);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(561)('Map');


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(50);
var aFunction = __webpack_require__(67);
var ctx = __webpack_require__(59);
var forOf = __webpack_require__(186);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAxtJREFUSEu9lk1oHGUYx///d97ZTeghEZLZKDkUPBRFUKzQ7qyB9OBBNFnxEPy4hOgtEUoolVLSpu2lEBD1Iq1oD35AG0kymxoQBQPm4xQMiHgp9GKTZqoSDG2zyc77tO9uvs0msyHxndPsPvP85v98DlHm1Af+TQX5ca518lMQUs5u4++pwH9LIF2JPFr/bJv8Z+sz3M5J/ffNDUpHsxCBWY7O3GuZvLwDzPqQVM7PiuC6qnGTZj56M3xjbDAWzBqlcunXoZ1hKRhA2Bdmx0+XA6Zy6bfF8Av1hFtt5pdOh/nGj9DWH+0MExAXUFLbC1MX+K8poB9AklDdc9mxT9ALteZk3eY7ABqUrrB18sqazXlYj2spKDn+uVnXzy++QsWXANasOLNv9jdEuqGYgsAAvArIvyAVRFZT8A6IJyFYAPgxRRJCaBgQCgsi/MN1FodnWqYe0IJSC8uXRORDJtTmUiAgyzaMgNVLvS5qVV0pzKU7ulv+t68TCcTg23B2sZ1e0JRhUsYkb+IU3J5smFCQvOmkF2RGoPEqCrGqe08wGxUB7tAb8n+Dw+dgDhYGg5BeLjMN4vkDhwnm6AX+r1B8YVeYTbbB8uPmsJeON1NWol5se96NBysa4xYofTTqkFBO0VVPFSs1zqkIBtie+yDMTnxmfXuD/tOieNKp0V1moYBYUYmtDFgC2BFmx7/ZKMQb8NNwcA3EkR3DWqEym6v3wtaJr7ZG7fBgc+19tTRAxRNlFe4XzMLrcsdfdBJ6quxg2E+YF2R6qHFRyg2GimBSLPmOMDvx9aZl+YPvySLPQaFzxyKpCAYUALZvLBAvyLxLmrOo0s/Iw/+srs2prQhWnG0cjXQhK5Fb6xpzDYImOHR3LfviOqikqdceKK2RjWslTk+vw3L+NMj/ZzamgvTvotSzscIRS8Y2RqVxF9rZ+Ascvmw36oEdm3PBHdYNHX/fqdKfH+imTiqYfPQlG2+kq/NVGFHaaZaiupUPjn2SSU3IUnRbufpY6QvpylHXa6jqAaQNYLVAWNrkez8iIIk8ID9pleyZaRn96xEO3naTQLauKwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(592), __esModule: true };

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(593);
module.exports = __webpack_require__(32).Object.keys;


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(88);
var $keys = __webpack_require__(126);

__webpack_require__(594)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(50);
var core = __webpack_require__(32);
var fails = __webpack_require__(86);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(596), __esModule: true };

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597);
module.exports = __webpack_require__(32).Object.values;


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(50);
var $values = __webpack_require__(598)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(87);
var isEnum = __webpack_require__(190).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(600);
var objectAssign = __webpack_require__(601);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-310d2b2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("e1c82d56", content, true, {});

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".match-tag-container[data-v-310d2b2e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin:0 auto;padding:.125rem .25rem;font-weight:500;font-size:.5rem;color:#16b13a;border-radius:2px;border:1px solid #16b13a;background-color:#fff;font-family:SF UI Display}.match-tag-container .icon-play[data-v-310d2b2e]{margin-right:.1875rem;width:.5625rem;height:.5rem}.match-tag-container.living-tag-container[data-v-310d2b2e]{color:#fff;background:#16b13a}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/AppMatchTag.vue"],"names":[],"mappings":"AACA,sCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,cAAe,AACf,uBAA0B,AAC1B,gBAAiB,AACjB,gBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,sBAA0B,AAC1B,yBAA2B,CAC5B,AACD,iDACE,sBAAwB,AACxB,eAAiB,AACjB,YAAe,CAChB,AACD,2DACE,WAAe,AACf,kBAAoB,CACrB","file":"AppMatchTag.vue","sourcesContent":["\n.match-tag-container[data-v-310d2b2e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 0 auto;\n  padding: 0.125rem 0.25rem;\n  font-weight: 500;\n  font-size: 0.5rem;\n  color: #16b13a;\n  border-radius: 2px;\n  border: 1px solid #16b13a;\n  background-color: #ffffff;\n  font-family: SF UI Display;\n}\n.match-tag-container .icon-play[data-v-310d2b2e] {\n  margin-right: 0.1875rem;\n  width: 0.5625rem;\n  height: 0.5rem;\n}\n.match-tag-container.living-tag-container[data-v-310d2b2e] {\n  color: #ffffff;\n  background: #16b13a;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = __webpack_require__(547);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconLive = __webpack_require__(606);
var iconLiving = __webpack_require__(568);

var TAG_TYPES = new _map2.default().set("1", {
    text: "LANGSUNG HD",
    icon: iconLive
}).set("2", {
    text: "HIGHLIGHTS",
    icon: iconLiving
});

exports.default = {
    props: {
        type: {
            type: String,
            default: ""
        }
    },

    computed: {
        activeTag: function activeTag() {
            return TAG_TYPES.get(this.type);
        }
    }
};

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAhdJREFUSEu9lkuojVEYhp9XLsmAkcuZGogUSUkoBgYiykAuE2F2KJ1EEgMm6tSJMxHCwKVEDMiEgWIqSjJRRnIJA0q5nc///q1df7tztrX2Pp2/9mCv//3eZ631ff+3lhjjiYj7wENgWFKMpWuOR8R2YD+wWdLX9hiNZhIRc4H36d1RSac7TEqeTERsAW4C04Ctku5mwSyKiE3AvRQwKOlwB+AO4BIwHbBuSNLfjrCI8Err1UoaiYiNwK002wFJZyNiUsukobkNTPYWSjrf0EQzBbVxRFi4HlgOzExmntkXYACYA4wAF6r/3wADWynYCcwDvgNngKkJ7Pcee+0dqnbmhzfboFPAkYZBTj2UaG4Auw1bBTwtiexS22/YA2BDlwYlYe8MewksLonqUvvJsBfAki4NSsI+GvYcWJoZ9TsVkYuq9PlQAnsDDFa/GcCh6jPoK6Rlw/zNHZB0Ln2X84GDqQ/mMrNhv4A9kq63Nd6VwBVgQQYxG+Zc7ZV0td00ImYBd4B1/wH2Dkvbugx4NlGw41W/PDmeMOfsWlvOZlcN+gTQP545+1M30kaBRMQu4Fh1YC7MAFmSnTOLHwM+jV0QrsA1wJRMUDGswHdUab2yCe2Nr4BFvU47I77u+k+A1RniXiX1ebYPuNirU0b8ZcN8/fJpvTYjoFvJW2BF63blEnYX2Jbufh7PugV3oNvjZ5WiR/aW9PkfcA7mVa4E05cAAAAASUVORK5CYII="

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-tag-container",
    class: {
      'living-tag-container': _vm.type === '1'
    }
  }, [_c('img', {
    staticClass: "icon-play",
    attrs: {
      "src": _vm.activeTag.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-text"
  }, [_vm._v(_vm._s(_vm.activeTag.text))])])
},staticRenderFns: []}

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17cb9b9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ab469f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultTeam.1d25f26.png";

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(638);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("145b53cc", content, true, {});

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".text-green[data-v-3b61b811]{color:#16b13a;font-size:.8rem}.topFixedWrap[data-v-3b61b811]{width:100%;position:fixed;top:0;z-index:999}.tab-box-fixed[data-v-3b61b811]{position:fixed;z-index:10;top:0;left:0}.tab-box-sticky[data-v-3b61b811]{position:-webkit-sticky;position:sticky;top:0;left:0;z-index:10}.navBread[data-v-3b61b811]{width:100%;height:2.4rem;background:#16b13a;color:#fff;line-height:2.4rem}.navBread a[data-v-3b61b811]{padding:0 1rem;text-decoration:none;color:#fff;font-size:.8rem}.navBread .match[data-v-3b61b811]{font-size:1rem;display:inline-block;height:1.2rem;line-height:1.2rem;border-right:.05rem solid #119730}.status_ended .scorewrap span[data-v-3b61b811]{width:2.1rem;height:2.1rem;overflow:hidden;display:inline-block;background:hsla(0,0%,100%,.1);font-size:2rem;float:left;border-radius:.1rem;text-align:center;line-height:2rem}.rowLine[data-v-3b61b811]{float:left;width:.7rem;height:.2rem;display:inline-block;background:#fff;overflow:hidden;margin:1rem 1rem 0}.competename[data-v-3b61b811]{margin-bottom:.6rem;text-align:center;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.time[data-v-3b61b811]{font-size:.7rem;color:#fff;text-align:center}.scorewrap[data-v-3b61b811]{margin-bottom:1rem}.status_playing .scorewrap span[data-v-3b61b811]{width:2.2rem;height:2.2rem;overflow:hidden;display:inline-block;background:hsla(0,0%,100%,.1);font-size:2rem;float:left;border-radius:.2rem;color:#16b13a;line-height:2.2rem}.status_playing .rowLine[data-v-3b61b811]{background:#16b13a}.status_playing .live[data-v-3b61b811]{width:6rem;height:1rem;background:#16bc3a;border-radius:.02666667rem;display:block;color:#fff;font-size:.68rem;line-height:1rem;margin:0 auto}.play_arrow[data-v-3b61b811]{margin:.25rem .4rem 0 1rem;width:.3rem;height:.4rem;float:left}.unlive[data-v-3b61b811]{color:#16b13a;font-size:.8rem}.status_unstart[data-v-3b61b811]{width:100%;font-size:.8rem}.status_unstart .vs[data-v-3b61b811]{font-size:1rem;margin-bottom:.9rem;padding-top:.8rem;text-align:center}.unstartTime[data-v-3b61b811]{height:1rem;line-height:1rem;overflow:hidden}.unstartLive[data-v-3b61b811]{width:2.4rem;height:.8rem;line-height:.8rem;display:inline-block;color:#16bc3a;font-size:.6rem;border:1px solid #16bc3a;border-radius:.02666667rem;float:left;margin:0 .2rem 0 .4rem;-webkit-transform:scale(.7);transform:scale(.7);position:relative;left:.7rem;top:.1rem}.unstartTime time[data-v-3b61b811]{float:left;font-size:.68rem}.tabWrap[data-v-3b61b811]{border-bottom:.1rem solid #eff1f4;width:100%;height:2.4rem;line-height:2.4rem;background:#fff}.tabWrap span[data-v-3b61b811]{width:33.3333%;display:inline-block;height:2.4rem;line-height:2.4rem;float:left;text-align:center;color:#606369;font-size:.9rem}.tabWrap span.selected[data-v-3b61b811]{border-bottom:.1rem solid #16bc3a;color:#16bc3a;position:relative}.contentWrap[data-v-3b61b811]{position:relative;top:12.2rem;font-size:12px}.contentWrap iframe[data-v-3b61b811]{border:none}.ml15[data-v-3b61b811]{margin-left:.8rem}.operamini-tips[data-v-3b61b811]{background:#ff0;text-align:center;font-weight:700}.w-full[data-v-3b61b811]{width:100%}.bannerInformWrap[data-v-3b61b811]{-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;height:7.4rem;overflow:hidden;background:url(" + escape(__webpack_require__(639)) + ") no-repeat;background-size:cover}.bannerInformWrap .banner-left[data-v-3b61b811],.bannerInformWrap .banner-right[data-v-3b61b811],.bannerInformWrap[data-v-3b61b811]{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bannerInformWrap .banner-left[data-v-3b61b811],.bannerInformWrap .banner-right[data-v-3b61b811]{width:30%;-ms-flex-negative:0;flex-shrink:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-top:1.375rem;text-align:center;font-size:.7rem;color:#fff}.bannerInformWrap .banner-left .team-logo[data-v-3b61b811],.bannerInformWrap .banner-right .team-logo[data-v-3b61b811]{box-sizing:border-box;width:2.7rem;height:2.7rem;margin-bottom:1rem}.bannerInformWrap .banner-left .team-name[data-v-3b61b811],.bannerInformWrap .banner-right .team-name[data-v-3b61b811]{box-sizing:border-box;width:80%!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bannerInformWrap .bannerCenterWrap[data-v-3b61b811]{box-sizing:border-box;width:40%;-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:1rem 0;font-size:.68rem;color:#fff}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/pages/AppMatchDetail.vue"],"names":[],"mappings":"AACA,6BACE,cAAe,AACf,eAAkB,CACnB,AACD,+BACE,WAAY,AACZ,eAAgB,AAChB,MAAO,AACP,WAAa,CACd,AACD,gCACE,eAAgB,AAChB,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,2BACE,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,kBAAoB,CACrB,AACD,6BACE,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,eAAiB,CAClB,AACD,kCACE,eAAgB,AAChB,qBAAsB,AACtB,cAAe,AACf,mBAAoB,AACpB,iCAAoC,CACrC,AACD,+CACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,qBAAsB,AACtB,8BAAqC,AACrC,eAAgB,AAChB,WAAY,AACZ,oBAAqB,AACrB,kBAAmB,AACnB,gBAAkB,CACnB,AACD,0BACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,qBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,8BACE,oBAAsB,AACtB,kBAAmB,AACnB,mBAAoB,AACpB,uBAAwB,AACxB,eAAiB,CAClB,AACD,uBACE,gBAAkB,AAClB,WAAY,AACZ,iBAAmB,CACpB,AACD,4BACE,kBAAoB,CACrB,AACD,iDACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,qBAAsB,AACtB,8BAAqC,AACrC,eAAgB,AAChB,WAAY,AACZ,oBAAsB,AACtB,cAAe,AACf,kBAAoB,CACrB,AACD,0CACE,kBAAoB,CACrB,AACD,uCACE,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,2BAA6B,AAC7B,cAAe,AACf,WAAY,AACZ,iBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB,AACD,6BACE,2BAA8B,AAC9B,YAAc,AACd,aAAe,AACf,UAAY,CACb,AACD,yBACE,cAAe,AACf,eAAkB,CACnB,AACD,iCACE,WAAY,AACZ,eAAkB,CACnB,AACD,qCACE,eAAgB,AAChB,oBAAqB,AACrB,kBAAoB,AACpB,iBAAmB,CACpB,AACD,8BACE,YAAa,AACb,iBAAkB,AAClB,eAAiB,CAClB,AACD,8BACE,aAAc,AACd,aAAe,AACf,kBAAoB,AACpB,qBAAsB,AACtB,cAAe,AACf,gBAAkB,AAClB,yBAA0B,AAC1B,2BAA6B,AAC7B,WAAY,AACZ,uBAA0B,AAC1B,4BAA8B,AACtB,oBAAsB,AAC9B,kBAAmB,AACnB,WAAa,AACb,SAAY,CACb,AACD,mCACE,WAAY,AACZ,gBAAmB,CACpB,AACD,0BACE,kCAAmC,AACnC,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,eAAiB,CAClB,AACD,+BACE,eAAgB,AAChB,qBAAsB,AACtB,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,kBAAmB,AACnB,cAAe,AACf,eAAiB,CAClB,AACD,wCACE,kCAAmC,AACnC,cAAe,AACf,iBAAmB,CACpB,AACD,8BACE,kBAAmB,AACnB,YAAa,AACb,cAAgB,CACjB,AACD,qCACE,WAAa,CACd,AACD,uBACE,iBAAoB,CACrB,AACD,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB,AAED,yBACE,UAAY,CACb,AACD,mCAQE,qBAAsB,AAClB,iBAAkB,AACtB,WAAY,AACZ,cAAe,AACf,gBAAiB,AACjB,mDAAkE,AAClE,qBAAuB,CACxB,AACD,oIAfE,sBAAuB,AACvB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAgC7B,AAvBD,iGAGE,UAAW,AACX,oBAAqB,AACjB,cAAe,AAInB,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAIhC,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACb,AACD,uHAEE,sBAAuB,AACvB,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,uHAEE,sBAAuB,AACvB,oBAAsB,AACtB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,qDACE,sBAAuB,AACvB,UAAW,AACX,oBAAqB,AACjB,cAAe,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACb","file":"AppMatchDetail.vue","sourcesContent":["\n.text-green[data-v-3b61b811] {\n  color: #16b13a;\n  font-size: 0.8rem;\n}\n.topFixedWrap[data-v-3b61b811] {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  z-index: 999;\n}\n.tab-box-fixed[data-v-3b61b811] {\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-3b61b811] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.navBread[data-v-3b61b811] {\n  width: 100%;\n  height: 2.4rem;\n  background: #16b13a;\n  color: #fff;\n  line-height: 2.4rem;\n}\n.navBread a[data-v-3b61b811] {\n  padding: 0 1rem;\n  text-decoration: none;\n  color: #fff;\n  font-size: .8rem;\n}\n.navBread .match[data-v-3b61b811] {\n  font-size: 1rem;\n  display: inline-block;\n  height: 1.2rem;\n  line-height: 1.2rem;\n  border-right: 0.05rem solid #119730;\n}\n.status_ended .scorewrap span[data-v-3b61b811] {\n  width: 2.1rem;\n  height: 2.1rem;\n  overflow: hidden;\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 2rem;\n  float: left;\n  border-radius: .1rem;\n  text-align: center;\n  line-height: 2rem;\n}\n.rowLine[data-v-3b61b811] {\n  float: left;\n  width: .7rem;\n  height: .2rem;\n  display: inline-block;\n  background: #fff;\n  overflow: hidden;\n  margin: 1rem 1rem 0;\n}\n.competename[data-v-3b61b811] {\n  margin-bottom: 0.6rem;\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.time[data-v-3b61b811] {\n  font-size: 0.7rem;\n  color: #fff;\n  text-align: center;\n}\n.scorewrap[data-v-3b61b811] {\n  margin-bottom: 1rem;\n}\n.status_playing .scorewrap span[data-v-3b61b811] {\n  width: 2.2rem;\n  height: 2.2rem;\n  overflow: hidden;\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 2rem;\n  float: left;\n  border-radius: 0.2rem;\n  color: #16b13a;\n  line-height: 2.2rem;\n}\n.status_playing .rowLine[data-v-3b61b811] {\n  background: #16b13a;\n}\n.status_playing .live[data-v-3b61b811] {\n  width: 6rem;\n  height: 1rem;\n  background: #16bc3a;\n  border-radius: 0.02666667rem;\n  display: block;\n  color: #fff;\n  font-size: 0.68rem;\n  line-height: 1rem;\n  margin: 0 auto;\n}\n.play_arrow[data-v-3b61b811] {\n  margin: 0.25rem 0.4rem 0 1rem;\n  width: 0.3rem;\n  height: 0.4rem;\n  float: left;\n}\n.unlive[data-v-3b61b811] {\n  color: #16b13a;\n  font-size: 0.8rem;\n}\n.status_unstart[data-v-3b61b811] {\n  width: 100%;\n  font-size: 0.8rem;\n}\n.status_unstart .vs[data-v-3b61b811] {\n  font-size: 1rem;\n  margin-bottom: .9rem;\n  padding-top: 0.8rem;\n  text-align: center;\n}\n.unstartTime[data-v-3b61b811] {\n  height: 1rem;\n  line-height: 1rem;\n  overflow: hidden;\n}\n.unstartLive[data-v-3b61b811] {\n  width: 2.4rem;\n  height: 0.8rem;\n  line-height: 0.8rem;\n  display: inline-block;\n  color: #16bc3a;\n  font-size: 0.6rem;\n  border: 1px solid #16bc3a;\n  border-radius: 0.02666667rem;\n  float: left;\n  margin: 0 0.2rem 0 0.4rem;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n  position: relative;\n  left: 0.7rem;\n  top: 0.1rem;\n}\n.unstartTime time[data-v-3b61b811] {\n  float: left;\n  font-size: 0.68rem;\n}\n.tabWrap[data-v-3b61b811] {\n  border-bottom: .1rem solid #eff1f4;\n  width: 100%;\n  height: 2.4rem;\n  line-height: 2.4rem;\n  background: #fff;\n}\n.tabWrap span[data-v-3b61b811] {\n  width: 33.3333%;\n  display: inline-block;\n  height: 2.4rem;\n  line-height: 2.4rem;\n  float: left;\n  text-align: center;\n  color: #606369;\n  font-size: .9rem;\n}\n.tabWrap span.selected[data-v-3b61b811] {\n  border-bottom: .1rem solid #16bc3a;\n  color: #16bc3a;\n  position: relative;\n}\n.contentWrap[data-v-3b61b811] {\n  position: relative;\n  top: 12.2rem;\n  font-size: 12px;\n}\n.contentWrap iframe[data-v-3b61b811] {\n  border: none;\n}\n.ml15[data-v-3b61b811] {\n  margin-left: 0.8rem;\n}\n.operamini-tips[data-v-3b61b811] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n/* 详情banner */\n.w-full[data-v-3b61b811] {\n  width: 100%;\n}\n.bannerInformWrap[data-v-3b61b811] {\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  width: 100%;\n  height: 7.4rem;\n  overflow: hidden;\n  background: url(../assets/match/videoMatchBannerBg.jpg) no-repeat;\n  background-size: cover;\n}\n.bannerInformWrap .banner-left[data-v-3b61b811],\n.bannerInformWrap .banner-right[data-v-3b61b811] {\n  box-sizing: border-box;\n  width: 30%;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-top: 1.375rem;\n  text-align: center;\n  font-size: .7rem;\n  color: #fff;\n}\n.bannerInformWrap .banner-left .team-logo[data-v-3b61b811],\n.bannerInformWrap .banner-right .team-logo[data-v-3b61b811] {\n  box-sizing: border-box;\n  width: 2.7rem;\n  height: 2.7rem;\n  margin-bottom: 1rem;\n}\n.bannerInformWrap .banner-left .team-name[data-v-3b61b811],\n.bannerInformWrap .banner-right .team-name[data-v-3b61b811] {\n  box-sizing: border-box;\n  width: 80% !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.bannerInformWrap .bannerCenterWrap[data-v-3b61b811] {\n  box-sizing: border-box;\n  width: 40%;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 1rem 0;\n  font-size: .68rem;\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/videoMatchBannerBg.42eb49b.jpg";

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(591);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(85);

var _promise2 = _interopRequireDefault(_promise);

var _matchDetail = __webpack_require__(641);

var _matchDetail2 = _interopRequireDefault(_matchDetail);

var _components = __webpack_require__(642);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'matchDetail',
    components: {
        downloadPopup: _components.downloadPopup, matchOverview: _components.matchOverview, matchAnalysis: _components.matchAnalysis, matchLive: _components.matchLive, AppMatchTag: _components.AppMatchTag
    },
    data: function data() {
        return {
            toggleSelect: '',
            subtitleName: '',
            competeId: null,
            idUrl: '',
            idData: {},
            idMatchAnalysisUrl: '',
            idMatchOddsUrl: '',
            idMatchOverViewUrl: '',
            competeStatus: '',
            local_month_day: '',
            local_hour_minite: '',
            currentIframeSrc: '',
            isOperamini: false,
            contentHeight: 'auto',
            matchTagFormation: {}
        };
    },
    asyncData: function asyncData(_ref) {
        var store = _ref.store,
            _ref$route$params = _ref.route.params,
            id = _ref$route$params.id,
            language = _ref$route$params.language;

        var locale = language && language.split('-')[0] || 'id';
        if (id) {
            return _promise2.default.all([store.dispatch('FETCH_MATCH_DETAIL_FORMATION', { matchId: id }), store.dispatch('FETCH_MATCH_OVERVIEW_FORMATION', { matchId: id, locale: locale }), store.dispatch('FETCH_MATCH_ANALYSIS_FORMATION', { matchId: id, locale: locale, isJSON: true }), store.dispatch('FETCH_MATCH_ODDS_EURO', { matchId: id }), store.dispatch('FETCH_MATCH_ODDS_ASIA', { matchId: id }), store.dispatch('FETCH_MATCH_ODDS_OVER_UNDER', { matchId: id }), store.dispatch('FETCH_MATCH_LIVE_DATA', { matchId: id })]);
        } else {
            return _promise2.default.reject('id不存在');
        }
    },
    head: function head() {
        return {
            title: this.idData.team_A_name + ' VS ' + this.idData.team_B_name + ' | ' + this.idData.competition_name + ' | ' + this.idData.date_utc + ' | All Sepakbola',
            meta: [{
                name: 'description',
                content: 'The live score, overview, lineup, events, technical statistics, match analysis of ' + this.idData.competition_name + ' ' + this.idData.team_A_name + ' vs ' + this.idData.team_B_name + ' at ' + this.idData.date_utc
            }, {
                name: 'keywords',
                content: this.idData.competition_name + ', ' + this.idData.team_A_name + ', ' + this.idData.team_B_name
            }]
        };
    },


    computed: {
        matchDetailFormation: function matchDetailFormation() {
            return this.$store.state.matchDetailStore.matchDetailFormation;
        }
    },

    created: function created() {
        var _this = this;

        this.competeId = this.$route.params.id;
        this.subtitleName = this.$route.params.subtitle;

        (0, _keys2.default)(_matchDetail2.default).map(function (locale) {
            return _this.$i18n.setLocaleMessage(locale, _matchDetail2.default[locale]);
        });

        this.idData = this.matchDetailFormation.matchSample || {};
        this.idMatchAnalysisUrl = this.matchDetailFormation.matchAnalysis.url || '';
        this.idMatchOddsUrl = this.matchDetailFormation.matchOdds.url || '';
        this.idMatchOverViewUrl = this.matchDetailFormation.matchSK.url || '';
        this.competeStatus = this.idData.status || '';

        var utcTime = this.idData.start_play || '';
        this.local_month_day = this.formatData(utcTime).local_Month_Day || '';
        this.local_hour_minite = this.formatData(utcTime).local_hms || '';

        if (this.competeStatus === 'Played' || this.competeStatus === 'Playing') {
            this.currentIframeSrc = this.idMatchOverViewUrl;
        } else if (this.competeStatus === 'Fixture') {
            this.currentIframeSrc = this.idMatchAnalysisUrl + '?m_station';
        }
    },
    updated: function updated() {
        var utilObj = __webpack_require__(499);
        utilObj.lazyload('teamWrap', 'team-logo');
    },
    mounted: function mounted() {
        var utilObj = __webpack_require__(499);
        document.body.scrollTop = 0;
        this.isOperamini = utilObj.checkOperamini();
        utilObj.timeForInOut();

        var clientHight = document.querySelector('#topFixed').clientHeight;
        this.contentHeight = 'calc(100vh - ' + clientHight + 'px)';

        this.matchTagFormation = JSON.parse(localStorage.getItem("match_tag"));

        this.getCurrentActiveTab();
    },


    methods: {
        getCurrentActiveTab: function getCurrentActiveTab() {
            var isLiveTab = this.matchTagFormation && this.matchTagFormation.type === '1';
            var isIkhtisarTab = this.competeStatus === 'Played' || this.competeStatus === 'Playing';

            if (isLiveTab) {
                this.toggleSelect = 'Live';
                return;
            }
            if (isIkhtisarTab) {
                this.toggleSelect = 'Ikhtisar';
                return;
            }
            this.toggleSelect = 'Analisis';
        },
        tran12: function tran12(time) {
            var timeArr = time.split(':');
            var result = '';
            if (timeArr[0] > 12) {
                result = timeArr[0] - 12 + ':' + timeArr[1] + ' FM';
            } else {
                result = timeArr[0] + ':' + timeArr[1] + ' AM';
            }
            return result;
        },
        toggle: function toggle(toggleName) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.toggleSelect = toggleName;
        },
        formatData: function formatData(gmtDate) {
            var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
            var diffMin = new Date().getTimezoneOffset();
            var localDate = new Date(date - diffMin * 60 * 1000);
            var localMonth = localDate.getMonth() + 1;
            if (localMonth < 10) {
                localMonth = '0' + localMonth;
            }
            var localTimeDetail = ('' + localDate).split(' ');
            var localMonthDay = localMonth + '-' + localTimeDetail[2];
            return {
                local_Month_Day: localMonthDay,
                local_hms: localTimeDetail[4].slice(0, 5)
            };
        }
    }
};

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    'es': {
        'events': 'Eventos',
        'goal': 'Gol',
        'penalty': 'Penalti',
        'penaltySaved': 'Penalti rechazado',
        'ownGoal': 'Gol en propia puerta',
        'assist': 'Asistencia',
        'statistics': 'Estadística',
        'noData': 'Sin datos',
        'notPrepared': 'Partido no se inicia',

        'prediction': 'Apoya a tu equipo',
        'vote': 'Votar',
        'voted': 'Votado',
        'home': 'Casa',
        'draw': 'Empate',
        'away': 'Fuera',
        'voteNum': '(1 voto) | ({count} votos)',
        'voteFail': 'El voto falló, reintenta ~',
        'matchVoted': 'Ya has votado ~',
        'matchNotStart': 'La partida no comienza',
        'predictionEnd': 'La predicción es final, recuerda predecir antes del partido',
        'broadcast': 'Información de transmisión',
        'statistic': 'Estadísticas de Jugador',
        'past_games': 'Partidos Pasados',
        'pg_no': 'No partidos pasados',
        'pg_lng': 'Últimos Partidos',
        'pg_w': '{count} PG',
        'pg_d': '{count} PE',
        'pg_date': 'Fecha',
        'pg_competition': 'Competición',
        'pg_home': 'Casa',
        'pg_result': 'Resultado',
        'pg_away': 'Fuera',
        'absentee': 'Ausente',
        'absentee_no': 'No hay ausente',
        'recent_games': 'Partidos Recientes',
        'rg_no': 'No hay partidos recientes',
        'rg_date': 'Fecha',
        'rg_competition': 'Competición',
        'rg_home': 'Casa',
        'rg_result': 'Resultado',
        'rg_away': 'Fuera',
        'league_table': 'Tabla de la liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Casa',
        'lt_away': 'Fuera',
        'lt_p': 'PJ',
        'lt_w': 'PG',
        'lt_d': 'PE',
        'lt_l': 'PP',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'PT',
        'lt_rank': 'Rango',
        'lt_wp': 'Porcentaje de victorias',
        'ct_team': 'Equipo',
        'ct_p': 'PJ',
        'ct_w': 'PG',
        'ct_d': 'PE',
        'ct_l': 'PP',
        'ct_fa': '+/-',
        'ct_pts': 'PT',
        'odds': 'Cuotas',
        'odds_no': 'No hay cuotas',
        'odds_no_data': 'Sin datos',
        'odds_handicap': 'Desventaja',
        'odds_ou': 'Más/Menos',
        'odds_1x2': '1x2',
        'odds_over': 'Más',
        'odds_under': 'Menos',
        'odds_total': 'Total',
        'odds_more': ' Más',
        'odds_company': 'Empresa',
        'odds_type': 'Tipo',
        'odds_spot': 'Lugar',
        'odds_initial': 'Inicial',
        'odds_home_win': 'Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Fuera',
        'odds_tu': 'Actualización',
        'odds_home_lose': 'Casa',
        'odds_draw': 'Empate',
        'odds_away_win': 'Fuera',
        'odds_highest': 'Máximo',
        'odds_lowest': 'Mínimo',
        'odds_average': 'Promedio',
        'odds_changes': 'La probabilidad cambia',
        'odds_dc': 'El detalle cambia',
        'Decimal': 'Decimal',
        'American': 'Americano',
        'Fractional': 'Fraccional',
        'more': 'Más'
    },
    'pt': {
        'events': 'Eventos',
        'goal': 'Gol',
        'penalty': 'Pênalti',
        'penaltySaved': 'Pênalti Defendido',
        'ownGoal': 'Gol Contra',
        'assist': 'Assistência',
        'statistics': 'Estatística  ',
        'noData': 'Não há dados',
        'notPrepared': 'O jogo não começa',

        'prediction': 'Previsões para a partida',
        'vote': 'Voto',
        'voted': 'Votado',
        'home': 'Em Casa',
        'draw': 'Empate',
        'away': 'Fora',
        'voteNum': '(1 voto) | ({count} votos)',
        'voteFail': 'Falha ao enviar o voto. Por favor, tente novamente~',
        'matchVoted': 'Você já votou ~',
        'matchNotStart': 'O jogo não começa',
        'predictionEnd': 'O prazo para as previsões terminou. Lembre-se de enviar suas previsões antes do início da partida.',
        'statistic': 'Estatisticas',
        'past_games': 'Jogos passados',
        'pg_no': 'Nenhum Jogo Passado',
        'pg_lng': 'Últimos{count} Jogos',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Data',
        'pg_competition': 'Competição',
        'pg_home': 'Em Casa',
        'pg_result': 'Resultado',
        'pg_away': 'Fora',
        'absentee': 'Ausência',
        'absentee_no': 'Nenhuma ausência',
        'recent_games': 'Jogos Recentes',
        'rg_no': 'Nenhum Jogo Recente',
        'rg_date': 'Data',
        'rg_competition': 'Competição',
        'rg_home': 'Em Casa',
        'rg_result': 'Resultado',
        'rg_away': 'Fora',
        'league_table': 'Tabela da Liga',
        'lt_format': 'Formato',
        'lt_total': 'Total',
        'lt_home': 'Em Casa',
        'lt_away': 'Fora',
        'lt_p': 'J',
        'lt_w': 'V',
        'lt_d': 'E',
        'lt_l': 'D',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Ranking',
        'lt_wp': 'WP',
        'ct_team': 'Time',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Probabilidade',
        'odds_no': 'Nenhuma Probabilidade',
        'odds_no_data': 'Nenhum Dado',
        'odds_handicap': 'Lesões',
        'odds_ou': 'Acima/Sub',
        'odds_1x2': '1x2',
        'odds_over': 'Acima  ',
        'odds_under': 'Sub',
        'odds_total': 'Total',
        'odds_more': 'Mais',
        'odds_company': 'Empresa',
        'odds_type': 'Tip',
        'odds_spot': 'Ponto',
        'odds_initial': 'Inicial',
        'odds_home_win': 'Em Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Fora',
        'odds_tu': 'Tempo Atualizado',
        'odds_home_lose': 'Em Casa',
        'odds_draw': 'Empate',
        'odds_away_win': 'Fora',
        'odds_highest': 'Mais alto',
        'odds_lowest': 'Mais baixo',
        'odds_average': 'Média',
        'odds_changes': 'Alterações nas Probabilidades',
        'odds_dc': 'Alterações nos Detalhes',
        'more': 'mais',
        'broadcast': 'Informações da Transmissão',
        'Decimal': 'Decimal',
        'American': 'Americano',
        'Fractional': 'Fracional',
        'matchPredictionTip': 'Dicas para a Partida',
        'matchPredictionResult': 'Previsões de resultados pelas Dicas para a Partida',
        'matchPredictionView': 'Visualizar'
    },
    'it': {
        'events': 'Eventi',
        'goal': 'Gol',
        'penalty': 'Rigore',
        'penaltySaved': 'Rigore Salvato',
        'ownGoal': 'Autogol',
        'assist': 'Assistenze',
        'statistics': 'Statistica',
        'noData': 'Nessun Dato',
        'notPrepared': 'Partita non cominciata',

        'prediction': 'Sostieni Tua Squadra',
        'vote': 'Voti',
        'voted': 'Votato',
        'home': 'Casa',
        'draw': 'Pareggio',
        'away': 'Via',
        'voteNum': '(1 voto) | ({conteggio} voti)',
        'voteFail': 'Voto fallito, per favore provi~',
        'matchVoted': 'Hai già votato~',
        'matchNotStart': 'Partita non cominciata',
        'predictionEnd': 'Previsione è finita, ricordi di prevedere prima della partita',
        'statistic': 'Statistiche',
        'past_games': 'Partite Passate',
        'pg_no': 'Nessuna Partita Passata',
        'pg_lng': 'Ultimi {conteggio} Giochi',
        'pg_w': '{conteggio} W',
        'pg_d': '{conteggio} D',
        'pg_date': 'Dati',
        'pg_competition': 'Concorso',
        'pg_home': 'Casa',
        'pg_result': 'Risultato',
        'pg_away': 'Via',
        'absentee': 'Assente',
        'absentee_no': 'Nessun assente',
        'recent_games': 'Recenti Partite',
        'rg_no': 'Nessun Recente Partita',
        'rg_date': 'Data',
        'rg_competition': 'Concorso',
        'rg_home': 'Casa',
        'rg_result': 'Risultato',
        'rg_away': 'Via',
        'league_table': 'Classica a punti',
        'lt_format': 'Formato',
        'lt_total': 'Totale',
        'lt_home': 'Casa',
        'lt_away': 'Trasferta',
        'lt_p': 'G',
        'lt_w': 'V',
        'lt_d': 'N',
        'lt_l': 'P',
        'lt_f': '+',
        'lt_a': 'S',
        'lt_pts': 'Pt',
        'lt_rank': 'Classifica',
        'lt_wp': 'VP',
        'ct_team': 'Squadra',
        'ct_p': 'G',
        'ct_w': 'V',
        'ct_d': 'N',
        'ct_l': 'P',
        'ct_fa': 'F/S',
        'ct_pts': 'Pt',
        'odds': 'Probabilità',
        'odds_no': 'Nessuna Probabilità',
        'odds_no_data': 'Nessun Dato',
        'odds_handicap': 'Disabile',
        'odds_ou': 'Sopra/Sotto',
        'odds_1x2': '1x2',
        'odds_over': 'Fine',
        'odds_under': 'Sopra',
        'odds_total': 'Sotto',
        'odds_more': 'Più',
        'odds_company': 'Società',
        'odds_type': 'Tipo',
        'odds_spot': 'Punto',
        'odds_initial': 'Iniziale',
        'odds_home_win': 'Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Via',
        'odds_tu': 'Tempo aggiornato',
        'odds_home_lose': 'Casa',
        'odds_draw': 'Pareggio',
        'odds_away_win': 'Via',
        'odds_highest': 'Altissimo',
        'odds_lowest': 'Bassissimo',
        'odds_average': 'Media',
        'odds_changes': 'Cambiamenti Probabilità',
        'odds_dc': 'Cambiamenti Dettagli',
        'more': 'più',
        'broadcast': 'Info di trasmissione',
        'Decimal': 'Decimale',
        'American': 'Americano',
        'Fractional': 'Frazionale',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Risultati previsti da Match Tips',
        'matchPredictionView': 'Vista'
    },
    'fr': {
        'events': 'Événements',
        'goal': 'Objectif',
        'penalty': 'Pénalité',
        'penaltySaved': 'Pénalité enregistrée',
        'ownGoal': ' Objectif propre',
        'assist': 'Assistez',
        'statistics': 'Statistique',
        'noData': 'Pas de données',
        'notPrepared': 'Le match ne commence pas',

        'prediction': 'Soutenez votre équipe',
        'vote': 'Vote',
        'voted': 'Voté',
        'home': 'Domicile',
        'draw': 'Dessiner',
        'away': ' Invitée',
        'voteNum': '(1 vote) | ({count} votes)',
        'voteFail': 'Vote échoué, bien vouloir réessayer ~',
        'matchVoted': 'Vous avez déjà voté ~',
        'matchNotStart': 'Le match ne commence pas',
        'predictionEnd': 'La prédiction c\'est la fin, ne pas oublier de prédire avant le match',
        'statistic': 'Statistiques',
        'past_games': 'Jeux précédents',
        'pg_no': 'Aucun jeu précédent',
        'pg_lng': 'Derniers {count} Jeux',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Date',
        'pg_competition': 'Compétition',
        'pg_home': 'Domicile',
        'pg_result': 'Résultat',
        'pg_away': 'Invitée',
        'absentee': 'Absent',
        'absentee_no': 'Pas d\'absent',
        'recent_games': 'Jeux récents',
        'rg_no': 'Pas de jeux récents',
        'rg_date': 'Date',
        'rg_competition': 'Compétition',
        'rg_home': 'Domicile',
        'rg_result': 'Résultat',
        'rg_away': 'Invitée',
        'league_table': 'Table ligue',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Domicile',
        'lt_away': 'Invitée',
        'lt_p': 'J',
        'lt_w': 'G',
        'lt_d': 'N',
        'lt_l': 'P',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Rang',
        'lt_wp': 'WP',
        'ct_team': 'Équipe',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Chances',
        'odds_no': 'Aucune chance',
        'odds_no_data': 'Pas de données',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Au dessus de/En dessous de',
        'odds_1x2': '1x2',
        'odds_over': 'Au dessus de',
        'odds_under': 'En dessous de',
        'odds_total': 'Total',
        'odds_more': 'Plus',
        'odds_company': 'Compagnie',
        'odds_type': 'Type',
        'odds_spot': 'Place',
        'odds_initial': 'Initial',
        'odds_home_win': 'Domicile',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Invitée',
        'odds_tu': 'Heure mise à jour',
        'odds_home_lose': 'Domicile',
        'odds_draw': 'Dessiner',
        'odds_away_win': 'Invitée',
        'odds_highest': 'Le plus élevé',
        'odds_lowest': 'Le plus bas',
        'odds_average': 'Moyenne',
        'odds_changes': 'Modifications de cotes',
        'odds_dc': 'Modifications de détail',
        'more': 'plus',
        'broadcast': 'Infos diffusion',
        'Decimal': 'Décimal',
        'American': 'Américain',
        'Fractional': 'Fractionnaire',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Résultats prévus par Match Tips',
        'matchPredictionView': 'Vue'
    },
    'ru': {
        'events': 'Мероприятия',
        'goal': 'Цель',
        'penalty': 'Пенальти',
        'penaltySaved': 'Отбитый Пенальти',
        'ownGoal': 'Автогол',
        'assist': 'голевые передачи',
        'statistics': 'Статистика',
        'noData': 'Нет данных',
        'notPrepared': 'Матч не начат',

        'prediction': 'Поддержите вашу команду',
        'vote': 'Голосовать',
        'voted': 'проголосовавший',
        'home': 'Домашний',
        'draw': 'рисовать',
        'away': 'потерять',
        'voteNum': '(1 голос) | ({count} голосов)',
        'voteFail': 'Проголосовать не удалось, повторите попытку ~',
        'matchVoted': 'Вы уже голосовали ~',
        'matchNotStart': 'Матч не начат',
        'predictionEnd': 'Прогнозирование окончено, не забудьте предсказать перед матчем',
        'statistic': 'Статистика',
        'past_games': 'Прошедшие игры',
        'pg_no': 'Нет прошлых игр',
        'pg_lng': 'Последние {count} игры',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Дата',
        'pg_competition': 'Соревнование',
        'pg_home': 'Домашний',
        'pg_result': 'результат',
        'pg_away': 'потерять',
        'absentee': 'отсутствующий',
        'absentee_no': 'Нет отсутствующих',
        'recent_games': 'Недавние игры',
        'rg_no': 'Нет недавних игр',
        'rg_date': 'Дата',
        'rg_competition': 'Соревнование',
        'rg_home': 'Домашний',
        'rg_result': 'Результат',
        'rg_away': 'потерять',
        'league_table': 'Таблица Лиги',
        'lt_format': 'Формат',
        'lt_total': 'Всего',
        'lt_home': 'Домашний',
        'lt_away': 'потерять',
        'lt_p': 'И',
        'lt_w': 'В',
        'lt_d': 'Н',
        'lt_l': 'П',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Очки',
        'lt_rank': 'Разряд',
        'lt_wp': 'WP',
        'ct_team': 'Команда',
        'ct_p': 'И',
        'ct_w': 'В',
        'ct_d': 'Н',
        'ct_l': 'П',
        'ct_fa': 'F/A',
        'ct_pts': 'ОЧКИ',
        'odds': 'Вероятность выигрыша',
        'odds_no': 'Нет вероятности выигрыша',
        'odds_no_data': 'Нет данных',
        'odds_handicap': 'Фора',
        'odds_ou': 'Больше / Меньше',
        'odds_1x2': '1х2',
        'odds_over': 'Больше',
        'odds_under': 'Меньше',
        'odds_total': 'Всего',
        'odds_more': 'Еще',
        'odds_company': 'Компания',
        'odds_type': 'Тип',
        'odds_spot': 'Одиннадцатиметровая отметка',
        'odds_initial': 'Начальный',
        'odds_home_win': 'Домашний',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'потерять',
        'odds_tu': 'Время обновлено',
        'odds_home_lose': 'Домашний',
        'odds_draw': 'постановочный бросок',
        'odds_away_win': 'потерять',
        'odds_highest': 'Наибольший',
        'odds_lowest': 'Низший',
        'odds_average': 'Средний',
        'odds_changes': 'Изменения вероятности выигрыша',
        'odds_dc': 'Изменения Деталей',
        'more': 'еще',
        'broadcast': 'Информация о трансляции',
        'Decimal': 'Десятичная дробь',
        'American': 'Американский',
        'Fractional': 'Дробный',
        'matchPredictionTip': 'Советы по игре',
        'matchPredictionResult': 'Прогнозируемые результаты от Советов по игре',
        'matchPredictionView': 'Посмотреть'
    },
    'tr': {
        'prediction': 'Maç Tahmini',
        'vote': 'Oy',
        'voted': 'oy',
        'home': 'birincil',
        'draw': 'çizmek',
        'away': 'yolcu',
        'voteNum': '(1 oy) | ({count} oy)',
        'voteFail': 'Oy veremedi, lütfen tekrar deneyin ~',
        'matchVoted': 'Zaten oy kullandın ~',
        'matchNotStart': 'Maç başlamıyor',
        'predictionEnd': 'Tahmin son, maçtan önce tahmin etmeyi unutmayın'
    },
    'in': {
        'prediction': 'Prediksi Pertandingani',
        'vote': 'Memilih',
        'voted': 'Terpilih',
        'home': 'Tuhan',
        'draw': 'Draw',
        'away': 'Tamu',
        'voteNum': '(1 suara) | ({count} suara)',
        'voteFail': 'Vote gagal, mohon dicoba ~',
        'matchVoted': 'Kamu sudah memilih ~',
        'matchNotStart': 'Pertandingan tidak dimulai',
        'predictionEnd': 'Prediksi sudah berakhir, ingatlah untuk memprediksi sebelum pertandingan',
        'statistic': 'Statistik',
        'past_games': 'Pertandingan Terakhir',
        'pg_no': 'Tidak Ada Pertandingan Terakhir',
        'pg_lng': 'Pertandingan {count} Terakhir',
        'pg_w': 'M',
        'pg_d': 'H',
        'pg_date': 'Tanggal',
        'pg_competition': 'Persaingan',
        'pg_home': 'Kandang',
        'pg_result': 'Hasil',
        'pg_away': 'Tandang',
        'absentee': 'Pemain yang Tidak Hadir',
        'absentee_no': 'No Pemain yang Tidak Hadir',
        'recent_games': 'Pertandingan Terkini',
        'rg_no': 'Tidak Ada Pertandingan Terkini',
        'rg_date': 'Tanggal',
        'rg_competition': 'Persaingan',
        'rg_home': 'Kandang',
        'rg_result': 'Hasil',
        'rg_away': 'Tandang',
        'league_table': 'Klasemen Liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Kandang',
        'lt_away': 'Tandang',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Poin',
        'lt_rank': 'Peringkat',
        'lt_wp': 'WP',
        'ct_team': 'Tim',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Poin',
        'odds': 'Odd',
        'odds_no': 'Tidak Ada Odd',
        'odds_no_data': 'Tidak Ada Data',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Atas/Bawah',
        'odds_1x2': '1x2',
        'odds_over': 'Atas',
        'odds_under': 'Bawah',
        'odds_total': 'Total',
        'odds_more': 'Lebih Lanjut',
        'odds_company': 'Perusahaan',
        'odds_type': 'Jenis',
        'odds_spot': 'Titik',
        'odds_initial': 'Awal',
        'odds_home_win': 'Kandang',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Tandang',
        'odds_tu': 'Waktu yang Diperbarui',
        'odds_home_lose': 'Kandang',
        'odds_draw': 'Penarikan',
        'odds_away_win': 'Tandang',
        'odds_highest': 'Tertinggi',
        'odds_lowest': 'Terendah',
        'odds_average': 'Rata-rata',
        'odds_changes': 'Perubahan Odd',
        'odds_dc': 'Perubahan Detail',
        'more': 'lebih lanjut'
    },
    'th': {
        'events': 'เหตุการณ์',
        'goal': 'ประตู',
        'penalty': 'ลูกโทษ',
        'penaltySaved': 'ลูกโทษที่ถูกป้องกัน',
        'ownGoal': 'การทำเข้าประตูตัวเอง',
        'assist': 'การจ่ายบอลแล้วเป็นประตู',
        'statistics': 'สถิติ',
        'noData': 'ไม่มีข้อมูล',
        'notPrepared': 'การแข่งขันยังไม่เริ่มต้น',

        'prediction': 'สนับสนุนทีมของคุณ',
        'vote': 'โหวต',
        'voted': 'โหวตแล้ว',
        'home': 'เจ้าบ้าน',
        'draw': 'เสมอ',
        'away': 'ทีมเยือน',
        'voteNum': '(1 โหวต) | ({count} โหวต)',
        'voteFail': 'การโหวตล้มเหลว โปรดลองอีกครั้ง ~',
        'matchVoted': 'คุณได้โหวตเรียบร้อยแล้ว ~',
        'matchNotStart': 'การแข่งขันยังไม่เริ่มต้น',
        'predictionEnd': 'การทำนายสิ้นสุดแล้ว อย่าลืมทำนายก่อนการแข่งขัน',
        'statistic': 'สถิติ',
        'broadcast': 'ข้อมูลการออกอากาศ',
        'past_games': 'เกมที่ผ่านมา',
        'pg_no': 'ไม่มีเกมที่ผ่านมา',
        'pg_lng': '{count} เกมล่าสุด',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'วันที่',
        'pg_competition': 'การแข่งขัน',
        'pg_home': 'เจ้าบ้าน',
        'pg_result': 'ผลการแข่งขัน',
        'pg_away': 'ทีมเยือน',
        'absentee': 'ผู้ที่ไม่มา',
        'absentee_no': 'ไม่มีผู้ที่ไม่มา',
        'recent_games': 'เกมล่าสุด',
        'rg_no': 'ไม่มีเกมล่าสุด',
        'rg_date': 'วันที่',
        'rg_competition': 'การแข่งขัน',
        'rg_home': 'เจ้าบ้าน',
        'rg_result': 'ผลการแข่งขัน',
        'rg_away': 'ทีมเยือน',
        'league_table': 'ตารางลีก',
        'lt_format': 'รูปแบบ',
        'lt_total': 'รวม',
        'lt_home': 'เจ้าบ้าน',
        'lt_away': 'ทีมเยือน',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'อันดับ',
        'lt_wp': 'WP',
        'ct_team': 'ทีม',
        'ct_p': 'แข่ง',
        'ct_w': 'ชนะ',
        'ct_d': 'เสมอ',
        'ct_l': 'แพ้',
        'ct_fa': 'F/A',
        'ct_pts': 'คะแนน',
        'odds': 'ราคาต่อรอง',
        'odds_no': 'ไม่มีราคาต่อรอง',
        'odds_no_data': 'ไม่มีข้อมูล',
        'odds_handicap': 'แฮนดิแคป',
        'odds_ou': 'สูง/ต่ำ',
        'odds_1x2': '1x2',
        'odds_over': 'สูง',
        'odds_under': 'ต่ำ',
        'odds_total': 'รวม',
        'odds_more': 'เพิ่มเติม',
        'odds_company': 'บริษัท',
        'odds_type': 'ชนิด',
        'odds_spot': 'จุด',
        'odds_initial': 'เริ่มต้น',
        'odds_home_win': 'เจ้าบ้าน',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'ทีมเยือน',
        'odds_tu': 'อัปเดตเวลาแล้ว',
        'odds_home_lose': 'เจ้าบ้าน',
        'odds_draw': 'เสมอ',
        'odds_away_win': 'ทีมเยือน',
        'odds_highest': 'สูงสุด',
        'odds_lowest': 'ต่ำสุด',
        'odds_average': 'ค่าเฉลี่ย',
        'odds_changes': 'การเปลี่ยนแปลงราคาต่อรอง',
        'odds_dc': 'การเปลี่ยนแปลงรายละเอียด',
        'Decimal': 'ทศนิยม',
        'American': 'อเมริกัน',
        'Fractional': 'เป็นเศษส่วน',
        'more': 'เพิ่มเติม',
        'matchPredictionTip': 'เทคนิคในการแข่งขัน (Match Tips)',
        'matchPredictionResult': 'ผลลัพธ์ที่คาดการณ์โดย เทคนิคในการแข่งขัน',
        'matchPredictionView': 'ดู'
    },
    'de': {
        'events': 'Veranstaltungen',
        'goal': 'Tor',
        'penalty': 'Elfmeter',
        'penaltySaved': 'Strafe gespeichert',
        'ownGoal': 'Eigentor',
        'assist': 'Helfen',
        'statistics': 'Statistik',
        'noData': 'Keine Daten',
        'notPrepared': 'Das Match beginnt nicht',

        'prediction': 'Unterstütze dein Team',
        'vote': 'Abstimmung',
        'voted': 'Abgestimmt',
        'home': 'Zuhause',
        'draw': 'Unentschieden',
        'away': 'Nicht anwesend',
        'voteNum': '(1 Stimme) | ({count} Stimmen)',
        'voteFail': 'Abstimmung fehlgeschlagen, bitte wiederholen ~',
        'matchVoted': 'Du hast bereits abgestimmt~',
        'matchNotStart': 'Das Match beginnt nicht',
        'predictionEnd': 'Vorhersage ist beendet, denke daran, vor dem Spiel vorherzusagen',
        'statistic': 'Statistiken',
        'broadcast': 'Info senden',
        'past_games': 'Vorherige Spiele',
        'pg_no': 'Keine vorherigen Spiele',
        'pg_lng': 'Letzte {count} Spiele',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Datum',
        'pg_competition': 'Wettbewerb',
        'pg_home': 'Zuhause',
        'pg_result': 'Ergebnis',
        'pg_away': 'Nicht anwesend',
        'absentee': 'Abwesenheit',
        'absentee_no': 'Kein Abwesender',
        'recent_games': 'Neueste Spiele',
        'rg_no': 'Keine neuesten Spiele',
        'rg_date': 'Datum',
        'rg_competition': 'Wettbewerb',
        'rg_home': 'Zuhause',
        'rg_result': 'Ergebnis',
        'rg_away': 'Nicht anwesend',
        'league_table': 'Ligatabelle',
        'lt_format': 'Format',
        'lt_total': 'Gesamt',
        'lt_home': 'Zuhause',
        'lt_away': 'Nicht anwesend',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pkte',
        'lt_rank': 'Rang',
        'lt_wp': 'WP',
        'ct_team': 'Mannschaft',
        'ct_p': 'Sp',
        'ct_w': 'G',
        'ct_d': 'U',
        'ct_l': 'V',
        'ct_fa': 'F/A',
        'ct_pts': 'Pkt',
        'odds': 'Chancen',
        'odds_no': 'Keine Chancen',
        'odds_no_data': 'Keine Daten',
        'odds_handicap': 'Behinderung',
        'odds_ou': 'Über/Unter',
        'odds_1x2': '1x2',
        'odds_over': 'Über',
        'odds_under': 'Unter',
        'odds_total': 'Gesamt',
        'odds_more': 'Mehr',
        'odds_company': 'Unternehmen',
        'odds_type': 'Art',
        'odds_spot': 'Stelle',
        'odds_initial': 'Start',
        'odds_home_win': 'Zuhause',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Nicht anwesend',
        'odds_tu': 'Zeit aktualisiert',
        'odds_home_lose': 'Zuhause',
        'odds_draw': 'Unentschieden',
        'odds_away_win': 'Nicht anwesend',
        'odds_highest': 'Höchste',
        'odds_lowest': 'Niedrigste',
        'odds_average': 'Durchschnittliche',
        'odds_changes': 'Quotenänderungen',
        'odds_dc': 'Detailänderungen',
        'Decimal': 'Dezimal',
        'American': 'Amerikanisch',
        'Fractional': 'Fraktional',
        'more': 'mehr',
        'matchPredictionTip': 'Spieltipps',
        'matchPredictionResult': 'Voraussichtliche Ergebnisse gemäss Spieltipps',
        'matchPredictionView': 'Aussicht'
    },
    'id': {
        'events': 'Acara',
        'goal': 'Gol',
        'penalty': 'Penalti',
        'penaltySaved': 'Penyelamatan Tendangan Penalti',
        'ownGoal': 'Gol Bunuh Diri',
        'assist': 'Umpan',
        'statistics': 'Statistik',
        'noData': 'Tidak Ada Data',
        'notPrepared': 'Pertandingan tidak dimulai',

        'prediction': 'Dukung Tim Anda',
        'vote': 'Memilih',
        'voted': 'Dipilih',
        'home': 'Kandang',
        'draw': 'Seri',
        'away': 'Tandang',
        'voteNum': '(1 suara) | ({count} suara)',
        'voteFail': 'Pemungutan suara gagal, coba lagi~',
        'matchVoted': 'Anda telah memilih~',
        'matchNotStart': 'Pertandingan tidak dimulai',
        'predictionEnd': 'Prediksi telah berakhir, ingatlah untuk memprediksi sebelum pertandingan',
        'statistic': 'Statistik',
        'broadcast': 'Info Siaran',
        'past_games': 'Permainan yang Lalu',
        'pg_no': 'Tidak ada Permainan yang Lalu',
        'pg_lng': 'Pertandingan {count} yang Terakhir',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Tanggal',
        'pg_competition': 'Kompetisi',
        'pg_home': 'Kandang',
        'pg_result': 'Hasil',
        'pg_away': 'Tandang',
        'absentee': 'Absen',
        'absentee_no': 'Tidak Absen',
        'recent_games': 'Game Terbaru',
        'rg_no': 'Tidak ada permainan terbaru',
        'rg_date': 'Tanggal',
        'rg_competition': 'Kompetisi',
        'rg_home': 'Kandang',
        'rg_result': 'Hasil',
        'rg_away': 'Tandang',
        'league_table': 'Tabel Liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Kandang',
        'lt_away': 'Tandang',
        'lt_p': 'P',
        'lt_w': 'M',
        'lt_d': 'S',
        'lt_l': 'K',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Peringkat',
        'lt_wp': 'WP',
        'ct_team': 'Tim',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Tolak ukur kekuatan tim',
        'odds_no': 'Tidak ada tolak ukur kekuatan tim',
        'odds_no_data': 'Tidak ada data',
        'odds_handicap': 'Keunggulan',
        'odds_ou': 'Atas/Bawah',
        'odds_1x2': '1x2',
        'odds_over': 'Atas',
        'odds_under': 'Bawah',
        'odds_total': 'Total',
        'odds_more': 'Lebih',
        'odds_company': 'Perusahaan',
        'odds_type': 'Tipe',
        'odds_spot': 'Titik',
        'odds_initial': 'Awal',
        'odds_home_win': 'Kandang',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Tandang',
        'odds_tu': 'Waktu Diperbarui',
        'odds_home_lose': 'Kandang',
        'odds_draw': 'Seri',
        'odds_away_win': 'Tandang',
        'odds_highest': 'Paling tinggi',
        'odds_lowest': 'Terendah',
        'odds_average': 'Rata-rata',
        'odds_changes': 'Perubahan Tolak ukur kekuatan tim',
        'odds_dc': 'Perubahan Detail',
        'Decimal': 'Desimal',
        'American': 'Amerika',
        'Fractional': 'Pecahan',
        'more': 'lebih',
        'matchPredictionTip': 'Tips Pertandingan',
        'matchPredictionResult': 'Prediksi hasil dengan Tips Pertandingan',
        'matchPredictionView': 'Tampilan'
    },
    'ja': {
        'events': 'イベント',
        'goal': 'ゴール',
        'penalty': 'ペナルティ',
        'penaltySaved': '保存されたパンルティ',
        'ownGoal': '自らの目標',
        'assist': 'アシスト',
        'statistics': '統計',
        'noData': 'データありません',
        'notPrepared': '試合は開始していません。',

        'prediction': 'お客様のチームをサポートします。',
        'vote': '投票',
        'voted': '投票しました。',
        'home': 'ホーム',
        'draw': '描く',
        'away': 'アウェイ',
        'voteNum': '（１回投票）) | ({count} 投票)',
        'voteFail': '投票失敗しました。再度お試しください～',
        'matchVoted': '既に投票済でした。',
        'matchNotStart': '試合は開始していません。',
        'predictionEnd': '予測は終了しました。試合の前に予測するようにご注意ください。',
        'statistic': '統計',
        'broadcast': '放送情報',
        'past_games': '過去ゲーム',
        'pg_no': '過去ゲームがありません。',
        'pg_lng': '過去 {count}ゲーム',
        'pg_w': '{count}W',
        'pg_d': '{count}D',
        'pg_date': '期日',
        'pg_competition': '対戦',
        'pg_home': 'ホーム',
        'pg_result': '結果',
        'pg_away': 'アウェイ',
        'absentee': '欠席',
        'absentee_no': '欠席なし',
        'recent_games': '最近のゲーム',
        'rg_no': '最近のゲームがありません',
        'rg_date': '期日',
        'rg_competition': '対戦',
        'rg_home': 'ホーム',
        'rg_result': '結果',
        'rg_away': 'アウェイ',
        'league_table': '順位表',
        'lt_format': 'フォーマット',
        'lt_total': 'トータル',
        'lt_home': 'ホーム',
        'lt_away': 'アウェイ',
        'lt_p': '試',
        'lt_w': '勝',
        'lt_d': '分',
        'lt_l': '負',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': '勝点',
        'lt_rank': 'ランキング',
        'lt_wp': 'WP',
        'ct_team': 'チーム',
        'ct_p': '試',
        'ct_w': '勝',
        'ct_d': '分',
        'ct_l': '負',
        'ct_fa': 'F/A',
        'ct_pts': '勝点',
        'odds': '勝目',
        'odds_no': '勝目がありません',
        'odds_no_data': 'データがありません',
        'odds_handicap': 'ハンディキャップ',
        'odds_ou': '以上/以下',
        'odds_1x2': '1x2',
        'odds_over': '以上',
        'odds_under': '以下',
        'odds_total': 'トータル',
        'odds_more': 'より多く',
        'odds_company': '会社',
        'odds_type': 'タイプ',
        'odds_spot': 'スポット',
        'odds_initial': 'イニシャル',
        'odds_home_win': 'ホーム',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'アウェイ',
        'odds_tu': '更新された時間',
        'odds_home_lose': 'ホーム',
        'odds_draw': '描く',
        'odds_away_win': 'アウェイ',
        'odds_highest': '一番高い',
        'odds_lowest': '一番低い',
        'odds_average': '平均',
        'odds_changes': '確率の変化',
        'odds_dc': '詳細変更内容',
        'Decimal': '１０進数',
        'American': 'アメリカ',
        'Fractional': '分数',
        'more': 'より多く',
        'matchPredictionTip': '試合のヒント',
        'matchPredictionResult': '試合ヒントによる予測結果',
        'matchPredictionView': 'ビューア'
    },
    'vi': {
        'events': 'Sự kiện',
        'goal': 'Bàn thắng',
        'penalty': 'Phạt đền',
        'penaltySaved': 'Pha cứu thua phạt đền',
        'ownGoal': 'Bàn thắng riêng',
        'assist': 'Hỗ trợ',
        'statistics': 'Số liệu thống kê',
        'noData': 'Không có dữ liệu',
        'notPrepared': 'Trận đấu chưa bắt đầu',

        'prediction': 'Ủng hộ đội của bạn',
        'vote': 'Bầu chọn',
        'voted': 'Đã bầu chọn',
        'home': 'Sân nhà',
        'draw': 'Hòa',
        'away': 'Sân khách',
        'voteNum': '(1 bầu chọn) | ({count} bầu chọn)',
        'voteFail': 'Bầu chọn không thành công, vui lòng thử lại~',
        'matchVoted': 'Bạn đã bầu chọn~',
        'matchNotStart': 'Trận đấu chưa bắt đầu',
        'predictionEnd': 'Kết thúc dự đoán, hãy nhớ dự đoán trước trận đấu',
        'statistic': 'Số liệu thống kê',
        'broadcast': 'Thông tin Phát sóng',
        'past_games': 'Các Trận đấu trước',
        'pg_no': 'Không có trận đấu trước',
        'pg_lng': 'Những trận {count} gần nhất',
        'pg_w': '{count} T.',
        'pg_d': '{count} H.',
        'pg_date': 'Ngày',
        'pg_competition': 'Cuộc thi đấu',
        'pg_home': 'Sân nhà',
        'pg_result': 'Kết quả',
        'pg_away': 'Sân khách',
        'absentee': 'Người vắng mặt',
        'absentee_no': 'Không có người vắng mặt',
        'recent_games': 'Những trận đấu gần đây',
        'rg_no': 'Không có trận đấu gần đây',
        'rg_date': 'Ngày',
        'rg_competition': 'Cuộc thi đấu',
        'rg_home': 'Sân nhà',
        'rg_result': 'Kết quả',
        'rg_away': 'Sân khách',
        'league_table': 'Bảng Vị trí Thi đấu',
        'lt_format': 'Định dạng',
        'lt_total': 'Tổng ',
        'lt_home': 'Sân nhà',
        'lt_away': 'Sân khách',
        'lt_p': 'S.T.',
        'lt_w': 'T.',
        'lt_d': 'H.',
        'lt_l': 'B',
        'lt_f': 'B.Tg.',
        'lt_a': 'B.Th.',
        'lt_pts': 'Đ.',
        'lt_rank': 'Xếp hạng',
        'lt_wp': 'WP',
        'ct_team': 'Đội',
        'ct_p': 'S.T.',
        'ct_w': 'T.',
        'ct_d': 'H.',
        'ct_l': 'B.',
        'ct_fa': 'F/A',
        'ct_pts': 'Đ.',
        'odds': 'Lợi thế',
        'odds_no': 'Không có lợi thế',
        'odds_no_data': 'Không có dữ liệu',
        'odds_handicap': 'Bất lợi',
        'odds_ou': 'Trên/Dưới',
        'odds_1x2': '1x2',
        'odds_over': 'Trên',
        'odds_under': 'Dưới',
        'odds_total': 'Tổng',
        'odds_more': 'Hơn',
        'odds_company': 'Công ty',
        'odds_type': 'Loại',
        'odds_spot': 'Điểm',
        'odds_initial': 'Ban đầu',
        'odds_home_win': 'Sân nhà',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Sân khách',
        'odds_tu': 'Thời gian cập nhật',
        'odds_home_lose': 'Sân nhà',
        'odds_draw': 'Hòa',
        'odds_away_win': 'Sân khách',
        'odds_highest': 'Cao nhất',
        'odds_lowest': 'Thấp nhất',
        'odds_average': 'Trung bình',
        'odds_changes': 'Thay đổi lợi thế',
        'odds_dc': 'Chi tiết thay đổi',
        'Decimal': 'Phần thập phân',
        'American': 'Người Mỹ',
        'Fractional': 'Phân số',
        'more': 'hơn',
        'matchPredictionTip': 'Thủ thuật trận đấu',
        'matchPredictionResult': 'Kết quả dự đoán theo thủ thuật trận đấu',
        'matchPredictionView': 'Xem'
    },
    'ar': {
        'events': 'فعاليات',
        'goal': 'هدف',
        'penalty': 'ركلة جزاء',
        'penaltySaved': 'ركلة جزاء مصدودة',
        'ownGoal': 'هدف عكسي',
        'assist': 'صناعة هدف',
        'statistics': 'إحصائيات',
        'noData': 'لا توجد بيانات',
        'notPrepared': 'المباراة لم تبدأ',

        'prediction': 'ادعم فريقك',
        'vote': 'تصويت',
        'voted': 'تم التصويت',
        'home': 'على ملعبه',
        'draw': 'تعادل',
        'away': 'خارج ملعبه',
        'voteNum': '(1 صوت) | ({count} أصوات)',
        'voteFail': 'فشل التصويت، يُرجى إعادة المحاولة~',
        'matchVoted': 'قمت بالتصويت بالفعل~',
        'matchNotStart': 'المباراة لم تبدأ',
        'predictionEnd': 'انتهت فترة التوقع، تذكر أن تقدم توقعك قبل المباراة',
        'statistic': 'إحصائيات',
        'broadcast': 'معلومات البث',
        'past_games': 'مباريات سابقة',
        'pg_no': 'لا توجد مباريات سابقة',
        'pg_lng': 'آخر {count} مباراة',
        'pg_w': '{count} فوز',
        'pg_d': '{count} تعادل',
        'pg_date': 'تاريخ',
        'pg_competition': 'منافسة',
        'pg_home': 'على ملعبه',
        'pg_result': 'نتيجة',
        'pg_away': 'خارج ملعبه',
        'absentee': 'غيابات',
        'absentee_no': 'لا توجد غيابات',
        'recent_games': 'المباريات الحالية',
        'rg_no': ' توجد مباريات حالية',
        'rg_date': 'تاريخ',
        'rg_competition': 'منافسة',
        'rg_home': 'على ملعبه',
        'rg_result': 'نتيجة',
        'rg_away': 'خارج ملعبه',
        'league_table': 'جدول الدوري',
        'lt_format': 'التشكيل',
        'lt_total': 'إجمالي',
        'lt_home': 'على ملعبه',
        'lt_away': 'خارج ملعبه',
        'lt_p': 'لعب',
        'lt_w': 'فوز',
        'lt_d': 'تعادل',
        'lt_l': 'هزيمة',
        'lt_f': 'أهداف له',
        'lt_a': 'أهداف عليه',
        'lt_pts': 'النقاط',
        'lt_rank': 'التصنيف',
        'lt_wp': 'النقاط المحصَّلة',
        'ct_team': 'الفريق',
        'ct_p': 'لعب',
        'ct_w': 'فوز',
        'ct_d': 'تعادل',
        'ct_l': 'هزيمة',
        'ct_fa': 'أهداف له/أهداف عليه',
        'ct_pts': 'النقاط',
        'odds': 'احتمالات',
        'odds_no': 'لا توجد احتمالات',
        'odds_no_data': 'لا توجد بيانات',
        'odds_handicap': 'هانديكاب',
        'odds_ou': 'أكثر/أقل',
        'odds_1x2': '1x2',
        'odds_over': 'أكثر',
        'odds_under': 'أقل',
        'odds_total': 'إجمالي',
        'odds_more': 'المزيد',
        'odds_company': 'شركة',
        'odds_type': 'نوع',
        'odds_spot': 'نقطة اللعب',
        'odds_initial': 'أولي',
        'odds_home_win': 'على ملعبه',
        'odds_hdp': 'هانديكاب',
        'odds_away_lose': 'خارج ملعبه',
        'odds_tu': 'تحديث الوقت',
        'odds_home_lose': 'على ملعبه',
        'odds_draw': 'تعادل',
        'odds_away_win': 'خارج ملعبه',
        'odds_highest': 'أعلى',
        'odds_lowest': 'أدنى',
        'odds_average': 'متوسط',
        'odds_changes': 'تغييرات الاحتمالات',
        'odds_dc': 'تغييرات التفاصيل',
        'Decimal': 'رقم عشري',
        'American': 'أمريكي',
        'Fractional': 'رقم كسري',
        'more': 'المزيد',
        'matchPredictionTip': 'نصائح المباراة',
        'matchPredictionResult': 'النتائج المتوقعة من خلال نصائح المباراة',
        'matchPredictionView': 'عرض'
    }
};

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppMatchTag = exports.downloadPopup = exports.matchLive = exports.matchAnalysis = exports.matchOverview = exports.BasicPopup = exports.AppLoading = undefined;

var _AppLoading = __webpack_require__(627);

var _AppLoading2 = _interopRequireDefault(_AppLoading);

var _BasicPopup = __webpack_require__(628);

var _BasicPopup2 = _interopRequireDefault(_BasicPopup);

var _matchOverview = __webpack_require__(653);

var _matchOverview2 = _interopRequireDefault(_matchOverview);

var _matchAnalysis = __webpack_require__(677);

var _matchAnalysis2 = _interopRequireDefault(_matchAnalysis);

var _matchLive = __webpack_require__(693);

var _matchLive2 = _interopRequireDefault(_matchLive);

var _downloadPopup = __webpack_require__(500);

var _downloadPopup2 = _interopRequireDefault(_downloadPopup);

var _AppMatchTag = __webpack_require__(602);

var _AppMatchTag2 = _interopRequireDefault(_AppMatchTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AppLoading = _AppLoading2.default;
exports.BasicPopup = _BasicPopup2.default;
exports.matchOverview = _matchOverview2.default;
exports.matchAnalysis = _matchAnalysis2.default;
exports.matchLive = _matchLive2.default;
exports.downloadPopup = _downloadPopup2.default;
exports.AppMatchTag = _AppMatchTag2.default;

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1cdc56b4", content, true, {});

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".loading-container[data-v-17cb9b9a]{z-index:3000;position:fixed;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(0,0,0,.5)}.loading-container .icon-loading[data-v-17cb9b9a]{width:2rem;height:2rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/AppLoading.vue"],"names":[],"mappings":"AACA,oCACE,aAAc,AACd,eAAgB,AAChB,MAAO,AACP,QAAS,AACT,SAAU,AACV,OAAQ,AACR,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA+B,CAChC,AACD,kDACE,WAAY,AACZ,WAAa,CACd","file":"AppLoading.vue","sourcesContent":["\n.loading-container[data-v-17cb9b9a] {\n  z-index: 3000;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: rgba(0, 0, 0, 0.5);\n}\n.loading-container .icon-loading[data-v-17cb9b9a] {\n  width: 2rem;\n  height: 2rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    }
};

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('img', {
    staticClass: "icon-loading",
    attrs: {
      "src": __webpack_require__(647)
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.5e3d98d.gif";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(649);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("2a92d293", content, true, {});

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "[data-v-7ab469f6]{box-sizing:border-box}.fade-enter-active[data-v-7ab469f6],.fade-leave-active[data-v-7ab469f6]{transition:opacity .3s}.fade-enter[data-v-7ab469f6],.fade-leave-to[data-v-7ab469f6]{opacity:0}.slide-enter[data-v-7ab469f6],.slide-leave-active[data-v-7ab469f6]{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}.popup-wrapper .popup-overlay[data-v-7ab469f6]{z-index:1000;position:fixed;top:0;left:0;right:0;bottom:0;background-color:#000;opacity:.5}.popup-wrapper .popup-container[data-v-7ab469f6]{z-index:10001;position:fixed;bottom:0;left:0;right:0;background-color:#fff;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.popup-wrapper .popup-container .popup-header[data-v-7ab469f6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:3.0625rem;padding:1.1875rem .6875rem}.popup-wrapper .popup-container .popup-header .close-icon[data-v-7ab469f6]{position:absolute;top:.875rem;right:.6875rem;width:.625rem;height:.625rem}.popup-wrapper .popup-container .popup-header .title[data-v-7ab469f6]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;font-size:.9375rem;font-weight:400;font-family:SF UI Display;color:#2d2f32}.popup-wrapper .popup-container .popup-content[data-v-7ab469f6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 .6875rem;padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/BasicPopup.vue"],"names":[],"mappings":"AACA,kBACE,qBAAuB,CACxB,AACD,wEAEE,sBAAyB,CAC1B,AACD,6DAEE,SAAW,CACZ,AACD,mEAEE,wCAA2C,AACnC,+BAAmC,CAC5C,AACD,+CACE,aAAc,AACd,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,sBAA0B,AAC1B,UAAa,CACd,AACD,iDACE,cAAe,AACf,eAAgB,AAChB,SAAU,AACV,OAAQ,AACR,QAAS,AACT,sBAA0B,AAC1B,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,+DACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,iBAAkB,AAClB,0BAA4B,CAC7B,AACD,2EACE,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,cAAgB,CACjB,AACD,sEACE,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,kBAAmB,AACnB,mBAAqB,AACrB,gBAAiB,AACjB,0BAA2B,AAC3B,aAAe,CAChB,AACD,gEACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AACpB,gDAAiD,AACjD,0CAA4C,CAC7C","file":"BasicPopup.vue","sourcesContent":["\n*[data-v-7ab469f6] {\n  box-sizing: border-box;\n}\n.fade-enter-active[data-v-7ab469f6],\n.fade-leave-active[data-v-7ab469f6] {\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-7ab469f6],\n.fade-leave-to[data-v-7ab469f6] {\n  opacity: 0;\n}\n.slide-enter[data-v-7ab469f6],\n.slide-leave-active[data-v-7ab469f6] {\n  -webkit-transform: translate3d(0, 100%, 0);\n          transform: translate3d(0, 100%, 0);\n}\n.popup-wrapper .popup-overlay[data-v-7ab469f6] {\n  z-index: 1000;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #000000;\n  opacity: 0.5;\n}\n.popup-wrapper .popup-container[data-v-7ab469f6] {\n  z-index: 10001;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #ffffff;\n  transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n}\n.popup-wrapper .popup-container .popup-header[data-v-7ab469f6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  height: 3.0625rem;\n  padding: 1.1875rem .6875rem;\n}\n.popup-wrapper .popup-container .popup-header .close-icon[data-v-7ab469f6] {\n  position: absolute;\n  top: .875rem;\n  right: .6875rem;\n  width: .625rem;\n  height: .625rem;\n}\n.popup-wrapper .popup-container .popup-header .title[data-v-7ab469f6] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  font-family: SF UI Display;\n  color: #2D2F32;\n}\n.popup-wrapper .popup-container .popup-content[data-v-7ab469f6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 0 .6875rem;\n  padding-bottom: constant(safe-area-inset-bottom);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '7.4375rem'
        }
    },

    methods: {
        handleClose: function handleClose() {
            this.$emit('close');
        }
    }
};

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-wrapper",
    class: _vm.customClass,
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "popup-overlay",
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "popup-container",
    style: ({
      minHeight: _vm.height
    })
  }, [_c('header', {
    staticClass: "popup-header",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": __webpack_require__(652)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAWlBMVEUAAACMlp+Im5+Ml5+Mlp+Mlp+Mlp98kJGMlp6Llp+MlaCKl6CLl5+Nlp+Ll56Ml6GMlp+Mlp+Llp+Mlp+Mlp+Mlp+Mlp+Ml5+MlZ+Mlp+Mlp+MlqCMlp+Mlp85X7AyAAAAHXRSTlMA+RPh5E+dBqisqVNAo0I+9PBKlOrN0dbHw4hjX578+YAAAAGDSURBVEjHldfLcoMwDIVhg80lF1pjG5KQ5P1fs63oVAuN56daseAMH+CRRm5I/a3c+jS4oyWRIJG0LSWWJXft0Wzb5aXMZd2S65f3T/nx2h7Mfk5eIuvk/CxXTRi7Y/JuCo1EZu9KfO9p34sczb1vfhOzuxW5MnIw70/O8s4qP2SWWnqXsjBUTua/R+Xkhu4cGpKrWZmnyzezvZ69kaM5nD5ag9nlbO4v+20VOZqlKnIyS9XlbAY5mEEOZpCDuSIHM8jBDHIwgxzMIB+qZpa/XlUzyx+PqpnlMdbMLNeyZpaDGeRgBrk1s/z1iBqO9yeaOfx/tu0tMFNG/WDQz011o/4q6OdgNnIw2+Np5WwO93uoyXmmPJ+mt6BZz7PpLWjW8wz9HGZKrZ+zGfo5mGESgRkmEZhBDmaQgxnkYK7IwQxyMIMczCgf6maWp1wxozzLmmDNJNc1wZpRrmsCmGlNsGaW65pgzSyXNWFb52Zes5pZniWyJTekKcQwdWo+IJ+8RL4AM/t0oPOdjIcAAAAASUVORK5CYII="

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42ab7654",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(655);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("2170738f", content, true, {});

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "body[data-v-42ab7654],html[data-v-42ab7654]{-webkit-touch-callout:none;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:15px;padding:0;margin:0;color:#333;background-color:#eff1f4;position:absolute;top:0;left:0;width:100%;height:auto;min-height:100%;overflow-x:hidden}.events[data-v-42ab7654]{background-color:#f5f5f5}section[data-v-42ab7654]{display:block;font-size:15px;height:30px;line-height:30px;font-weight:400;padding:0 0 0 15px;margin:0;background-color:#e2e4e6}.content[data-v-42ab7654]{margin:10px 15px}a[data-v-42ab7654]{color:#399e5c;text-decoration:none}.person[data-v-42ab7654]{color:#000;text-decoration:none}p[data-v-42ab7654]{line-height:1.6;text-align:justify;word-wrap:break-word;word-break:normal;margin:20px 0}dd[data-v-42ab7654],dl[data-v-42ab7654],dt[data-v-42ab7654],li[data-v-42ab7654],ul[data-v-42ab7654]{list-style:none;margin:0;padding:0}header h1[data-v-42ab7654]{font-size:20px;padding:0;margin:0;line-height:1.5}header time[data-v-42ab7654]{color:#999;font-size:12px;display:inline-block;padding:0;vertical-align:top;margin-left:6px}header h2[data-v-42ab7654]{line-height:20px;font-size:12px;padding:5px 0 0;font-weight:400;margin:0}article video[data-v-42ab7654]{display:block;margin:0 auto;width:100%;background-size:118px}.media-iframe[data-v-42ab7654]{text-indent:0;display:block;margin:0 auto;width:100%;min-height:100px}.media-container[data-v-42ab7654]{display:block;position:relative;z-index:1000;margin:0 auto}.media-container-video[data-v-42ab7654]{border-bottom:25px solid #000;border-top:25px solid #000}.media-holder[data-v-42ab7654]{position:absolute;left:0;top:0;z-index:999;width:100%;height:100%;background:url(" + escape(__webpack_require__(656)) + ") no-repeat 50%;background-size:40px 40px}.media-holder-video[data-v-42ab7654]{background:url(" + escape(__webpack_require__(657)) + ") no-repeat 50%;background-size:60px 60px}.floater[data-v-42ab7654]{float:left;height:50%;margin-bottom:-10px}.empty[data-v-42ab7654]{clear:both;height:20px;position:relative;text-align:center;color:#babdc2;font-size:14px}li[data-v-42ab7654],ol[data-v-42ab7654]{margin:0;padding:0}ol#timeline[data-v-42ab7654]{width:100%;padding-bottom:20px;background:url(" + escape(__webpack_require__(658)) + ") 50% repeat-y}ol#timeline li[data-v-42ab7654]{position:relative;color:#555;margin:10px 0;margin-top:20px}ol#timeline li div[data-v-42ab7654]{width:40%;border:1px solid #ddd;padding:5px 0;background:#fff;position:relative;border-radius:3px}ol#timeline p[data-v-42ab7654]{margin:0;padding:0;font-size:12px;height:20px;line-height:20px;text-indent:0}ol#timeline p img[data-v-42ab7654]{width:15px;vertical-align:middle}.content_p[data-v-42ab7654]{padding-bottom:41px}.show[data-v-42ab7654]{width:100%;font-size:12px;padding-top:13px;line-height:14px;border-top:1px solid #e9e9e9;background:#eff1f4}.show_main[data-v-42ab7654]{padding:0 15px}.show img[data-v-42ab7654]{width:12px;vertical-align:top;margin-right:3px}.show span[data-v-42ab7654]{display:inline-block;text-align:left;margin-bottom:13px}.show_main[data-v-42ab7654]{text-align:justify;text-justify:distribute-all-lines;text-align-last:justify;-moz-text-align-last:justify;-webkit-text-align-last:justify}@media screen and (-webkit-min-device-pixel-ratio:0){.show_main[data-v-42ab7654]:after{content:\"\";display:inline-block;overflow:hidden;width:0;height:0}}.cf[data-v-42ab7654]:after,.cf[data-v-42ab7654]:before{content:\"\";display:table}.cf[data-v-42ab7654]:after{clear:both}.cf[data-v-42ab7654]{zoom:1;clear:both;padding:0}ol#timeline .home[data-v-42ab7654]{float:left;text-align:right;padding-right:10px}ol#timeline .home p[data-v-42ab7654]{text-align:right;font-size:12px}ol#timeline .home span.arrow[data-v-42ab7654]{display:block;width:6px;height:8px;background:url(" + escape(__webpack_require__(659)) + ") 0 0 no-repeat;position:absolute;right:-6px;top:5px;background-size:cover}ol#timeline .away[data-v-42ab7654]{float:right;text-align:left;padding-left:10px;line-height:15px}ol#timeline .away span.arrow[data-v-42ab7654]{display:block;width:6px;height:8px;background:url(" + escape(__webpack_require__(660)) + ") 0 0 no-repeat;position:absolute;left:-6px;top:5px;background-size:cover}ol#timeline .away p[data-v-42ab7654]{text-align:left}ol#timeline .num[data-v-42ab7654]{width:20px;left:0;right:0;position:absolute;margin:auto;background:#16ac3a;border-radius:10px;color:#fff;font-family:arial;font-size:10px}.content .act[data-v-42ab7654],ol#timeline .num[data-v-42ab7654]{display:block;height:20px;text-align:center;line-height:20px;font-weight:400}.content .act[data-v-42ab7654]{width:100%;color:#16ac3a;font-size:14px;margin-top:5px}.content .dot[data-v-42ab7654]{margin:-5px auto 0}.content .dot[data-v-42ab7654],.content .dot_s[data-v-42ab7654]{display:block;width:8px;height:8px;border-radius:4px;background:#16ac3a}.content .dot_s[data-v-42ab7654]{margin:0 auto}ol#timeline>li[data-v-42ab7654]:first-child{margin-top:5px}.icon_start[data-v-42ab7654]{display:block;margin:0 auto;width:16px;height:16px;background:url(" + escape(__webpack_require__(661)) + ") 0 0 no-repeat;background-size:100%}.icon_end[data-v-42ab7654]{display:block;margin:5px auto 0;width:16px;height:16px;background:url(" + escape(__webpack_require__(662)) + ") 0 0 no-repeat;background-size:100%}.status[data-v-42ab7654]{width:96%;margin:0 auto;padding:0}.status table[data-v-42ab7654]{margin:0;padding:0;width:100%;word-break:keep-all}.status table.head[data-v-42ab7654]{border-bottom:1px solid #ddd}.status td[data-v-42ab7654],.status th[data-v-42ab7654]{margin:0;padding:0;width:100%;border-collapse:collapse;font-weight:400;font-size:12px;border:0}.status th[data-v-42ab7654]{height:40px;line-height:40px}.status td[data-v-42ab7654]{height:16px;line-height:16px;padding:7px 0;font-family:arial;color:#333}.status a[data-v-42ab7654]{color:#333}.status th img[data-v-42ab7654]{width:25px;height:25px;vertical-align:middle;margin:0;padding:0}.status .away[data-v-42ab7654]{width:43%;text-align:right;text-overflow:ellipsis}.status .home[data-v-42ab7654]{width:43%;text-align:left;text-overflow:ellipsis}.status .name[data-v-42ab7654]{width:14%;text-align:center}.status .rank[data-v-42ab7654]{margin:0 1px;width:77%;background:#e9e9e9;margin-top:2px}.status .rank[data-v-42ab7654],.status .ranks[data-v-42ab7654]{display:inline-block;height:12px;line-height:12px;border-radius:1px;vertical-align:top}.status .ranks[data-v-42ab7654]{background:#16ac3a}.status .ranks_l[data-v-42ab7654]{background:#888}span.text_lim[data-v-42ab7654]{display:inline-block;white-space:nowrap;overflow:hidden;line-break:strict;vertical-align:middle;text-overflow:ellipsis;width:90px}.empty[data-v-42ab7654]{padding-top:36%}.video[data-v-42ab7654]{position:relative}.video .mask[data-v-42ab7654]{width:100%;height:100%;position:absolute;top:0;left:0;background:url(https://dqdfiles.b0.upaiyun.com/app/icon_playing.png) 50% no-repeat rgba(0,0,0,.5);background-size:auto 20px;z-index:10000;display:none}.playing .mask[data-v-42ab7654]{display:block}.playing .media-holder-video[data-v-42ab7654]{display:none}ul.gif_container[data-v-42ab7654]{min-height:200px;padding:15px 10px 10px;font-size:0}ul.gif_container li[data-v-42ab7654]{background:#fff;display:inline-block;width:49%;min-height:100px;margin-bottom:8px;overflow:hidden;font-size:0;vertical-align:middle}ul.gif_container li[data-v-42ab7654]:nth-child(2n){margin-left:2%}ul.gif_container li .img_con[data-v-42ab7654]{background-repeat:no-repeat;background-position:50%;background-size:100% auto;height:128px;width:100%}ul.gif_container li .text_con[data-v-42ab7654]{font-size:12px;margin:0;padding:8px 8px 10px;height:52px;position:relative}ul.gif_container li .text_con p[data-v-42ab7654]{margin:0;height:30px;line-height:15px;text-align:left;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}ul.gif_container li a[data-v-42ab7654]{display:block;color:#333}ul.gif_container li a[data-v-42ab7654]:visited{color:#999}.total_view[data-v-42ab7654]{position:absolute;left:8px;bottom:10px;color:#16ac3a}.comments[data-v-42ab7654]{position:absolute;right:8px;bottom:10px;color:#999}.gif[data-v-42ab7654]{background-image:url(" + escape(__webpack_require__(663)) + ");background-position:50%;background-size:20px 20px;height:20px;width:20px;display:block;z-index:2000}#app_news[data-v-42ab7654]{background:#fff}#app_news dd[data-v-42ab7654]{padding:0 14px;border-top:1px solid #eee;height:72px}#app_news dd a[data-v-42ab7654]{display:block;color:#333;height:52px;padding:10px 0;position:relative}#app_news dd a[data-v-42ab7654]:visited{color:#999}#app_news dd span[data-v-42ab7654]{color:#aaa;font-size:11px;position:absolute;right:0;bottom:9px}#app_news dd .img_news[data-v-42ab7654]{background-color:#e9e9e9;width:70px;height:52px;float:left;margin-right:10px;background-position:50%;background-size:100%}#app_news dd .video_news[data-v-42ab7654]{width:70px;height:52px;border-radius:2px;float:left;margin-right:12px;background-position:50%;background-size:100%}#app_news dd .video_icon[data-v-42ab7654]{background:url(https://dqdfiles.b0.upaiyun.com/app/video.png) 50% no-repeat rgba(0,0,0,.5);width:100%;height:100%;background-size:20px 20px}#app_news p[data-v-42ab7654]{padding:0 0 3px;line-height:18px;margin:0;font-size:14px;position:relative;bottom:2px}.loading[data-v-42ab7654]{position:absolute;width:45px;height:45px;background:url(" + escape(__webpack_require__(664)) + ") no-repeat;background-size:100%;margin:auto;top:0;bottom:0;left:0;right:0;-webkit-animation:spin-data-v-42ab7654 1s linear infinite;animation:spin-data-v-42ab7654 1s linear infinite}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-data-v-42ab7654{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/matchOverview.vue"],"names":[],"mappings":"AACA,4CAEI,2BAA4B,AAC5B,sDAA4D,AAC5D,eAAgB,AAChB,UAAW,AACX,SAAU,AACV,WAAY,AACZ,yBAA0B,AAC1B,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AAEb,gBAAiB,AACjB,iBAAmB,CACtB,AACD,yBACI,wBAA0B,CAC7B,AACD,yBACI,cAAe,AAEf,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,SAAU,AAEV,wBAA0B,CAC7B,AACD,0BACI,gBAAkB,CACrB,AACD,mBACI,cAAe,AACf,oBAAsB,CACzB,AACD,yBACI,WAAa,AACb,oBAAsB,CACzB,AACD,mBACI,gBAAiB,AACjB,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,aAAe,CAClB,AACD,oGAKI,gBAAiB,AACjB,SAAU,AACV,SAAW,CACd,AACD,2BACI,eAAgB,AAChB,UAAW,AACX,SAAU,AACV,eAAiB,CACpB,AACD,6BACI,WAAY,AACZ,eAAgB,AAChB,qBAAsB,AACtB,UAAW,AACX,mBAAoB,AACpB,eAAiB,CACpB,AACD,2BACI,iBAAkB,AAClB,eAAgB,AAChB,gBAAmB,AACnB,gBAAoB,AACpB,QAAU,CACb,AACD,+BACI,cAAe,AACf,cAAe,AACf,WAAY,AAEZ,qBAAuB,CAC1B,AACD,+BACI,cAAe,AACf,cAAe,AACf,cAAe,AACf,WAAY,AACZ,gBAAkB,CACrB,AACD,kCACI,cAAe,AACf,kBAAmB,AACnB,aAAc,AACd,aAAe,CAClB,AACD,wCACI,8BAA+B,AAC/B,0BAA4B,CAC/B,AACD,+BACI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,WAAY,AACZ,YAAa,AACb,uDAA0E,AAC1E,yBAA2B,CAC9B,AACD,qCACI,uDAAqE,AACrE,yBAA2B,CAC9B,AACD,0BACI,WAAY,AACZ,WAAY,AACZ,mBAAqB,CACxB,AACD,wBACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,cAAe,AACf,cAAgB,CACnB,AACD,wCAEI,SAAU,AACV,SAAW,CACd,AACD,6BACI,WAAY,AACZ,oBAAqB,AACrB,qDAAsE,CACzE,AACD,gCACI,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,eAAiB,CACpB,AACD,oCACI,UAAW,AACX,sBAAuB,AAEvB,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,iBAAmB,CACtB,AACD,+BACI,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,aAAe,CAClB,AACD,mCACI,WAAY,AACZ,qBAAuB,CAC1B,AACD,4BACI,mBAAqB,CACxB,AACD,uBACI,WAAY,AACZ,eAAgB,AAEhB,iBAAkB,AAClB,iBAAkB,AAClB,6BAA8B,AAE9B,kBAAoB,CACvB,AACD,4BACI,cAAgB,CACnB,AACD,2BACI,WAAY,AACZ,mBAAoB,AACpB,gBAAkB,CACrB,AACD,4BACI,qBAAsB,AACtB,gBAAiB,AACjB,kBAAoB,CACvB,AACD,4BACI,mBAAoB,AACpB,kCAAmC,AAEnC,wBAAyB,AAEzB,6BAA8B,AAE9B,+BAAiC,CAEpC,AAGD,qDACA,kCACQ,WAAY,AACZ,qBAAsB,AACtB,gBAAiB,AACjB,QAAS,AACT,QAAU,CACjB,CACA,AACD,uDAEI,WAAY,AACZ,aAAe,CAClB,AACD,2BACI,UAAY,CACf,AACD,qBACI,OAAQ,AACR,WAAY,AACZ,SAAW,CACd,AACD,mCACI,WAAY,AACZ,iBAAkB,AAClB,kBAAoB,CACvB,AACD,qCACI,iBAAkB,AAClB,cAAgB,CACnB,AACD,8CACI,cAAe,AACf,UAAW,AACX,WAAY,AACZ,uDAA2D,AAC3D,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,qBAAuB,CAC1B,AACD,mCACI,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,gBAAkB,CACrB,AACD,8CACI,cAAe,AACf,UAAW,AACX,WAAY,AACZ,uDAA2D,AAC3D,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,qBAAuB,CAC1B,AACD,qCACI,eAAiB,CACpB,AACD,kCAEI,WAAY,AAEZ,OAAQ,AACR,QAAS,AACT,kBAAmB,AACnB,YAAa,AACb,mBAAoB,AACpB,mBAAoB,AACpB,WAAY,AAIZ,kBAAmB,AACnB,cAAgB,CACnB,AACD,iEAhBI,cAAe,AAEf,YAAa,AAQb,kBAAmB,AACnB,iBAAkB,AAClB,eAAiB,CAcpB,AAVD,+BAEI,WAAY,AAEZ,cAAe,AAIf,eAAgB,AAChB,cAAgB,CACnB,AACD,+BAMI,kBAAyB,CAC5B,AACD,gEAPI,cAAe,AACf,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,kBAAoB,CAUvB,AAPD,iCAMI,aAAsB,CACzB,AACD,4CACI,cAAgB,CACnB,AACD,6BACI,cAAe,AACf,cAAe,AACf,WAAY,AACZ,YAAa,AACb,uDAAgE,AAChE,oBAAsB,CACzB,AACD,2BACI,cAAe,AACf,kBAAwB,AACxB,WAAY,AACZ,YAAa,AACb,uDAA8D,AAC9D,oBAAsB,CACzB,AACD,yBACI,UAAW,AACX,cAAe,AACf,SAAW,CACd,AACD,+BACI,SAAU,AACV,UAAW,AACX,WAAY,AACZ,mBAAqB,CACxB,AACD,oCACI,4BAA8B,CAEjC,AACD,wDAEI,SAAU,AACV,UAAW,AACX,WAAY,AACZ,yBAA0B,AAC1B,gBAAiB,AACjB,eAAgB,AAChB,QAAU,CACb,AACD,4BACI,YAAa,AACb,gBAAkB,CACrB,AACD,4BACI,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,2BACI,UAAY,CACf,AACD,gCACI,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,SAAU,AACV,SAAW,CACd,AACD,+BACI,UAAW,AACX,iBAAkB,AAClB,sBAAwB,CAC3B,AACD,+BACI,UAAW,AACX,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,+BACI,UAAW,AACX,iBAAmB,CACtB,AACD,+BACI,aAAc,AAEd,UAAW,AAGX,mBAAoB,AAGpB,cAAgB,CACnB,AACD,+DATI,qBAAsB,AAEtB,YAAa,AACb,iBAAkB,AAElB,kBAAmB,AACnB,kBAAoB,CAUvB,AAPD,gCAII,kBAAoB,CAGvB,AACD,kCACI,eAAiB,CACpB,AACD,+BACI,qBAAsB,AACtB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,sBAAuB,AACvB,uBAAwB,AACxB,UAAY,CACf,AACD,wBACI,eAAiB,CACpB,AACD,wBACI,iBAAmB,CACtB,AACD,8BACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,kGAAiH,AACjH,0BAA2B,AAC3B,cAAe,AACf,YAAc,CACjB,AACD,gCACI,aAAe,CAClB,AACD,8CACI,YAAc,CACjB,AAGD,kCACI,iBAAkB,AAClB,uBAAwB,AACxB,WAAa,CAChB,AACD,qCACI,gBAAoB,AACpB,qBAAsB,AACtB,UAAW,AACX,iBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,qBAAuB,CAC1B,AACD,mDACI,cAAgB,CACnB,AACD,8CACI,4BAA6B,AAC7B,wBAAmC,AACnC,0BAA2B,AAC3B,aAAc,AACd,UAAY,CACf,AACD,+CACI,eAAgB,AAChB,SAAU,AACV,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CACtB,AACD,iDACI,SAAU,AACV,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,4BAA6B,AAC7B,qBAAsB,AACtB,eAAiB,CACpB,AACD,uCACI,cAAe,AACf,UAAe,CAClB,AACD,+CACI,UAAe,CAClB,AACD,6BACI,kBAAmB,AACnB,SAAU,AACV,YAAa,AACb,aAAe,CAClB,AACD,2BACI,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,UAAe,CAClB,AACD,sBACI,+CAAyD,AACzD,wBAAmC,AACnC,0BAA2B,AAC3B,YAAa,AACb,WAAY,AACZ,cAAe,AACf,YAAc,CACjB,AACD,2BACI,eAAiB,CACpB,AACD,8BACI,eAAgB,AAGhB,0BAA8B,AAE9B,WAAa,CAJhB,AAMD,gCACI,cAAe,AACf,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,iBAAmB,CACtB,AACD,wCACI,UAAe,CAClB,AACD,mCACI,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,UAAY,CACf,AACD,wCACI,yBAA0B,AAC1B,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,wBAAmC,AACnC,oBAAsB,CACzB,AACD,0CACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,wBAAmC,AACnC,oBAAsB,CACzB,AACD,0CACI,2FAA0G,AAC1G,WAAY,AACZ,YAAa,AACb,yBAA2B,CAC9B,AACD,6BACI,gBAAmB,AACnB,iBAAkB,AAClB,SAAU,AACV,eAAgB,AAChB,kBAAmB,AACnB,UAAY,CACf,AACD,0BACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,mDAA8D,AAC9D,qBAAsB,AACtB,YAAa,AACb,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,0DAA2D,AACnD,iDAAmD,CAC9D,AACD,wBACA,GACQ,gCAAkC,AAClC,uBAA0B,CACjC,CACA,AACD,gCACA,GACQ,gCAAkC,AAClC,uBAA0B,CACjC,CACA","file":"matchOverview.vue","sourcesContent":["\nhtml[data-v-42ab7654],\nbody[data-v-42ab7654] {\n    -webkit-touch-callout: none;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 15px;\n    padding: 0;\n    margin: 0;\n    color: #333;\n    background-color: #eff1f4;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: auto;\n    /* iOS position:fixed; elements fix (not 100%) */\n    min-height: 100%;\n    overflow-x: hidden;\n}\n.events[data-v-42ab7654] {\n    background-color: #f5f5f5;\n}\nsection[data-v-42ab7654] {\n    display: block;\n    /* vertical-align:middle; */\n    font-size: 15px;\n    height: 30px;\n    line-height: 30px;\n    font-weight: 400;\n    padding: 0 0 0 15px;\n    margin: 0;\n    /*color: 555;*/\n    background-color: #e2e4e6;\n}\n.content[data-v-42ab7654] {\n    margin: 10px 15px;\n}\na[data-v-42ab7654] {\n    color: #399e5c;\n    text-decoration: none;\n}\n.person[data-v-42ab7654] {\n    color: black;\n    text-decoration: none;\n}\np[data-v-42ab7654] {\n    line-height: 1.6;\n    text-align: justify;\n    word-wrap: break-word;\n    word-break: normal;\n    margin: 20px 0;\n}\nul[data-v-42ab7654],\nli[data-v-42ab7654],\ndl[data-v-42ab7654],\ndt[data-v-42ab7654],\ndd[data-v-42ab7654] {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\nheader h1[data-v-42ab7654] {\n    font-size: 20px;\n    padding: 0;\n    margin: 0;\n    line-height: 1.5;\n}\nheader time[data-v-42ab7654] {\n    color: #999;\n    font-size: 12px;\n    display: inline-block;\n    padding: 0;\n    vertical-align: top;\n    margin-left: 6px;\n}\nheader h2[data-v-42ab7654] {\n    line-height: 20px;\n    font-size: 12px;\n    padding: 5px 0 0 0;\n    font-weight: normal;\n    margin: 0;\n}\narticle video[data-v-42ab7654] {\n    display: block;\n    margin: 0 auto;\n    width: 100%;\n    /* background: url() #3e3e3e no-repeat center center; */\n    background-size: 118px;\n}\n.media-iframe[data-v-42ab7654] {\n    text-indent: 0;\n    display: block;\n    margin: 0 auto;\n    width: 100%;\n    min-height: 100px;\n}\n.media-container[data-v-42ab7654] {\n    display: block;\n    position: relative;\n    z-index: 1000;\n    margin: 0 auto;\n}\n.media-container-video[data-v-42ab7654] {\n    border-bottom: 25px #000 solid;\n    border-top: 25px #000 solid;\n}\n.media-holder[data-v-42ab7654] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 999;\n    width: 100%;\n    height: 100%;\n    background: url('../assets/match/play@80x80.png') no-repeat center center;\n    background-size: 40px 40px;\n}\n.media-holder-video[data-v-42ab7654] {\n    background: url('../assets/match/video.png') no-repeat center center;\n    background-size: 60px 60px;\n}\n.floater[data-v-42ab7654] {\n    float: left;\n    height: 50%;\n    margin-bottom: -10px;\n}\n.empty[data-v-42ab7654] {\n    clear: both;\n    height: 20px;\n    position: relative;\n    text-align: center;\n    color: #babdc2;\n    font-size: 14px;\n}\nol[data-v-42ab7654],\nli[data-v-42ab7654] {\n    margin: 0;\n    padding: 0;\n}\nol#timeline[data-v-42ab7654] {\n    width: 100%;\n    padding-bottom: 20px;\n    background: url('../assets/match/bg_line.png') center center repeat-y;\n}\nol#timeline li[data-v-42ab7654] {\n    position: relative;\n    color: #555;\n    margin: 10px 0;\n    margin-top: 20px;\n}\nol#timeline li div[data-v-42ab7654] {\n    width: 40%;\n    border: 1px solid #ddd;\n    /*no*/\n    padding: 5px 0;\n    background: #fff;\n    position: relative;\n    border-radius: 3px;\n}\nol#timeline p[data-v-42ab7654] {\n    margin: 0;\n    padding: 0;\n    font-size: 12px;\n    height: 20px;\n    line-height: 20px;\n    text-indent: 0;\n}\nol#timeline p img[data-v-42ab7654] {\n    width: 15px;\n    vertical-align: middle;\n}\n.content_p[data-v-42ab7654] {\n    padding-bottom: 41px;\n}\n.show[data-v-42ab7654] {\n    width: 100%;\n    font-size: 12px;\n    /*height:14px;*/\n    padding-top: 13px;\n    line-height: 14px;\n    border-top: 1px solid #e9e9e9;\n    /*no*/\n    background: #eff1f4;\n}\n.show_main[data-v-42ab7654] {\n    padding: 0 15px;\n}\n.show img[data-v-42ab7654] {\n    width: 12px;\n    vertical-align: top;\n    margin-right: 3px;\n}\n.show span[data-v-42ab7654] {\n    display: inline-block;\n    text-align: left;\n    margin-bottom: 13px;\n}\n.show_main[data-v-42ab7654] {\n    text-align: justify;\n    text-justify: distribute-all-lines;\n    /*ie6-8*/\n    text-align-last: justify;\n    /* ie9*/\n    -moz-text-align-last: justify;\n    /*ff*/\n    -webkit-text-align-last: justify;\n    /*chrome 20+*/\n}\n\n/* chrome*/\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n.show_main[data-v-42ab7654]:after {\n        content: \"\";\n        display: inline-block;\n        overflow: hidden;\n        width: 0;\n        height: 0;\n}\n}\n.cf[data-v-42ab7654]:before,\n.cf[data-v-42ab7654]:after {\n    content: \"\";\n    display: table;\n}\n.cf[data-v-42ab7654]:after {\n    clear: both;\n}\n.cf[data-v-42ab7654] {\n    zoom: 1;\n    clear: both;\n    padding: 0;\n}\nol#timeline .home[data-v-42ab7654] {\n    float: left;\n    text-align: right;\n    padding-right: 10px;\n}\nol#timeline .home p[data-v-42ab7654] {\n    text-align: right;\n    font-size: 12px;\n}\nol#timeline .home span.arrow[data-v-42ab7654] {\n    display: block;\n    width: 6px;\n    height: 8px;\n    background: url('../assets/match/tri_l.png') 0 0 no-repeat;\n    position: absolute;\n    right: -6px;\n    top: 5px;\n    background-size: cover;\n}\nol#timeline .away[data-v-42ab7654] {\n    float: right;\n    text-align: left;\n    padding-left: 10px;\n    line-height: 15px;\n}\nol#timeline .away span.arrow[data-v-42ab7654] {\n    display: block;\n    width: 6px;\n    height: 8px;\n    background: url('../assets/match/tri_r.png') 0 0 no-repeat;\n    position: absolute;\n    left: -6px;\n    top: 5px;\n    background-size: cover;\n}\nol#timeline .away p[data-v-42ab7654] {\n    text-align: left;\n}\nol#timeline .num[data-v-42ab7654] {\n    display: block;\n    width: 20px;\n    height: 20px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    margin: auto;\n    background: #16ac3a;\n    border-radius: 10px;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    font-weight: 400;\n    font-family: arial;\n    font-size: 10px;\n}\n.content .act[data-v-42ab7654] {\n    display: block;\n    width: 100%;\n    height: 20px;\n    color: #16ac3a;\n    text-align: center;\n    line-height: 20px;\n    font-weight: 400;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.content .dot[data-v-42ab7654] {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-radius: 4px;\n    background: #16ac3a;\n    margin: -5px auto 0 auto;\n}\n.content .dot_s[data-v-42ab7654] {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-radius: 4px;\n    background: #16ac3a;\n    margin: 0 auto 0 auto;\n}\nol#timeline > li[data-v-42ab7654]:first-child {\n    margin-top: 5px;\n}\n.icon_start[data-v-42ab7654] {\n    display: block;\n    margin: 0 auto;\n    width: 16px;\n    height: 16px;\n    background: url('../assets/match/icon_start.png') 0 0 no-repeat;\n    background-size: 100%;\n}\n.icon_end[data-v-42ab7654] {\n    display: block;\n    margin: 5px auto 0 auto;\n    width: 16px;\n    height: 16px;\n    background: url('../assets/match/icon_end.png') 0 0 no-repeat;\n    background-size: 100%;\n}\n.status[data-v-42ab7654] {\n    width: 96%;\n    margin: 0 auto;\n    padding: 0;\n}\n.status table[data-v-42ab7654] {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    word-break: keep-all;\n}\n.status table.head[data-v-42ab7654] {\n    border-bottom: 1px solid #ddd;\n    /*no*/\n}\n.status th[data-v-42ab7654],\n.status td[data-v-42ab7654] {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    border-collapse: collapse;\n    font-weight: 400;\n    font-size: 12px;\n    border: 0;\n}\n.status th[data-v-42ab7654] {\n    height: 40px;\n    line-height: 40px;\n}\n.status td[data-v-42ab7654] {\n    height: 16px;\n    line-height: 16px;\n    padding: 7px 0;\n    font-family: arial;\n    color: #333;\n}\n.status a[data-v-42ab7654] {\n    color: #333;\n}\n.status th img[data-v-42ab7654] {\n    width: 25px;\n    height: 25px;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n}\n.status .away[data-v-42ab7654] {\n    width: 43%;\n    text-align: right;\n    text-overflow: ellipsis;\n}\n.status .home[data-v-42ab7654] {\n    width: 43%;\n    text-align: left;\n    text-overflow: ellipsis;\n}\n.status .name[data-v-42ab7654] {\n    width: 14%;\n    text-align: center;\n}\n.status .rank[data-v-42ab7654] {\n    margin: 0 1px;\n    display: inline-block;\n    width: 77%;\n    height: 12px;\n    line-height: 12px;\n    background: #e9e9e9;\n    border-radius: 1px;\n    vertical-align: top;\n    margin-top: 2px;\n}\n.status .ranks[data-v-42ab7654] {\n    display: inline-block;\n    height: 12px;\n    line-height: 12px;\n    background: #16ac3a;\n    border-radius: 1px;\n    vertical-align: top;\n}\n.status .ranks_l[data-v-42ab7654] {\n    background: #888;\n}\nspan.text_lim[data-v-42ab7654] {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    line-break: strict;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    width: 90px;\n}\n.empty[data-v-42ab7654] {\n    padding-top: 36%;\n}\n.video[data-v-42ab7654] {\n    position: relative;\n}\n.video .mask[data-v-42ab7654] {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: url(https://dqdfiles.b0.upaiyun.com/app/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);\n    background-size: auto 20px;\n    z-index: 10000;\n    display: none;\n}\n.playing .mask[data-v-42ab7654] {\n    display: block;\n}\n.playing .media-holder-video[data-v-42ab7654] {\n    display: none;\n}\n\n/*code for css*/\nul.gif_container[data-v-42ab7654] {\n    min-height: 200px;\n    padding: 15px 10px 10px;\n    font-size: 0;\n}\nul.gif_container li[data-v-42ab7654] {\n    background: #FFFFFF;\n    display: inline-block;\n    width: 49%;\n    min-height: 100px;\n    margin-bottom: 8px;\n    overflow: hidden;\n    font-size: 0;\n    vertical-align: middle;\n}\nul.gif_container li[data-v-42ab7654]:nth-child(even) {\n    margin-left: 2%;\n}\nul.gif_container li .img_con[data-v-42ab7654] {\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% auto;\n    height: 128px;\n    width: 100%;\n}\nul.gif_container li .text_con[data-v-42ab7654] {\n    font-size: 12px;\n    margin: 0;\n    padding: 8px 8px 10px;\n    height: 52px;\n    position: relative;\n}\nul.gif_container li .text_con p[data-v-42ab7654] {\n    margin: 0;\n    height: 30px;\n    line-height: 15px;\n    text-align: left;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n}\nul.gif_container li a[data-v-42ab7654] {\n    display: block;\n    color: #333333;\n}\nul.gif_container li a[data-v-42ab7654]:visited {\n    color: #999999;\n}\n.total_view[data-v-42ab7654] {\n    position: absolute;\n    left: 8px;\n    bottom: 10px;\n    color: #16ac3a;\n}\n.comments[data-v-42ab7654] {\n    position: absolute;\n    right: 8px;\n    bottom: 10px;\n    color: #999999;\n}\n.gif[data-v-42ab7654] {\n    background-image: url('../assets/match/3x_gif_icon.png');\n    background-position: center center;\n    background-size: 20px 20px;\n    height: 20px;\n    width: 20px;\n    display: block;\n    z-index: 2000;\n}\n#app_news[data-v-42ab7654] {\n    background: #fff;\n}\n#app_news dd[data-v-42ab7654] {\n    padding: 0 14px;\n}\n#app_news dd[data-v-42ab7654] {\n    border-top: 1px solid #eeeeee;\n    /*no*/\n    height: 72px;\n}\n#app_news dd a[data-v-42ab7654] {\n    display: block;\n    color: #333;\n    height: 52px;\n    padding: 10px 0;\n    position: relative;\n}\n#app_news dd a[data-v-42ab7654]:visited {\n    color: #999999;\n}\n#app_news dd span[data-v-42ab7654] {\n    color: #aaa;\n    font-size: 11px;\n    position: absolute;\n    right: 0;\n    bottom: 9px;\n}\n#app_news dd .img_news[data-v-42ab7654] {\n    background-color: #e9e9e9;\n    width: 70px;\n    height: 52px;\n    float: left;\n    margin-right: 10px;\n    background-position: center center;\n    background-size: 100%;\n}\n#app_news dd .video_news[data-v-42ab7654] {\n    width: 70px;\n    height: 52px;\n    border-radius: 2px;\n    float: left;\n    margin-right: 12px;\n    background-position: center center;\n    background-size: 100%;\n}\n#app_news dd .video_icon[data-v-42ab7654] {\n    background: url(https://dqdfiles.b0.upaiyun.com/app/video.png) center center no-repeat rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    background-size: 20px 20px;\n}\n#app_news p[data-v-42ab7654] {\n    padding: 0 0 3px 0;\n    line-height: 18px;\n    margin: 0;\n    font-size: 14px;\n    position: relative;\n    bottom: 2px;\n}\n.loading[data-v-42ab7654] {\n    position: absolute;\n    width: 45px;\n    height: 45px;\n    background: url('../assets/match/loading-icon.png') no-repeat;\n    background-size: 100%;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    -webkit-animation: spin-data-v-42ab7654 1s linear infinite;\n            animation: spin-data-v-42ab7654 1s linear infinite;\n}\n@-webkit-keyframes spin {\n100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n}\n}\n@keyframes spin-data-v-42ab7654 {\n100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/play@80x80.0052e6a.png";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/video.5c02d28.png";

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAMAAABFaP0WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjRBQjk2RkFFQ0Q2MTFFNDg0RTg4Mjg4REU1OUM2MTYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjRBQjk2RjlFQ0Q2MTFFNDg0RTg4Mjg4REU1OUM2MTYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzU4NUI5REJFNEIxMTFFNEI2Q0I5MkRFM0Y4Q0I2RDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzU4NUI5RENFNEIxMTFFNEI2Q0I5MkRFM0Y4Q0I2RDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6XlUFwAAAABlBMVEUWrDoAAABaqTIbAAAADklEQVR42mJgAAGAAAMAAAYAAeBCEU4AAAAASUVORK5CYII="

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tri_l.ae7674f.png";

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tri_r.500c15b.png";

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_start.dfba46a.png";

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_end.036a353.png";

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3x_gif_icon.7314492.png";

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon.c67c881.png";

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(595);

var _values2 = _interopRequireDefault(_values);

var _AppMatchHighlights = __webpack_require__(666);

var _AppMatchHighlights2 = _interopRequireDefault(_AppMatchHighlights);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'overview',
    components: { AppMatchHighlights: _AppMatchHighlights2.default },
    props: ['matchId'],
    data: function data() {
        return {
            match_data: {
                statistics: {
                    team_A: {},
                    team_B: {}
                }
            },
            isLoaded: false,
            is_empty: false,
            empty_msg: '',
            statistics_show: false,
            events_show: false
        };
    },

    computed: {
        matchOverviewFormation: function matchOverviewFormation() {
            return this.$store.state.matchDetailStore.matchOverviewFormation;
        },
        highlightVideos: function highlightVideos() {
            return this.matchOverviewFormation.highlight || {};
        },
        highlightVisible: function highlightVisible() {
            var videos = (0, _values2.default)(this.highlightVideos);
            return videos.some(function (video) {
                return !!video;
            });
        }
    },
    created: function created() {
        if (this.matchOverviewFormation) {
            this.match_data = this.matchOverviewFormation;
            this.isLoaded = true;
            if (this.matchOverviewFormation.status === 'Fixture' || this.matchOverviewFormation.status === 'Postponed') {
                this.is_empty = true;
                this.empty_msg = this.$t('notPrepared');
                return;
            }
            if (this.matchOverviewFormation.statistics && this.matchOverviewFormation.statistics.team_A && this.matchOverviewFormation.statistics.team_B) {
                this.statistics_show = true;
            }
            if (this.matchOverviewFormation.events && this.matchOverviewFormation.events.length !== 0) {
                this.events_show = true;
            }
            if (!this.statistics_show && !this.events_show) {
                this.is_empty = true;
                this.empty_msg = this.$t('noData');
            }
        } else {
            this.isLoaded = true;
            this.is_empty = true;
            this.empty_msg = this.$t('noData');
        }
    },

    methods: {
        showDefault: function showDefault(team) {
            var defaultImg = __webpack_require__(629);
            event.target.src = defaultImg;
        },
        getHost: function getHost() {
            var hostname = location.hostname;
            var obj = {
                'localhost': 'https://api-test.allfootballapp.com',
                'test-n.allfootballapp.com': 'https://api-test.allfootballapp.com',
                'beta-n.allfootballapp.com': 'beta-api.allfootballapp.com',
                'n.allfootballapp.com': 'api.allfootballapp.com'
            };
            return obj[hostname];
        }
    }
};

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(670),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af2c084a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("20df18b9", content, true, {});

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "[data-v-af2c084a]{box-sizing:border-box}.match-highlights-container .title[data-v-af2c084a]{display:block;height:1.875rem;margin:0;padding:0 0 0 .9375rem;line-height:1.875rem;font-size:.9375rem;font-weight:400;background-color:#e2e4e6}.match-highlights-container .highlights-carousel[data-v-af2c084a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;padding:.8125rem .6875rem;background:#fff}.match-highlights-container .highlights-carousel .carousel-item[data-v-af2c084a]{width:100%;height:200px;cursor:pointer}.match-highlights-container .highlights-carousel .carousel-item[data-v-af2c084a]:nth-child(2){margin-top:.375rem}.match-highlights-container .highlights-carousel .playback-carousel-item.carousel-item[data-v-af2c084a]{background:url(\"https://img.724bifen.com/fastdfs0/M00/00/10/rBVwNGZ-IU6ANMzXAAGEDZW2jwk412.jpg\") no-repeat;background-size:cover}@media screen and (min-width:700px){.match-highlights-container .highlights-carousel[data-v-af2c084a]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.match-highlights-container .highlights-carousel .carousel-item[data-v-af2c084a]:nth-child(2){margin-top:0;margin-left:.375rem}}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/AppMatchHighlights.vue"],"names":[],"mappings":"AACA,kBACE,qBAAuB,CACxB,AACD,oDACE,cAAe,AACf,gBAAiB,AACjB,SAAU,AACV,uBAAyB,AACzB,qBAAsB,AACtB,mBAAqB,AACrB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kEACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,0BAA6B,AAC7B,eAAoB,CACrB,AACD,iFACE,WAAY,AACZ,aAAc,AACd,cAAgB,CACjB,AACD,8FACE,kBAAoB,CACrB,AACD,wGACE,2GAA4G,AAC5G,qBAAuB,CACxB,AACD,oCACA,kEACI,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAC/B,AACD,8FACI,aAAc,AACd,mBAAqB,CACxB,CACA","file":"AppMatchHighlights.vue","sourcesContent":["\n*[data-v-af2c084a] {\n  box-sizing: border-box;\n}\n.match-highlights-container .title[data-v-af2c084a] {\n  display: block;\n  height: 1.875rem;\n  margin: 0;\n  padding: 0 0 0 0.9375rem;\n  line-height: 1.875rem;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  background-color: #e2e4e6;\n}\n.match-highlights-container .highlights-carousel[data-v-af2c084a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  padding: 0.8125rem 0.6875rem;\n  background: #FFFFFF;\n}\n.match-highlights-container .highlights-carousel .carousel-item[data-v-af2c084a] {\n  width: 100%;\n  height: 200px;\n  cursor: pointer;\n}\n.match-highlights-container .highlights-carousel .carousel-item[data-v-af2c084a]:nth-child(2) {\n  margin-top: .375rem;\n}\n.match-highlights-container .highlights-carousel .playback-carousel-item.carousel-item[data-v-af2c084a] {\n  background: url('https://img.724bifen.com/fastdfs0/M00/00/10/rBVwNGZ-IU6ANMzXAAGEDZW2jwk412.jpg') no-repeat;\n  background-size: cover;\n}\n@media screen and (min-width: 700px) {\n.match-highlights-container .highlights-carousel[data-v-af2c084a] {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n.match-highlights-container .highlights-carousel .carousel-item[data-v-af2c084a]:nth-child(2) {\n    margin-top: 0;\n    margin-left: .375rem;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        data: {
            type: Object,
            default: function _default() {
                return {
                    highlight_url: '',
                    playback_url: ''
                };
            }
        }
    },

    methods: {
        handlePlayVideo: function handlePlayVideo(url) {
            window.open(url, '_blank');
        }
    }
};

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-highlights-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sorotan & Putar Ulang")]), _vm._v(" "), _c('div', {
    staticClass: "highlights-carousel"
  }, [(_vm.data.highlight_url) ? _c('iframe', {
    staticClass: "carousel-item",
    attrs: {
      "src": _vm.data.highlight_url,
      "frameborder": "0",
      "fs": "0",
      "modestbranding": "1",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;fs;modestbranding",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.playback_url) ? _c('div', {
    staticClass: "playback-carousel-item carousel-item",
    on: {
      "click": function($event) {
        _vm.handlePlayVideo(_vm.data.playback_url)
      }
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "overview"
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), (_vm.is_empty) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v(_vm._s(_vm.empty_msg))]) : _c('div', {
    staticClass: "events"
  }, [(_vm.highlightVisible) ? _c('AppMatchHighlights', {
    attrs: {
      "data": _vm.highlightVideos
    }
  }) : _vm._e(), _vm._v(" "), (_vm.events_show) ? [_c('section', [_vm._v(_vm._s(_vm.$t('events')))]), _vm._v(" "), _c('div', {
    staticClass: "content content_p"
  }, [_c('span', {
    staticClass: "icon_start"
  }), _vm._v(" "), _c('ol', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.match_data.events), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "cf"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.minute))]), _vm._v(" "), (item.teamAEvents.length !== 0) ? _c('div', {
      staticClass: "home"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _vm._l((item.teamAEvents), function(team, index) {
      return _c('p', {
        key: index
      }, [_c('span', {
        staticClass: "person"
      }, [_c('span', {
        staticClass: "text_lim"
      }, [_vm._v(" " + _vm._s(team.person) + " ")]), _vm._v(" "), _c('img', {
        attrs: {
          "src": _vm.getImgSrc(team.event_pic)
        }
      })])])
    })], 2) : _vm._e(), _vm._v(" "), (item.teamBEvents.length !== 0) ? _c('div', {
      staticClass: "away"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _vm._l((item.teamBEvents), function(team, index) {
      return _c('p', {
        key: index
      }, [_c('span', {
        staticClass: "person"
      }, [_c('img', {
        attrs: {
          "src": _vm.getImgSrc(team.event_pic)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text_lim"
      }, [_vm._v(" " + _vm._s(team.person) + " ")])])])
    })], 2) : _vm._e()])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon_end"
  })]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_c('div', {
    staticClass: "show_main"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(672),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('goal')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(673),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('penalty')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(674),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('penaltySaved')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(675),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('ownGoal')))]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(676),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('assist')))])])])] : _vm._e(), _vm._v(" "), (_vm.statistics_show) ? [_c('section', [_vm._v(_vm._s(_vm.$t('statistics')))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('table', {
    staticClass: "head"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "away"
  }, [_c('span', {
    staticClass: "team"
  }, [_c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.match_data.statistics.team_A.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.match_data.statistics.team_A.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "home"
  }, [_c('span', {
    staticClass: "team"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.match_data.statistics.team_B.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.match_data.statistics.team_B.name))])])])])])]), _vm._v(" "), (_vm.statistics_show) ? _c('table', [_c('tbody', _vm._l((_vm.match_data.statistics.list), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "away"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.team_A.value))]), _vm._v(" "), _c('span', {
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "ranks",
      class: item.team_A.class,
      style: ({
        width: item.team_A.per + '%'
      })
    })])]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "home"
    }, [_c('span', {
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "ranks",
      class: item.team_B.class,
      style: ({
        width: item.team_B.per + '%'
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.team_B.value))])])])
  }))]) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cf"
  }, [_c('span', {
    staticClass: "dot_s"
  })])
}]}

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_goal.8578830.png";

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_point.5156b91.png";

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_point_1.849dce5.png";

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_w.8d9879e.png";

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_a.a6c0ac3.png";

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(692),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f6bbe8e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(679);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("578f567f", content, true, {});

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "a[data-v-5f6bbe8e]{color:#000}body[data-v-5f6bbe8e],html[data-v-5f6bbe8e]{height:100%}body[data-v-5f6bbe8e]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background:#eff1f4}div[data-v-5f6bbe8e],li[data-v-5f6bbe8e],ol[data-v-5f6bbe8e],p[data-v-5f6bbe8e],ul[data-v-5f6bbe8e]{margin:0;padding:0}body[data-v-5f6bbe8e]{margin:0;padding:0;font-size:12px;-webkit-font-smoothing:antialiased;position:relative}nav[data-v-5f6bbe8e]{font-size:14px;height:30px;line-height:30px;font-weight:700;color:#333;background:#e2e4e6;text-align:left;padding-left:16px}nav a[data-v-5f6bbe8e]{font-size:12px;float:right;margin-right:5px;color:#16ac3a;text-decoration:none}.container[data-v-5f6bbe8e]{position:relative}.forecast[data-v-5f6bbe8e]{top:5px;text-align:center;width:100%;font-size:14px;color:#999;margin-bottom:-15px;background:#eff1f4;padding-top:5px;margin-top:0}ul.vote_con[data-v-5f6bbe8e]{margin:0;height:120px;padding:15px 10%;background:#eff1f4;list-style:none}ul.vote_con li[data-v-5f6bbe8e]{width:33.3333333333%;float:left;position:relative}ul.vote_con li[data-v-5f6bbe8e]:first-child{left:-3%}ul.vote_con li[data-v-5f6bbe8e]:last-child{right:-3%}ul .vote_view[data-v-5f6bbe8e]{position:relative;width:86%;height:112px;margin:0 auto}ul .vote_view .bottom_vote[data-v-5f6bbe8e]{text-align:center;color:#fff;position:relative;height:30px;line-height:30px;font-size:14px;width:100%;border-bottom-left-radius:4px;border-bottom-right-radius:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}ul .vote_view .vote-label[data-v-5f6bbe8e]{color:#999;text-align:center;width:100%;margin:0;font-size:12px;height:35px;line-height:35px;white-space:nowrap}ul .vote_view div img[data-v-5f6bbe8e]{position:relative;bottom:1px;height:16px;width:16px;vertical-align:middle}ul .vote_view b[data-v-5f6bbe8e]{display:block;font-size:16px;color:#fff}ul .bottom_vote span[data-v-5f6bbe8e]{display:inline-block;margin-right:4px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDMkI5M0YzRUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDMkI5M0Y0RUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjFFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjJFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZbxI3AAAA+klEQVR42mL8//8/AwnAAIi9gHglEN8lSgfIAhLwjv8Q8AmII4nRQ4rhrED85D8qsCWkj4mE4JEDYkE0sU5CmkixQAmIudDELIFYlVoW4DJIhloWmGBLI0D8gxoWgILGB4v4FyB+SA0L+oBYFIv4dSB+hk8jC5RWB2JWHCknCYiDcej/A8RaOBz6G4hvgtJq+X/agXJGIPEVS/KjFvgB8to/BtqB00zQsKIV2MzEQFtwgJYW3Abic7S04CAQ/6WlBRtJLYtIAR+A+BgtLQAFzztaWrAXubBjo7Lh/9Et+ENlCx4A8TXk0jQDiPuBmJ0Khn8C4kxkAYAAAwC3wR7EkrY5PgAAAABJRU5ErkJggg==);background-position:50%;background-size:12px 12px;background-repeat:no-repeat;height:12px;width:12px;vertical-align:middle;position:relative;bottom:1px}ul .bottom_vote span.voted[data-v-5f6bbe8e]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjgwRkYzQkNDRUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjgwRkYzQkNERUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjVFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjZFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4U4m8kAAAA6klEQVR42rSWywrCMBBF07QKWhUVRNy4EkXdufL/P0EXfoHShRXF+gC19Q5EKcGqgZkLh5ahySEhGeplWaYc0gBdsAGnfwZ4joI56IA7WID1rwHaYXL6tm7eAzADbU5BBZSs2oRTUAW+VWuBkEsQflkZi6BZUH9wCHxzPO3QabpwCKag/KGegOu3gYF51uhOFOxvH/QKxqe5o2uHLlhCF22Al7GSyYq2aKjkMtJmKVLZSwsirWQTSwqonR8kBTFtv6Qgcu1FLrmBnaQgNhIxwTbf7LS0IGWe/AyO+W66NO2YYyWvv413ngIMAJZ8LcWM3z54AAAAAElFTkSuQmCC)}ul .vote_view .vote_box[data-v-5f6bbe8e]{position:relative;left:0;height:72px;width:100%;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.05);overflow:hidden}#away .progress[data-v-5f6bbe8e]{background:#f12b2b}#away .bottom_vote[data-v-5f6bbe8e]{background:#cd2525}#away .clicked[data-v-5f6bbe8e]{color:#dc6767}#home .progress[data-v-5f6bbe8e]{background:#49c867}#home .bottom_vote[data-v-5f6bbe8e]{background:#3eaa58}#home .clicked[data-v-5f6bbe8e]{color:#78c48a}#draw .progress[data-v-5f6bbe8e]{background:#1d9ff9}#draw .bottom_vote[data-v-5f6bbe8e]{background:#1987d4}#draw .clicked[data-v-5f6bbe8e]{color:#5eabe1}.progress_con[data-v-5f6bbe8e]{position:relative;width:100%;height:100%}.progress[data-v-5f6bbe8e]{position:absolute;border-top-left-radius:4px;border-top-right-radius:4px;bottom:0;width:100%;height:20px;line-height:20px;z-index:1;text-align:center;color:#151515;font-weight:700;transition:background .25s ease}.content.preview[data-v-5f6bbe8e]{background:#eff1f4;margin:0}.content iframe[data-v-5f6bbe8e]{width:100%;border:none;margin:0}.content.overview p[data-v-5f6bbe8e]{background:#eff1f4;margin:0;width:100%;position:absolute;bottom:0;top:50px;font-size:14px;line-height:220px;color:#999;text-align:center}#mask[data-v-5f6bbe8e]{position:fixed;margin:auto;top:180px;left:0;right:0;height:40px;line-height:40px;text-align:center}#mask span[data-v-5f6bbe8e]{font-size:14px;padding:10px 16px;text-align:center;line-height:25px;border-radius:4px;color:#fff;background-color:#383a3c;display:inline-block;max-width:67%}input[data-v-5f6bbe8e]{border:0;margin:0;padding:0;width:0;height:0}nav.tab[data-v-5f6bbe8e]{text-align:center;display:block;width:100%;background:#eff1f4;height:auto;padding:16px 0;line-height:0}nav.tab ul[data-v-5f6bbe8e]{display:inline-block;border:1px solid #16ac3a;font-size:14px;border-radius:2px;width:64%;font-size:0;list-style:none;padding:0;height:28px}nav.tab li[data-v-5f6bbe8e]{list-style:none;display:inline-block;width:50%;font-size:14px;line-height:28px;height:28px;color:#16ac3a}nav.tab li a[data-v-5f6bbe8e]{display:block;color:inherit;font-size:inherit;text-align:inherit;width:100%;padding:0;margin:0}nav.tab li.current[data-v-5f6bbe8e]{background:#16ac3a;color:#fff}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/matchAnalysis.vue"],"names":[],"mappings":"AACA,mBACI,UAAY,CACf,AACD,4CAEI,WAAa,CAChB,AACD,sBAEI,sDAA4D,AAC5D,kBAAoB,CACvB,AACD,oGAKI,SAAU,AACV,SAAW,CACd,AACD,sBACI,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,mCAAoC,AACpC,iBAAmB,CACtB,AACD,qBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,uBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,oBAAsB,CACzB,AACD,4BACI,iBAAmB,CACtB,AACD,2BACI,QAAS,AACT,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,WAAe,AACf,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,YAAc,CACjB,AAED,6BACI,SAAU,AACV,aAAc,AACd,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CACpB,AACD,gCACI,qBAAsB,AACtB,WAAY,AACZ,iBAAmB,CACtB,AACD,4CACI,QAAU,CACb,AACD,2CACI,SAAW,CACd,AACD,+BACI,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,aAAe,CAClB,AACD,4CACI,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,8BAA+B,AAC/B,+BAAgC,AAChC,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,2CACI,WAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACvB,AACD,uCACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,qBAAuB,CAC1B,AACD,iCACI,cAAe,AACf,eAAgB,AAChB,UAAY,CACf,AACD,sCACI,qBAAsB,AACtB,iBAAkB,AAClB,yjDAA0jD,AAC1jD,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,kBAAmB,AACnB,UAAY,CACf,AACD,4CACI,giDAAkiD,CACriD,AACD,yCACI,kBAAmB,AACnB,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,6CAAoD,AACpD,eAAiB,CACpB,AACD,iCACI,kBAAoB,CACvB,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,aAAe,CAClB,AACD,iCACI,kBAAoB,CACvB,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,aAAe,CAClB,AACD,iCACI,kBAAoB,CACvB,AACD,oCACI,kBAAoB,CACvB,AACD,gCACI,aAAe,CAClB,AACD,+BACI,kBAAmB,AACnB,WAAY,AACZ,WAAa,CAChB,AACD,2BACI,kBAAmB,AACnB,2BAA4B,AAC5B,4BAA6B,AAC7B,SAAU,AACV,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,UAAW,AACX,kBAAmB,AACnB,cAAe,AACf,gBAAkB,AAClB,+BAAkC,CACrC,AACD,kCACI,mBAAoB,AACpB,QAAU,CACb,AACD,iCACI,WAAY,AACZ,YAAa,AACb,QAAU,CACb,AACD,qCACI,mBAAoB,AACpB,SAAU,AACV,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,eAAgB,AAChB,kBAAmB,AACnB,WAAY,AACZ,iBAAmB,CACtB,AACD,uBACI,eAAgB,AAChB,YAAa,AACb,UAAW,AACX,OAAQ,AACR,QAAS,AACT,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACtB,AACD,4BACI,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,yBAA0B,AAC1B,qBAAsB,AACtB,aAAe,CAClB,AAGD,uBACI,SAAU,AACV,SAAU,AACV,UAAW,AACX,QAAS,AACT,QAAU,CACb,AACD,yBACI,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,YAAa,AACb,eAAgB,AAChB,aAAe,CAClB,AACD,4BACI,qBAAsB,AACtB,yBAA0B,AAE1B,eAAgB,AAChB,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,gBAAiB,AACjB,UAAW,AACX,WAAa,CAChB,AACD,4BACI,gBAAiB,AACjB,qBAAsB,AACtB,UAAW,AACX,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,aAAe,CAClB,AACD,8BACI,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,WAAY,AACZ,UAAW,AACX,QAAU,CACb,AACD,oCACI,mBAAoB,AACpB,UAAY,CACf","file":"matchAnalysis.vue","sourcesContent":["\na[data-v-5f6bbe8e] {\n    color: #000;\n}\nhtml[data-v-5f6bbe8e],\nbody[data-v-5f6bbe8e] {\n    height: 100%;\n}\nbody[data-v-5f6bbe8e] {\n    /*设置英文字体*/\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background: #eff1f4;\n}\np[data-v-5f6bbe8e],\ndiv[data-v-5f6bbe8e],\nul[data-v-5f6bbe8e],\nol[data-v-5f6bbe8e],\nli[data-v-5f6bbe8e]{\n    margin: 0;\n    padding: 0;\n}\nbody[data-v-5f6bbe8e] {\n    margin: 0;\n    padding: 0;\n    font-size: 12px;\n    -webkit-font-smoothing: antialiased;\n    position: relative;\n}\nnav[data-v-5f6bbe8e] {\n    font-size: 14px;\n    height: 30px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #333;\n    background: #e2e4e6;\n    text-align: left;\n    padding-left: 16px;\n}\nnav a[data-v-5f6bbe8e] {\n    font-size: 12px;\n    float: right;\n    margin-right: 5px;\n    color: #16ac3a;\n    text-decoration: none;\n}\n.container[data-v-5f6bbe8e] {\n    position: relative;\n}\n.forecast[data-v-5f6bbe8e] {\n    top: 5px;\n    text-align: center;\n    width: 100%;\n    font-size: 14px;\n    color: #999999;\n    margin-bottom: -15px;\n    background: #eff1f4;\n    padding-top: 5px;\n    margin-top: 0;\n}\n/*预测样式*/\nul.vote_con[data-v-5f6bbe8e] {\n    margin: 0;\n    height: 120px;\n    padding: 15px 10%;\n    background: #eff1f4;\n    list-style: none;\n}\nul.vote_con li[data-v-5f6bbe8e] {\n    width: 33.3333333333%;\n    float: left;\n    position: relative;\n}\nul.vote_con li[data-v-5f6bbe8e]:first-child {\n    left: -3%;\n}\nul.vote_con li[data-v-5f6bbe8e]:last-child {\n    right: -3%;\n}\nul .vote_view[data-v-5f6bbe8e] {\n    position: relative;\n    width: 86%;\n    height: 112px;\n    margin: 0 auto;\n}\nul .vote_view .bottom_vote[data-v-5f6bbe8e] {\n    text-align: center;\n    color: #fff;\n    position: relative;\n    height: 30px;\n    line-height: 30px;\n    font-size: 14px;\n    width: 100%;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\nul .vote_view .vote-label[data-v-5f6bbe8e] {\n    color: #999999;\n    text-align: center;\n    width: 100%;\n    margin: 0;\n    font-size: 12px;\n    height: 35px;\n    line-height: 35px;\n    white-space: nowrap;\n}\nul .vote_view div img[data-v-5f6bbe8e] {\n    position: relative;\n    bottom: 1px;\n    height: 16px;\n    width: 16px;\n    vertical-align: middle;\n}\nul .vote_view b[data-v-5f6bbe8e] {\n    display: block;\n    font-size: 16px;\n    color: #fff;\n}\nul .bottom_vote span[data-v-5f6bbe8e] {\n    display: inline-block;\n    margin-right: 4px;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDMkI5M0YzRUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDMkI5M0Y0RUQwQzExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjFFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjJFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZbxI3AAAA+klEQVR42mL8//8/AwnAAIi9gHglEN8lSgfIAhLwjv8Q8AmII4nRQ4rhrED85D8qsCWkj4mE4JEDYkE0sU5CmkixQAmIudDELIFYlVoW4DJIhloWmGBLI0D8gxoWgILGB4v4FyB+SA0L+oBYFIv4dSB+hk8jC5RWB2JWHCknCYiDcej/A8RaOBz6G4hvgtJq+X/agXJGIPEVS/KjFvgB8to/BtqB00zQsKIV2MzEQFtwgJYW3Abic7S04CAQ/6WlBRtJLYtIAR+A+BgtLQAFzztaWrAXubBjo7Lh/9Et+ENlCx4A8TXk0jQDiPuBmJ0Khn8C4kxkAYAAAwC3wR7EkrY5PgAAAABJRU5ErkJggg==);\n    background-position: center center;\n    background-size: 12px 12px;\n    background-repeat: no-repeat;\n    height: 12px;\n    width: 12px;\n    vertical-align: middle;\n    position: relative;\n    bottom: 1px;\n}\nul .bottom_vote span.voted[data-v-5f6bbe8e] {\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjgwRkYzQkNDRUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjgwRkYzQkNERUQ0MjExRTZBNTAxRTZDMDcwQ0ExQjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0MyQjkzRjVFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0MyQjkzRjZFRDBDMTFFNkE1MDFFNkMwNzBDQTFCM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4U4m8kAAAA6klEQVR42rSWywrCMBBF07QKWhUVRNy4EkXdufL/P0EXfoHShRXF+gC19Q5EKcGqgZkLh5ahySEhGeplWaYc0gBdsAGnfwZ4joI56IA7WID1rwHaYXL6tm7eAzADbU5BBZSs2oRTUAW+VWuBkEsQflkZi6BZUH9wCHxzPO3QabpwCKag/KGegOu3gYF51uhOFOxvH/QKxqe5o2uHLlhCF22Al7GSyYq2aKjkMtJmKVLZSwsirWQTSwqonR8kBTFtv6Qgcu1FLrmBnaQgNhIxwTbf7LS0IGWe/AyO+W66NO2YYyWvv413ngIMAJZ8LcWM3z54AAAAAElFTkSuQmCC);\n}\nul .vote_view .vote_box[data-v-5f6bbe8e] {\n    position: relative;\n    left: 0;\n    height: 72px;\n    width: 100%;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    overflow: hidden;\n}\n#away .progress[data-v-5f6bbe8e] {\n    background: #f12b2b;\n}\n#away .bottom_vote[data-v-5f6bbe8e] {\n    background: #cd2525;\n}\n#away .clicked[data-v-5f6bbe8e] {\n    color: #dc6767;\n}\n#home .progress[data-v-5f6bbe8e] {\n    background: #49c867;\n}\n#home .bottom_vote[data-v-5f6bbe8e] {\n    background: #3eaa58;\n}\n#home .clicked[data-v-5f6bbe8e] {\n    color: #78c48a;\n}\n#draw .progress[data-v-5f6bbe8e] {\n    background: #1d9ff9;\n}\n#draw .bottom_vote[data-v-5f6bbe8e] {\n    background: #1987d4;\n}\n#draw .clicked[data-v-5f6bbe8e] {\n    color: #5eabe1;\n}\n.progress_con[data-v-5f6bbe8e] {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n.progress[data-v-5f6bbe8e] {\n    position: absolute;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    bottom: 0;\n    width: 100%;\n    height: 20px;\n    line-height: 20px;\n    z-index: 1;\n    text-align: center;\n    color: #151515;\n    font-weight: bold;\n    transition: background 250ms ease;\n}\n.content.preview[data-v-5f6bbe8e] {\n    background: #eff1f4;\n    margin: 0;\n}\n.content iframe[data-v-5f6bbe8e] {\n    width: 100%;\n    border: none;\n    margin: 0;\n}\n.content.overview p[data-v-5f6bbe8e] {\n    background: #eff1f4;\n    margin: 0;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    top: 50px;\n    font-size: 14px;\n    line-height: 220px;\n    color: #999;\n    text-align: center;\n}\n#mask[data-v-5f6bbe8e] {\n    position: fixed;\n    margin: auto;\n    top: 180px;\n    left: 0;\n    right: 0;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n}\n#mask span[data-v-5f6bbe8e] {\n    font-size: 14px;\n    padding: 10px 16px;\n    text-align: center;\n    line-height: 25px;\n    border-radius: 4px;\n    color: #fff;\n    background-color: #383a3c;\n    display: inline-block;\n    max-width: 67%;\n}\n\n/*未知模块*/\ninput[data-v-5f6bbe8e] {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n}\nnav.tab[data-v-5f6bbe8e] {\n    text-align: center;\n    display: block;\n    width: 100%;\n    background: #eff1f4;\n    height: auto;\n    padding: 16px 0;\n    line-height: 0;\n}\nnav.tab ul[data-v-5f6bbe8e] {\n    display: inline-block;\n    border: 1px solid #16ac3a;\n    /*no*/\n    font-size: 14px;\n    border-radius: 2px;\n    width: 64%;\n    font-size: 0;\n    list-style: none;\n    padding: 0;\n    height: 28px;\n}\nnav.tab li[data-v-5f6bbe8e] {\n    list-style: none;\n    display: inline-block;\n    width: 50%;\n    font-size: 14px;\n    line-height: 28px;\n    height: 28px;\n    color: #16ac3a;\n}\nnav.tab li a[data-v-5f6bbe8e] {\n    display: block;\n    color: inherit;\n    font-size: inherit;\n    text-align: inherit;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n}\nnav.tab li.current[data-v-5f6bbe8e] {\n    background: #16ac3a;\n    color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fingerprintjs = __webpack_require__(681);

var _fingerprintjs2 = _interopRequireDefault(_fingerprintjs);

var _pastGames = __webpack_require__(682);

var _pastGames2 = _interopRequireDefault(_pastGames);

var _skeleton = __webpack_require__(688);

var _skeleton2 = _interopRequireDefault(_skeleton);

var _axios = __webpack_require__(185);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            isShowOverview: false,
            tabShow: 'preview',
            voteData: {
                data: [{ id: 1, name: 'Home', num: 0, percent: 0 }, { id: 2, name: 'Draw', num: 0, percent: 0 }, { id: 3, name: 'Away', num: 0, percent: 0 }],
                total_num: 0,
                select_opt: []
            },
            analysisData: null,
            animateFinished: false,
            elAnalysisHtml: '',
            elOverviewHtml: '',
            homeImgSrc: '',
            awayImgSrc: '',
            UUID: ''
        };
    },

    props: ['matchId'],
    components: {
        PastGames: _pastGames2.default,
        Skeleton: _skeleton2.default
    },
    computed: {
        matchAnalysisFormation: function matchAnalysisFormation() {
            return this.$store.state.matchDetailStore.matchAnalysisFormation;
        }
    },
    created: function created() {
        this.homeImgSrc = this.matchAnalysisFormation.team_A_logo || '';
        this.awayImgSrc = this.matchAnalysisFormation.team_B_logo || '';
        this.analysisData = this.matchAnalysisFormation || null;
    },
    mounted: function mounted() {
        var _this = this;

        this.UUID = 'CA' + new _fingerprintjs2.default({ canvas: true }).get();

        _axios2.default.get('/v2/vote/result/match/' + this.matchId, {
            headers: {
                uuid: this.UUID
            },
            params: {
                language: 'id-id'
            }
        }).then(function (res) {
            var data = res.data;
            if (data.errCode === 0) {
                _this.voteData = data.data;
                _this.votePercent(_this.voteData);
            }
        }).catch(function () {
            console.log('出错了');
        });
    },

    watch: {
        elOverviewHtml: function elOverviewHtml() {
            this.resizeIframeHeight();
        }
    },
    methods: {
        votePercent: function votePercent(voteData) {
            var percents = [];
            var offsetPercent = 0;

            voteData.data.forEach(function (item) {
                var per = voteData.total_num ? item.num / voteData.total_num * 100 : 0;
                item.percent = Math.round(per);
                offsetPercent += item.percent;

                percents.push(per - Math.floor(per));
            });
            if (!offsetPercent) {
                return;
            }
            if (offsetPercent > 100) {
                var i = percents.indexOf(Math.min.apply(null, percents));
                voteData.data[i].percent -= 1;
            } else if (offsetPercent < 100) {
                var _i = percents.indexOf(Math.max.apply(null, percents));
                voteData.data[_i].percent += 1;
            }
        },
        height: function height(num) {
            if (!this.voteData.total_num) {
                return 20;
            }
            return Math.floor(num / this.voteData.total_num * 52 + 20);
        },
        votable: function votable() {
            if (this.isMatchStart()) {
                return false;
            }
            if (this.voteData.select_opt && this.voteData.select_opt.length) {
                return false;
            }

            return true;
        },
        voted: function voted(id) {
            if (this.voteData.select_opt && this.voteData.select_opt.some(function (item) {
                return +item === id;
            })) {
                return true;
            }
            return false;
        },
        vote: function vote(id) {
            var _this2 = this;

            if (this.votable() && !this.voted(id)) {
                _axios2.default.get('/v2/vote/match/' + this.matchId + '?match_id=' + this.matchId + '&opt_id=' + id, {
                    headers: {
                        uuid: this.UUID
                    },
                    params: {
                        language: 'id-id'
                    }
                }).then(function (res) {
                    if (res.status !== 200) {
                        return;
                    }
                    var data = res.data;
                    if (!data.errCode) {
                        _this2.voteData.select_opt.push(id);
                        _this2.voteData.data[id - 1].num++;
                        _this2.voteData.total_num++;
                        _this2.votePercent(_this2.voteData);
                    }
                });
            }
        },
        resizeIframeHeight: function resizeIframeHeight() {
            var frame = document.getElementById('overviewFrame');
            if (!this.elOverviewHtml || !frame) {
                return;
            }

            var iframeDoc = frame.contentDocument || frame.contentWindow.document;

            iframeDoc.open();
            iframeDoc.write(this.elOverviewHtml);
            iframeDoc.close();

            frame.style.height = iframeDoc.body.scrollHeight + 'px';
        },
        isMatchStart: function isMatchStart() {
            var voteData = this.voteData;
            if (voteData && voteData.start_time) {
                var date = new Date(voteData.start_time.replace(/-/g, '/')).getTime();
                var diffMin = new Date().getTimezoneOffset();
                date = date - diffMin * 60 * 1000;
                var nowDate = new Date().getTime();

                return nowDate >= date;
            }
            return true;
        }
    }
};

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* fingerprintJS 0.5.3 - Fast browser fingerprint library
* https://github.com/Valve/fingerprintjs
* Copyright (c) 2013 Valentin Vasilyev (valentin.vasilyev@outlook.com)
* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*/

;(function (name, context, definition) {
  if (typeof module !== 'undefined' && module.exports) { module.exports = definition(); }
  else if (true) { !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
  else { context[name] = definition(); }
})('Fingerprint', this, function () {
  'use strict';
  
  var Fingerprint = function (options) {
    var nativeForEach, nativeMap;
    nativeForEach = Array.prototype.forEach;
    nativeMap = Array.prototype.map;

    this.each = function (obj, iterator, context) {
      if (obj === null) {
        return;
      }
      if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === {}) return;
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (iterator.call(context, obj[key], key, obj) === {}) return;
          }
        }
      }
    };

    this.map = function(obj, iterator, context) {
      var results = [];
      // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.
      if (obj == null) return results;
      if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
      this.each(obj, function(value, index, list) {
        results[results.length] = iterator.call(context, value, index, list);
      });
      return results;
    };

    if (typeof options == 'object'){
      this.hasher = options.hasher;
      this.screen_resolution = options.screen_resolution;
      this.canvas = options.canvas;
      this.ie_activex = options.ie_activex;
    } else if(typeof options == 'function'){
      this.hasher = options;
    }
  };

  Fingerprint.prototype = {
    get: function(){
      var keys = [];
      keys.push(navigator.userAgent);
      keys.push(navigator.language);
      keys.push(screen.colorDepth);
      if (this.screen_resolution) {
        var resolution = this.getScreenResolution();
        if (typeof resolution !== 'undefined'){ // headless browsers, such as phantomjs
          keys.push(this.getScreenResolution().join('x'));
        }
      }
      keys.push(new Date().getTimezoneOffset());
      keys.push(this.hasSessionStorage());
      keys.push(this.hasLocalStorage());
      keys.push(!!window.indexedDB);
      //body might not be defined at this point or removed programmatically
      if(document.body){
        keys.push(typeof(document.body.addBehavior));
      } else {
        keys.push(typeof undefined);
      }
      keys.push(typeof(window.openDatabase));
      keys.push(navigator.cpuClass);
      keys.push(navigator.platform);
      keys.push(navigator.doNotTrack);
      keys.push(this.getPluginsString());
      if(this.canvas && this.isCanvasSupported()){
        keys.push(this.getCanvasFingerprint());
      }
      if(this.hasher){
        return this.hasher(keys.join('###'), 31);
      } else {
        return this.murmurhash3_32_gc(keys.join('###'), 31);
      }
    },

    /**
     * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
     * 
     * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
     * @see http://github.com/garycourt/murmurhash-js
     * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
     * @see http://sites.google.com/site/murmurhash/
     * 
     * @param {string} key ASCII only
     * @param {number} seed Positive integer only
     * @return {number} 32-bit positive integer hash 
     */

    murmurhash3_32_gc: function(key, seed) {
      var remainder, bytes, h1, h1b, c1, c2, k1, i;
      
      remainder = key.length & 3; // key.length % 4
      bytes = key.length - remainder;
      h1 = seed;
      c1 = 0xcc9e2d51;
      c2 = 0x1b873593;
      i = 0;
      
      while (i < bytes) {
          k1 = 
            ((key.charCodeAt(i) & 0xff)) |
            ((key.charCodeAt(++i) & 0xff) << 8) |
            ((key.charCodeAt(++i) & 0xff) << 16) |
            ((key.charCodeAt(++i) & 0xff) << 24);
        ++i;
        
        k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

        h1 ^= k1;
            h1 = (h1 << 13) | (h1 >>> 19);
        h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
        h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
      }
      
      k1 = 0;
      
      switch (remainder) {
        case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
        case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
        case 1: k1 ^= (key.charCodeAt(i) & 0xff);
        
        k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
        h1 ^= k1;
      }
      
      h1 ^= key.length;

      h1 ^= h1 >>> 16;
      h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
      h1 ^= h1 >>> 13;
      h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
      h1 ^= h1 >>> 16;

      return h1 >>> 0;
    },

    // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
    hasLocalStorage: function () {
      try{
        return !!window.localStorage;
      } catch(e) {
        return true; // SecurityError when referencing it means it exists
      }
    },
    
    hasSessionStorage: function () {
      try{
        return !!window.sessionStorage;
      } catch(e) {
        return true; // SecurityError when referencing it means it exists
      }
    },

    isCanvasSupported: function () {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    },

    isIE: function () {
      if(navigator.appName === 'Microsoft Internet Explorer') {
        return true;
      } else if(navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)){// IE 11
        return true;
      }
      return false;
    },

    getPluginsString: function () {
      if(this.isIE() && this.ie_activex){
        return this.getIEPluginsString();
      } else {
        return this.getRegularPluginsString();
      }
    },

    getRegularPluginsString: function () {
      return this.map(navigator.plugins, function (p) {
        var mimeTypes = this.map(p, function(mt){
          return [mt.type, mt.suffixes].join('~');
        }).join(',');
        return [p.name, p.description, mimeTypes].join('::');
      }, this).join(';');
    },

    getIEPluginsString: function () {
      if(window.ActiveXObject){
        var names = ['ShockwaveFlash.ShockwaveFlash',//flash plugin
          'AcroPDF.PDF', // Adobe PDF reader 7+
          'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
          'QuickTime.QuickTime', // QuickTime
          // 5 versions of real players
          'rmocx.RealPlayer G2 Control',
          'rmocx.RealPlayer G2 Control.1',
          'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
          'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
          'RealPlayer',
          'SWCtl.SWCtl', // ShockWave player
          'WMPlayer.OCX', // Windows media player
          'AgControl.AgControl', // Silverlight
          'Skype.Detection'];
          
        // starting to detect plugins in IE
        return this.map(names, function(name){
          try{
            new ActiveXObject(name);
            return name;
          } catch(e){
            return null;
          }
        }).join(';');
      } else {
        return ""; // behavior prior version 0.5.0, not breaking backwards compat.
      }
    },

    getScreenResolution: function () {
      return [screen.height, screen.width];
    },

    getCanvasFingerprint: function () {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      // https://www.browserleaks.com/canvas#how-does-it-work
      var txt = 'http://valve.github.io';
      ctx.textBaseline = "top";
      ctx.font = "14px 'Arial'";
      ctx.textBaseline = "alphabetic";
      ctx.fillStyle = "#f60";
      ctx.fillRect(125,1,62,20);
      ctx.fillStyle = "#069";
      ctx.fillText(txt, 2, 15);
      ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
      ctx.fillText(txt, 4, 17);
      return canvas.toDataURL();
    }
  };


  return Fingerprint;

});


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(687),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8cc0d072",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(684);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("31158a5e", content, true, {});

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "a[data-v-8cc0d072]{color:#000}body[data-v-8cc0d072],html[data-v-8cc0d072]{height:100%}body[data-v-8cc0d072]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background:#eff1f4}div[data-v-8cc0d072],li[data-v-8cc0d072],ol[data-v-8cc0d072],p[data-v-8cc0d072],ul[data-v-8cc0d072]{margin:0;padding:0}body[data-v-8cc0d072]{margin:0;padding:0;-webkit-font-smoothing:antialiased;position:relative}nav[data-v-8cc0d072]{font-size:14px;height:30px;line-height:30px;font-weight:700;color:#333;background:#e2e4e6;text-align:left;padding-left:16px}nav a[data-v-8cc0d072]{font-size:12px;float:right;margin-right:5px;color:#16ac3a;text-decoration:none}.t[data-v-8cc0d072]{border-bottom:1px solid #ddd}.con[data-v-8cc0d072]{width:100%}.con .channel-wrap[data-v-8cc0d072]{font-size:0}.con .channel[data-v-8cc0d072]{width:50%;display:inline-block;box-sizing:border-box;height:40px;border-bottom:1px solid #ddd;border-right:1px solid #ddd;text-align:center;line-height:40px;font-size:14px;color:#333;font-weight:700}.con .channel[data-v-8cc0d072]:nth-child(2n){border-right:none!important}.con .channel[data-v-8cc0d072]:last-child,.con .channel[data-v-8cc0d072]:nth-last-child(2):nth-child(odd){border-bottom:none!important}.con .title[data-v-8cc0d072]{padding:0 10px;background:#eff1f4;font-weight:700;color:#333;height:35px;line-height:35px;border-bottom:1px solid #ddd}.help[data-v-8cc0d072]{display:inline-block;width:14px;height:14px;font-size:0;background:url(" + escape(__webpack_require__(685)) + ") no-repeat;vertical-align:middle;background-size:100% 100%;float:none}.con .title_1[data-v-8cc0d072]{padding:0 10px 0 16px;background:#eff1f4;font-weight:700;color:#333;height:35px;line-height:35px}.con .box[data-v-8cc0d072]{background:#eff1f4;padding:10px 10px 5px}.con .box table[data-v-8cc0d072]{width:100%}.con .box td[data-v-8cc0d072]{width:30%;height:auto;line-height:20px;font-weight:700;color:#333;text-align:left;display:inline-block;font-size:14px;border:0;background:none;vertical-align:text-top}.con .box td.mid[data-v-8cc0d072]{width:40%;text-align:center}.con .box td.away[data-v-8cc0d072]{text-align:right}div.bar[data-v-8cc0d072]{height:25px;line-height:25px;padding:0 10px 16px;border-bottom:1px solid #ddd}div.bar td[data-v-8cc0d072]{color:#fff;padding:0;margin:0;border:0;font-size:12px}div.bar .lose[data-v-8cc0d072]{background:#f12b2b;text-align:right;padding-right:5px}div.bar .win[data-v-8cc0d072]{background:#49c867;text-align:left;padding-left:5px}div.bar .draw[data-v-8cc0d072]{background:#1d9ff9}img[data-v-8cc0d072]{width:20px;margin:0 5px 0 0;vertical-align:middle}.con .title img[data-v-8cc0d072]{width:20px!important;height:auto!important;display:inline-block}table[data-v-8cc0d072]{border-collapse:collapse;width:100%;max-width:100%;word-break:break-word}table th[data-v-8cc0d072]{height:25px;line-height:1.2;color:#999;font-size:11px;-webkit-transform:scale(.9);transform:scale(.9)}table td[data-v-8cc0d072],table th[data-v-8cc0d072]{vertical-align:middle;text-align:center;border-bottom:1px solid #ddd}table td[data-v-8cc0d072]{color:#555;height:30px;padding:3px 0}table td p[data-v-8cc0d072]{line-height:10px;font-size:10px;height:10px;margin:0;padding:0;font-family:arial;text-align:center;-webkit-transform:scale(.8);transform:scale(.8)}div.none[data-v-8cc0d072]{height:55px;line-height:55px;text-align:center;font-size:14px;color:#999}.match-prediction-result[data-v-8cc0d072],.match-prediction[data-v-8cc0d072]{text-align:center}.match-prediction h2[data-v-8cc0d072]{font-size:18px;color:#333;margin:20px 0 15px}.match-prediction-result h2[data-v-8cc0d072]{font-size:18px;color:#16ac3a;margin:20px 0 15px}.match-prediction-result h2.long-title[data-v-8cc0d072]{font-size:14px}.match-prediction .btn[data-v-8cc0d072]{display:inline-block;width:146px;height:36px;color:#fff;background-color:#16b13a;font-size:16px;text-decoration:none;font-weight:700;border-radius:2px;line-height:36px}.match-prediction-result p[data-v-8cc0d072],.match-prediction p[data-v-8cc0d072]{color:#8c9399;line-height:1.4;padding:0 10px;margin-bottom:15px}.match-prediction p.free-chance[data-v-8cc0d072]{color:#333}.match-prediction p.free-chance b[data-v-8cc0d072]{color:#16ac3a;font-size:15px}.list_1 .date[data-v-8cc0d072]{width:50px}.list_1 .cup[data-v-8cc0d072]{width:70px}.list_1 .away[data-v-8cc0d072],.list_1 .home[data-v-8cc0d072]{width:88px}.list_1 .stat[data-v-8cc0d072]{width:24px}.list_2 .name[data-v-8cc0d072]{text-align:left}.list_2 .rank[data-v-8cc0d072]{width:24px}.list_2 tr.top td[data-v-8cc0d072]{background:#16ac3a;color:#fff;border-bottom:1px solid #128a2e}span.stat[data-v-8cc0d072]{display:inline-block;padding:0 5px;height:16px;line-height:17px;color:#fff}tr.lose td.team[data-v-8cc0d072],tr.lose td.team a[data-v-8cc0d072]{color:#f12b2b}tr.lose span.stat[data-v-8cc0d072]{background:#f12b2b}tr.draw td.team[data-v-8cc0d072],tr.draw td.team a[data-v-8cc0d072]{color:#1d9ff9}tr.draw span.stat[data-v-8cc0d072]{background:#1d9ff9}tr.win td.team[data-v-8cc0d072],tr.win td.team a[data-v-8cc0d072]{color:#49c867}tr.win span.stat[data-v-8cc0d072]{background:#49c867}.list_3 td[data-v-8cc0d072],.list_3 th[data-v-8cc0d072]{border:1px solid #ddd;padding:10px 18px 10px 10px;height:20px;line-height:20px;text-align:left;border-collapse:collapse}.list_3 th[data-v-8cc0d072]{color:#333;font-size:12px;background:#eff1f4;-webkit-transform:scale(1);transform:scale(1)}.list_3 td[data-v-8cc0d072]{position:relative;width:50%}.list_3 td a[data-v-8cc0d072]{text-decoration:none}.content span.num[data-v-8cc0d072]{display:inline-block;width:18px;margin:-2px 5px 0 0;height:18px;text-align:center;line-height:18px;background:#eff1f4;vertical-align:middle;border-radius:18px;font-family:arial}span.reason[data-v-8cc0d072]{position:absolute;top:13px;right:15px;width:16px;height:16px;background:#000}span.reason_red[data-v-8cc0d072],span.suspension[data-v-8cc0d072]{width:9px;height:12px;border-radius:2px;background:#e20004}span.reason_yellow[data-v-8cc0d072]{width:9px;height:12px;border-radius:2px;background:#f9f115}span.injury[data-v-8cc0d072],span.reason_injured[data-v-8cc0d072]{width:12px;height:12px;border:1px solid #ddd;background:#eff1f4;text-align:center;line-height:12px;border-radius:2px;color:#e20004;font-size:12px;font-weight:700;font-family:arial}td.company[data-v-8cc0d072]{width:80px}#odd_list a[data-v-8cc0d072]{text-decoration:none}#odd_list td[data-v-8cc0d072]{max-width:100px;overflow:hidden;text-overflow:ellipsis}input[data-v-8cc0d072]{border:0;margin:0;padding:0;width:0;height:0}nav.tab[data-v-8cc0d072]{text-align:center;display:block;width:100%;background:#eff1f4;height:auto;padding:16px 0;line-height:0}nav.tab ul[data-v-8cc0d072]{display:inline-block;border:1px solid #16ac3a;font-size:14px;border-radius:2px;width:64%;font-size:0;list-style:none;padding:0;height:28px}nav.tab li[data-v-8cc0d072]{list-style:none;display:inline-block;width:50%;font-size:14px;line-height:28px;height:28px;color:#16ac3a}nav.tab li a[data-v-8cc0d072]{display:block;color:inherit;font-size:inherit;text-align:inherit;width:100%;padding:0;margin:0}nav.tab li.current[data-v-8cc0d072]{background:#16ac3a;color:#fff}.preview .vue-dialog[data-v-8cc0d072]{font-size:17px;top:20vw!important}.preview .vue-dialog .dialog-content[data-v-8cc0d072]{padding:25px;font-size:17px;text-align:center;line-height:1.5}.preview .vue-dialog-button[data-v-8cc0d072]{font-size:17px!important;color:#16ac3a;height:45px;line-height:45px;border-radius:0}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/pastGames.vue"],"names":[],"mappings":"AACA,mBACI,UAAY,CACf,AACD,4CAEI,WAAa,CAChB,AACD,sBAEI,sDAA4D,AAC5D,kBAAoB,CACvB,AACD,oGAKI,SAAU,AACV,SAAW,CACd,AACD,sBACI,SAAU,AACV,UAAW,AACX,mCAAoC,AACpC,iBAAmB,CACtB,AACD,qBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,uBACI,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,oBAAsB,CACzB,AACD,oBACI,4BAA8B,CAEjC,AACD,sBACI,UAAY,CACf,AACD,oCACI,WAAa,CAChB,AACD,+BACI,UAAW,AACX,qBAAsB,AACtB,sBAAuB,AACvB,YAAa,AACb,6BAA8B,AAE9B,4BAA6B,AAE7B,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,eAAkB,CACrB,AACD,6CACI,2BAA8B,CACjC,AACD,0GAEI,4BAA+B,CAClC,AACD,6BACI,eAAgB,AAChB,mBAAoB,AACpB,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,4BAA8B,CACjC,AACD,uBACI,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,YAAa,AACb,mDAAoD,AACpD,sBAAuB,AACvB,0BAA2B,AAC3B,UAAY,CACf,AACD,+BACI,sBAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,gBAAkB,CACrB,AACD,2BACI,mBAAoB,AACpB,qBAA4B,CAC/B,AACD,iCACI,UAAY,CACf,AACD,8BACI,UAAW,AACX,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,qBAAsB,AACtB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,uBAAyB,CAC5B,AACD,kCACI,UAAW,AACX,iBAAmB,CACtB,AACD,mCACI,gBAAkB,CACrB,AACD,yBACI,YAAa,AACb,iBAAkB,AAClB,oBAA0B,AAC1B,4BAA8B,CAEjC,AACD,4BACI,WAAY,AACZ,UAAW,AACX,SAAU,AACV,SAAU,AACV,cAAgB,CACnB,AACD,+BACI,mBAAoB,AACpB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,8BACI,mBAAoB,AACpB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,+BACI,kBAAoB,CACvB,AACD,qBACI,WAAY,AACZ,iBAAkB,AAClB,qBAAuB,CAC1B,AACD,iCACI,qBAAuB,AACvB,sBAAwB,AACxB,oBAAsB,CACzB,AACD,uBACI,yBAA0B,AAC1B,WAAY,AACZ,eAAgB,AAChB,qBAAuB,CAC1B,AACD,0BACI,YAAa,AACb,gBAAiB,AAGjB,WAAY,AACZ,eAAgB,AAGhB,4BAA8B,AAC9B,mBAAsB,CACzB,AACD,oDATI,sBAAuB,AACvB,kBAAmB,AAGnB,4BAA8B,CAajC,AARD,0BACI,WAAY,AACZ,YAAa,AACb,aAAe,CAKlB,AACD,4BACI,iBAAkB,AAClB,eAAgB,AAChB,YAAa,AACb,SAAU,AACV,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,4BAA8B,AAC9B,mBAAsB,CACzB,AACD,0BACI,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CACf,AACD,6EAEI,iBAAmB,CACtB,AACD,sCACI,eAAgB,AAChB,WAAY,AACZ,kBAAoB,CACvB,AACD,6CACI,eAAgB,AAChB,cAAe,AACf,kBAAoB,CACvB,AACD,wDACI,cAAgB,CACnB,AACD,wCACI,qBAAsB,AACtB,YAAa,AACb,YAAa,AACb,WAAY,AACZ,yBAA0B,AAC1B,eAAgB,AAChB,qBAAsB,AACtB,gBAAkB,AAClB,kBAAmB,AACnB,gBAAkB,CACrB,AACD,iFAEI,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,kBAAoB,CACvB,AACD,iDACI,UAAY,CACf,AACD,mDACI,cAAe,AACf,cAAgB,CACnB,AACD,+BACI,UAAY,CACf,AACD,8BACI,UAAY,CACf,AAID,8DACI,UAAY,CACf,AACD,+BACI,UAAY,CACf,AACD,+BACI,eAAiB,CACpB,AACD,+BACI,UAAY,CACf,AACD,mCACI,mBAAoB,AACpB,WAAY,AACZ,+BAAiC,CAEpC,AACD,2BACI,qBAAsB,AACtB,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,UAAY,CACf,AAID,oEACI,aAAe,CAClB,AACD,mCACI,kBAAoB,CACvB,AAID,oEACI,aAAe,CAClB,AACD,mCACI,kBAAoB,CACvB,AAID,kEACI,aAAe,CAClB,AACD,kCACI,kBAAoB,CACvB,AACD,wDAEI,sBAAuB,AAEvB,4BAA6B,AAC7B,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,wBAA0B,CAC7B,AACD,4BACI,WAAY,AACZ,eAAgB,AAChB,mBAAoB,AACpB,2BAA4B,AAC5B,kBAAoB,CACvB,AACD,4BACI,kBAAmB,AACnB,SAAW,CACd,AACD,8BACI,oBAAsB,CACzB,AACD,mCACI,qBAAsB,AACtB,WAAY,AACZ,oBAAqB,AACrB,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,sBAAuB,AACvB,mBAAoB,AAGpB,iBAAmB,CACtB,AACD,6BACI,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,eAAiB,CACpB,AAOD,kEACI,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,kBAAoB,CACvB,AACD,oCACI,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,kBAAoB,CACvB,AAeD,kEAbI,WAAY,AACZ,YAAa,AACb,sBAAuB,AAEvB,mBAAoB,AACpB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CAetB,AACD,4BACI,UAAY,CACf,AACD,6BACI,oBAAsB,CACzB,AACD,8BACI,gBAAiB,AACjB,gBAAiB,AACjB,sBAAwB,CAC3B,AAGD,uBACI,SAAU,AACV,SAAU,AACV,UAAW,AACX,QAAS,AACT,QAAU,CACb,AACD,yBACI,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,YAAa,AACb,eAAgB,AAChB,aAAe,CAClB,AACD,4BACI,qBAAsB,AACtB,yBAA0B,AAE1B,eAAgB,AAChB,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,gBAAiB,AACjB,UAAW,AACX,WAAa,CAChB,AACD,4BACI,gBAAiB,AACjB,qBAAsB,AACtB,UAAW,AACX,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,aAAe,CAClB,AACD,8BACI,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,WAAY,AACZ,UAAW,AACX,QAAU,CACb,AACD,oCACI,mBAAoB,AACpB,UAAY,CACf,AAGD,sCACI,eAAgB,AAChB,kBAAqB,CACxB,AACD,sDACI,aAAc,AACd,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CACpB,AACD,6CACI,yBAA2B,AAC3B,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,eAAiB,CACpB","file":"pastGames.vue","sourcesContent":["\na[data-v-8cc0d072] {\n    color: #000;\n}\nhtml[data-v-8cc0d072],\nbody[data-v-8cc0d072] {\n    height: 100%;\n}\nbody[data-v-8cc0d072] {\n    /*设置英文字体*/\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background: #eff1f4;\n}\np[data-v-8cc0d072],\ndiv[data-v-8cc0d072],\nul[data-v-8cc0d072],\nol[data-v-8cc0d072],\nli[data-v-8cc0d072] {\n    margin: 0;\n    padding: 0;\n}\nbody[data-v-8cc0d072] {\n    margin: 0;\n    padding: 0;\n    -webkit-font-smoothing: antialiased;\n    position: relative;\n}\nnav[data-v-8cc0d072] {\n    font-size: 14px;\n    height: 30px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #333;\n    background: #e2e4e6;\n    text-align: left;\n    padding-left: 16px;\n}\nnav a[data-v-8cc0d072] {\n    font-size: 12px;\n    float: right;\n    margin-right: 5px;\n    color: #16ac3a;\n    text-decoration: none;\n}\n.t[data-v-8cc0d072] {\n    border-bottom: 1px solid #ddd;\n    /*no*/\n}\n.con[data-v-8cc0d072] {\n    width: 100%;\n}\n.con .channel-wrap[data-v-8cc0d072] {\n    font-size: 0;\n}\n.con .channel[data-v-8cc0d072] {\n    width: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    height: 40px;\n    border-bottom: 1px solid #ddd;\n    /*px*/\n    border-right: 1px solid #ddd;\n    /*px*/\n    text-align: center;\n    line-height: 40px;\n    font-size: 14px;\n    color: #333;\n    font-weight: bold;\n}\n.con .channel[data-v-8cc0d072]:nth-child(even) {\n    border-right: none !important;\n}\n.con .channel[data-v-8cc0d072]:nth-last-child(2):nth-child(odd),\n.con .channel[data-v-8cc0d072]:last-child {\n    border-bottom: none !important;\n}\n.con .title[data-v-8cc0d072] {\n    padding: 0 10px;\n    background: #eff1f4;\n    font-weight: 700;\n    color: #333;\n    height: 35px;\n    line-height: 35px;\n    border-bottom: 1px solid #ddd;\n}\n.help[data-v-8cc0d072] {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    font-size: 0;\n    background: url(../assets/match/help.png) no-repeat;\n    vertical-align: middle;\n    background-size: 100% 100%;\n    float: none;\n}\n.con .title_1[data-v-8cc0d072] {\n    padding: 0 10px 0 16px;\n    background: #eff1f4;\n    font-weight: 700;\n    color: #333;\n    height: 35px;\n    line-height: 35px;\n}\n.con .box[data-v-8cc0d072] {\n    background: #eff1f4;\n    padding: 10px 10px 5px 10px;\n}\n.con .box table[data-v-8cc0d072] {\n    width: 100%;\n}\n.con .box td[data-v-8cc0d072] {\n    width: 30%;\n    height: auto;\n    line-height: 20px;\n    font-weight: 700;\n    color: #333;\n    text-align: left;\n    display: inline-block;\n    font-size: 14px;\n    border: 0;\n    background: none;\n    vertical-align: text-top;\n}\n.con .box td.mid[data-v-8cc0d072] {\n    width: 40%;\n    text-align: center;\n}\n.con .box td.away[data-v-8cc0d072] {\n    text-align: right;\n}\ndiv.bar[data-v-8cc0d072] {\n    height: 25px;\n    line-height: 25px;\n    padding: 0 10px 16px 10px;\n    border-bottom: 1px solid #ddd;\n    /*no*/\n}\ndiv.bar td[data-v-8cc0d072] {\n    color: #fff;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    font-size: 12px;\n}\ndiv.bar .lose[data-v-8cc0d072] {\n    background: #f12b2b;\n    text-align: right;\n    padding-right: 5px;\n}\ndiv.bar .win[data-v-8cc0d072] {\n    background: #49c867;\n    text-align: left;\n    padding-left: 5px;\n}\ndiv.bar .draw[data-v-8cc0d072] {\n    background: #1d9ff9;\n}\nimg[data-v-8cc0d072] {\n    width: 20px;\n    margin: 0 5px 0 0;\n    vertical-align: middle;\n}\n.con .title img[data-v-8cc0d072] {\n    width: 20px !important;\n    height: auto !important;\n    display: inline-block;\n}\ntable[data-v-8cc0d072] {\n    border-collapse: collapse;\n    width: 100%;\n    max-width: 100%;\n    word-break: break-word;\n}\ntable th[data-v-8cc0d072] {\n    height: 25px;\n    line-height: 1.2;\n    vertical-align: middle;\n    text-align: center;\n    color: #999;\n    font-size: 11px;\n    border-bottom: 1px solid #ddd;\n    /*no*/\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9);\n}\ntable td[data-v-8cc0d072] {\n    color: #555;\n    height: 30px;\n    padding: 3px 0;\n    border-bottom: 1px solid #ddd;\n    /*no*/\n    vertical-align: middle;\n    text-align: center;\n}\ntable td p[data-v-8cc0d072] {\n    line-height: 10px;\n    font-size: 10px;\n    height: 10px;\n    margin: 0;\n    padding: 0;\n    font-family: arial;\n    text-align: center;\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n}\ndiv.none[data-v-8cc0d072] {\n    height: 55px;\n    line-height: 55px;\n    text-align: center;\n    font-size: 14px;\n    color: #999;\n}\n.match-prediction[data-v-8cc0d072],\n.match-prediction-result[data-v-8cc0d072] {\n    text-align: center;\n}\n.match-prediction h2[data-v-8cc0d072] {\n    font-size: 18px;\n    color: #333;\n    margin: 20px 0 15px;\n}\n.match-prediction-result h2[data-v-8cc0d072] {\n    font-size: 18px;\n    color: #16ac3a;\n    margin: 20px 0 15px;\n}\n.match-prediction-result h2.long-title[data-v-8cc0d072] {\n    font-size: 14px;\n}\n.match-prediction .btn[data-v-8cc0d072] {\n    display: inline-block;\n    width: 146px;\n    height: 36px;\n    color: #fff;\n    background-color: #16b13a;\n    font-size: 16px;\n    text-decoration: none;\n    font-weight: bold;\n    border-radius: 2px;\n    line-height: 36px;\n}\n.match-prediction p[data-v-8cc0d072],\n.match-prediction-result p[data-v-8cc0d072] {\n    color: #8c9399;\n    line-height: 1.4;\n    padding: 0 10px;\n    margin-bottom: 15px;\n}\n.match-prediction p.free-chance[data-v-8cc0d072] {\n    color: #333;\n}\n.match-prediction p.free-chance b[data-v-8cc0d072] {\n    color: #16ac3a;\n    font-size: 15px;\n}\n.list_1 .date[data-v-8cc0d072] {\n    width: 50px;\n}\n.list_1 .cup[data-v-8cc0d072] {\n    width: 70px;\n}\n.list_1 .home[data-v-8cc0d072] {\n    width: 88px;\n}\n.list_1 .away[data-v-8cc0d072] {\n    width: 88px;\n}\n.list_1 .stat[data-v-8cc0d072] {\n    width: 24px;\n}\n.list_2 .name[data-v-8cc0d072] {\n    text-align: left;\n}\n.list_2 .rank[data-v-8cc0d072] {\n    width: 24px;\n}\n.list_2 tr.top td[data-v-8cc0d072] {\n    background: #16ac3a;\n    color: #fff;\n    border-bottom: 1px solid #128a2e;\n    /*no*/\n}\nspan.stat[data-v-8cc0d072] {\n    display: inline-block;\n    padding: 0 5px;\n    height: 16px;\n    line-height: 17px;\n    color: #fff;\n}\ntr.lose td.team[data-v-8cc0d072] {\n    color: #f12b2b;\n}\ntr.lose td.team a[data-v-8cc0d072] {\n    color: #f12b2b;\n}\ntr.lose span.stat[data-v-8cc0d072] {\n    background: #f12b2b;\n}\ntr.draw td.team[data-v-8cc0d072] {\n    color: #1d9ff9;\n}\ntr.draw td.team a[data-v-8cc0d072] {\n    color: #1d9ff9;\n}\ntr.draw span.stat[data-v-8cc0d072] {\n    background: #1d9ff9;\n}\ntr.win td.team[data-v-8cc0d072] {\n    color: #49c867;\n}\ntr.win td.team a[data-v-8cc0d072] {\n    color: #49c867;\n}\ntr.win span.stat[data-v-8cc0d072] {\n    background: #49c867;\n}\n.list_3 td[data-v-8cc0d072],\n.list_3 th[data-v-8cc0d072] {\n    border: 1px solid #ddd;\n    /*no*/\n    padding: 10px 18px 10px 10px;\n    height: 20px;\n    line-height: 20px;\n    text-align: left;\n    border-collapse: collapse;\n}\n.list_3 th[data-v-8cc0d072] {\n    color: #333;\n    font-size: 12px;\n    background: #eff1f4;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n.list_3 td[data-v-8cc0d072] {\n    position: relative;\n    width: 50%;\n}\n.list_3 td a[data-v-8cc0d072] {\n    text-decoration: none;\n}\n.content span.num[data-v-8cc0d072] {\n    display: inline-block;\n    width: 18px;\n    margin: -2px 5px 0 0;\n    height: 18px;\n    text-align: center;\n    line-height: 18px;\n    background: #eff1f4;\n    vertical-align: middle;\n    border-radius: 18px;\n    /*border: 1px solid #dfdfdf;*/\n    /*no*/\n    font-family: arial;\n}\nspan.reason[data-v-8cc0d072] {\n    position: absolute;\n    top: 13px;\n    right: 15px;\n    width: 16px;\n    height: 16px;\n    background: #000;\n}\nspan.reason_red[data-v-8cc0d072] {\n    width: 9px;\n    height: 12px;\n    border-radius: 2px;\n    background: #e20004;\n}\nspan.suspension[data-v-8cc0d072] {\n    width: 9px;\n    height: 12px;\n    border-radius: 2px;\n    background: #e20004;\n}\nspan.reason_yellow[data-v-8cc0d072] {\n    width: 9px;\n    height: 12px;\n    border-radius: 2px;\n    background: #f9f115;\n}\nspan.reason_injured[data-v-8cc0d072] {\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ddd;\n    /*no*/\n    background: #eff1f4;\n    text-align: center;\n    line-height: 12px;\n    border-radius: 2px;\n    color: #e20004;\n    font-size: 12px;\n    font-weight: 700;\n    font-family: arial;\n}\nspan.injury[data-v-8cc0d072] {\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ddd;\n    /*no*/\n    background: #eff1f4;\n    text-align: center;\n    line-height: 12px;\n    border-radius: 2px;\n    color: #e20004;\n    font-size: 12px;\n    font-weight: 700;\n    font-family: arial;\n}\ntd.company[data-v-8cc0d072] {\n    width: 80px;\n}\n#odd_list a[data-v-8cc0d072] {\n    text-decoration: none;\n}\n#odd_list td[data-v-8cc0d072] {\n    max-width: 100px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/*未知模块*/\ninput[data-v-8cc0d072] {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n}\nnav.tab[data-v-8cc0d072] {\n    text-align: center;\n    display: block;\n    width: 100%;\n    background: #eff1f4;\n    height: auto;\n    padding: 16px 0;\n    line-height: 0;\n}\nnav.tab ul[data-v-8cc0d072] {\n    display: inline-block;\n    border: 1px solid #16ac3a;\n    /*no*/\n    font-size: 14px;\n    border-radius: 2px;\n    width: 64%;\n    font-size: 0;\n    list-style: none;\n    padding: 0;\n    height: 28px;\n}\nnav.tab li[data-v-8cc0d072] {\n    list-style: none;\n    display: inline-block;\n    width: 50%;\n    font-size: 14px;\n    line-height: 28px;\n    height: 28px;\n    color: #16ac3a;\n}\nnav.tab li a[data-v-8cc0d072] {\n    display: block;\n    color: inherit;\n    font-size: inherit;\n    text-align: inherit;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n}\nnav.tab li.current[data-v-8cc0d072] {\n    background: #16ac3a;\n    color: #fff;\n}\n\n/*dialog*/\n.preview .vue-dialog[data-v-8cc0d072] {\n    font-size: 17px;\n    top: 20vw !important;\n}\n.preview .vue-dialog .dialog-content[data-v-8cc0d072] {\n    padding: 25px;\n    font-size: 17px;\n    text-align: center;\n    line-height: 1.5;\n}\n.preview .vue-dialog-button[data-v-8cc0d072] {\n    font-size: 17px !important;\n    color: #16ac3a;\n    height: 45px;\n    line-height: 45px;\n    border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/help.07012f6.png";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(197);

var _assign2 = _interopRequireDefault(_assign);

var _defaultTeam = __webpack_require__(629);

var _defaultTeam2 = _interopRequireDefault(_defaultTeam);

var _queryString = __webpack_require__(599);

var _queryString2 = _interopRequireDefault(_queryString);

var _axios = __webpack_require__(185);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        gameData: Object
    },
    data: function data() {
        var data = (0, _assign2.default)({
            has_odds: null,
            cup_table: null,
            match_live: null,
            battle_history: null,
            sideline: null,
            league_table: null,
            recent_record: null,
            tips: null,
            aver: null,
            priceText: '',
            paybackTimer: null,
            isLogin: true,
            locale: 'id'
        }, this.gameData);
        return data;
    },
    mounted: function mounted() {
        var query = _queryString2.default.parse(location.search);
        this.locale = query['language'] || query['locale'] || 'id';
    },

    methods: {
        loadDefaultImg: function loadDefaultImg(event) {
            var dom = event.target;
            dom.src = _defaultTeam2.default;
        },
        isPayAble: function isPayAble() {
            if (this.tips.title && this.tips.content) {
                return true;
            }

            if (this.gameData.status && this.gameData.status !== 'Playing' && this.gameData.status !== 'Played') {
                return true;
            }

            var date = new Date(this.gameData.start_play.replace(/-/g, '/')).getTime();
            var offset = new Date().getTimezoneOffset();
            date = date - offset * 60 * 1000;
            var nowDate = new Date().getTime();

            return nowDate - date < 60 * 60 * 1000;
        },
        payback: function payback() {
            var me = this;

            _axios2.default.get('/api/v2/match/predict_detail', {
                params: {
                    match_id: this.gameData.match_id,
                    _t: new Date().getTime()
                }
            }).then(function (response) {
                var res = response.data;
                if (!res.data || !res.data.title) {
                    setTimeout(me.payback.bind(me), 200);
                    return;
                }

                me.paybackTimer && clearTimeout(me.paybackTimer);
                me.paybackTimer = null;
                me.tips = res.data;
            });
        }
    }
};

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.match_live && _vm.match_live.length) ? [_c('nav', [_vm._v(_vm._s(_vm.$t('broadcast')))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "channel-wrap"
  }, _vm._l((_vm.match_live), function(item) {
    return _c('span', {
      key: item,
      staticClass: "channel"
    }, [_vm._v(_vm._s(item))])
  }))])] : _vm._e(), _vm._v(" "), _c('nav', [_vm._v(_vm._s(_vm.$t('past_games')))]), _vm._v(" "), (_vm.battle_history) ? _c('article', {
    staticClass: "con"
  }, [(_vm.battle_history['list'] && _vm.battle_history['list'].length) ? [_c('div', {
    staticClass: "box"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "home"
  }, [_vm._v(_vm._s(_vm.team_A))]), _vm._v(" "), _c('td', {
    staticClass: "mid"
  }, [_vm._v(_vm._s(_vm.$t('pg_lng', {
    count: _vm.battle_history.list.length
  })))]), _vm._v(" "), _c('td', {
    staticClass: "away"
  }, [_vm._v(_vm._s(_vm.team_B))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "win",
    style: ({
      width: ((_vm.battle_history['percent']['win']) + "%")
    })
  }, [_vm._v("\n                                " + _vm._s(_vm.$tc('pg_w', 10, {
    count: _vm.battle_history['team_A']['win']
  })) + "\n                            ")]), _vm._v(" "), _c('td', {
    staticClass: "draw",
    style: ({
      width: ((_vm.battle_history['percent']['draw']) + "%")
    })
  }, [_vm._v("\n                                " + _vm._s(_vm.$tc('pg_d', 10, {
    count: _vm.battle_history['team_A']['draw']
  })) + "\n                            ")]), _vm._v(" "), _c('td', {
    staticClass: "lose",
    style: ({
      width: ((_vm.battle_history['percent']['lose']) + "%")
    })
  }, [_vm._v("\n                                " + _vm._s(_vm.$tc('pg_w', 10, {
    count: _vm.battle_history['team_B']['win']
  })) + "\n                            ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "list_1"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t('pg_date')))]), _vm._v(" "), _c('th', {
    staticClass: "cup"
  }, [_vm._v(_vm._s(_vm.$t('pg_competition')))]), _vm._v(" "), _c('th', {
    staticClass: "home"
  }, [_vm._v(_vm._s(_vm.$t('pg_home')))]), _vm._v(" "), _c('th', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.$t('pg_result')))]), _vm._v(" "), _c('th', {
    staticClass: "away"
  }, [_vm._v(_vm._s(_vm.$t('pg_away')))])]), _vm._v(" "), _vm._l((_vm.battle_history.list), function(match) {
    return _c('tr', {
      key: match.match_href,
      class: match['color']
    }, [_c('td', {
      staticClass: "time"
    }, [_c('p', [_vm._v(_vm._s(match['date']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(match['year']))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(match['competition']))]), _vm._v(" "), _c('td', {
      class: {
        team: match.main_team == 'team_A'
      }
    }, [_vm._v(_vm._s(match['team_A_name']))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": match['match_href']
      }
    }, [_c('span', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(match['score']))])])]), _vm._v(" "), _c('td', {
      class: {
        team: match.main_team == 'team_B'
      }
    }, [_vm._v(_vm._s(match['team_B_name']))])])
  })], 2)])] : _c('div', {
    staticClass: "none"
  }, [_vm._v(_vm._s(_vm.$t('pg_no')))])], 2) : _vm._e(), _vm._v(" "), (_vm.sideline && _vm.sideline.max) ? [_c('nav', {
    staticClass: "t"
  }, [_vm._v(" " + _vm._s(_vm.$t('absentee')) + " " + _vm._s(_vm.sideline.max))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('table', {
    staticClass: "list_3"
  }, [_c('tbody', [_c('tr', [_c('th', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.team_A_logo),
      "alt": ""
    },
    on: {
      "error": _vm.loadDefaultImg
    }
  }), _vm._v(" " + _vm._s(_vm.team_A) + "\n                        ")]), _vm._v(" "), _c('th', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.team_B_logo),
      "alt": ""
    },
    on: {
      "error": _vm.loadDefaultImg
    }
  }), _vm._v(" " + _vm._s(_vm.team_B) + "\n                        ")])]), _vm._v(" "), _vm._l((_vm.sideline.max), function(i) {
    return _c('tr', {
      key: i
    }, [_c('td', [(_vm.sideline['team_A'][i - 1]) ? [_c('span', {
      staticClass: "num"
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_A'][i - 1]['shirtnumber']))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.sideline['team_A'][i - 1]['href']
      }
    }, [_vm._v(_vm._s(_vm.sideline['team_A'][i - 1]['name']) + "\n                                ")]), _vm._v(" "), _c('span', {
      class: 'reason ' + _vm.sideline['team_A'][i - 1]['reason']
    }, [_vm._v("\n                                    " + _vm._s(_vm.sideline['team_A'][i - 1]['reason_char']) + " ")])] : _vm._e()], 2), _vm._v(" "), _c('td', [(_vm.sideline['team_B'][i - 1]) ? [_c('span', {
      staticClass: "num"
    }, [_vm._v(" " + _vm._s(_vm.sideline['team_B'][i - 1]['shirtnumber']))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.sideline['team_B'][i - 1]['href']
      }
    }, [_vm._v(_vm._s(_vm.sideline['team_B'][i - 1]['name']))]), _vm._v(" "), _c('span', {
      class: 'reason ' + _vm.sideline['team_B'][i - 1]['reason']
    }, [_vm._v("\n                                    " + _vm._s(_vm.sideline['team_B'][i - 1]['reason_char']) + "\n                                ")])] : _vm._e()], 2)])
  })], 2)])])] : _vm._e(), _vm._v(" "), (_vm.league_table) ? [_c('nav', {
    staticClass: "t"
  }, [_vm._v(_vm._s(_vm.$t('league_table')))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_vm._l((_vm.league_table), function(tables, team) {
    return [(team !== 'name') ? [_c('div', {
      key: team,
      staticClass: "title"
    }, [_c('img', {
      attrs: {
        "src": team === 'team_A' ? _vm.getImgSrc(_vm.team_A_logo) : _vm.getImgSrc(_vm.team_B_logo),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v("\n                        " + _vm._s(team === 'team_A' ? _vm.team_A : _vm.team_B) + "\n                    ")]), _vm._v(" "), _c('table', {
      key: tables.name
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('lt_format')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_p')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_w')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_d')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_l')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_f')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_a')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_pts')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_rank')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('lt_wp')))])]), _vm._v(" "), _vm._l((tables), function(table) {
      return _c('tr', {
        key: table.name
      }, [_c('td', [_vm._v(_vm._s(_vm.$t('lt_' + table['name'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_total']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_won']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['matches_lost']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['goals_pro']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['goals_against']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['points']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['rank']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table['win_rate']))])])
    })], 2)])] : _vm._e()]
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.cup_table) ? [_c('nav', [_vm._v(_vm._s(_vm.cup_table['name']))]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('table', {
    staticClass: "list_2"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "rank"
  }), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('ct_team')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_p')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_w')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_d')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_l')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_fa')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('ct_pts')))])]), _vm._v(" "), _vm._l((_vm.cup_table.list), function(team, rank) {
    return _c('tr', {
      key: rank,
      class: {
        top: team.color == 'green'
      }
    }, [_c('td', [_vm._v(_vm._s(team['rank']))]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(team['logo']),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v(" " + _vm._s(team['name']) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_total']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_won']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_draw']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['matches_lost']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['goals_pro']) + "/" + _vm._s(team['goals_against']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team['points']))])])
  })], 2)])])] : _vm._e(), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "odd"
    }
  }, [_vm._v(_vm._s(_vm.$t('odds')))]), _vm._v(" "), (_vm.has_odds) ? _c('article', {
    staticClass: "con",
    attrs: {
      "id": "odd_list"
    }
  }, [_c('div', {
    staticClass: "title_1"
  }, [_vm._v(_vm._s(_vm.$t('odds_handicap')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tab://4"
    }
  }, [_c('table', {
    staticClass: "list_4"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_hdp')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_lose')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "title_1"
  }, [_vm._v(_vm._s(_vm.$t('odds_1x2')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tab://4"
    }
  }, [_c('table', {
    staticClass: "list_4"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_home_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_draw')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_away_win')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('odds_tu')))])]), _vm._v(" "), (_vm.aver) ? _c('tr', [_c('td', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.$t('odds_average')))]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.$t('odds_spot')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['homeWin']) ? _vm.aver['now']['homeWin'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['draw']) ? _vm.aver['now']['draw'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['awayWin']) ? _vm.aver['now']['awayWin'] : '---'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Boolean(_vm.aver['now']['ts']) ? _vm.aver['now']['ts'] : '---'))])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "none"
  }, [_vm._v(_vm._s(_vm.$t('odds_no')))]), _vm._v(" "), _c('nav', [_vm._v(_vm._s(_vm.$t('recent_games')))]), _vm._v(" "), _vm._l((_vm.recent_record), function(matches, team) {
    return _c('article', {
      key: team,
      staticClass: "con"
    }, [(team !== 'name') ? [_c('div', {
      staticClass: "title t"
    }, [_c('img', {
      attrs: {
        "src": team === 'team_A' ? _vm.getImgSrc(_vm.team_A_logo) : _vm.getImgSrc(_vm.team_B_logo),
        "alt": ""
      },
      on: {
        "error": _vm.loadDefaultImg
      }
    }), _vm._v("\n                " + _vm._s(team === 'team_A' ? _vm.team_A : _vm.team_B) + "\n            ")]), _vm._v(" "), (matches && matches.length) ? _c('table', {
      staticClass: "list_1"
    }, [_c('tbody', [_c('tr', [_c('th', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$t('rg_date')))]), _vm._v(" "), _c('th', {
      staticClass: "cup"
    }, [_vm._v(_vm._s(_vm.$t('rg_competition')))]), _vm._v(" "), _c('th', {
      staticClass: "home"
    }, [_vm._v(_vm._s(_vm.$t('rg_home')))]), _vm._v(" "), _c('th', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(_vm.$t('rg_result')))]), _vm._v(" "), _c('th', {
      staticClass: "away"
    }, [_vm._v(_vm._s(_vm.$t('rg_away')))])]), _vm._v(" "), _vm._l((matches), function(match, id) {
      return _c('tr', {
        key: id,
        class: match['color']
      }, [_c('td', {
        staticClass: "time"
      }, [_c('p', [_vm._v(_vm._s(match['date']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(match['year']))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(match['competition']))]), _vm._v(" "), _c('td', {
        class: {
          team: match['main_team'] === 'team_A'
        }
      }, [_vm._v(_vm._s(match['team_A_name']))]), _vm._v(" "), _c('td', [_c('a', {
        attrs: {
          "href": match['match_href']
        }
      }, [_c('span', {
        staticClass: "stat"
      }, [_vm._v(_vm._s(match['score']))])])]), _vm._v(" "), _c('td', {
        class: {
          team: match['main_team'] === 'team_B'
        }
      }, [_vm._v(_vm._s(match['team_B_name']))])])
    })], 2)]) : _c('div', {
      staticClass: "none"
    }, [_vm._v(_vm._s(_vm.$t('rg_no')))])] : _vm._e()], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(184)(
  /* script */
  null,
  /* template */
  __webpack_require__(691),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-155f1585",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(690);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("c8252750", content, true, {});

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".background-masker[data-v-155f1585]{background:#eff1f4;position:absolute}.past-game-skeleton[data-v-155f1585]{background:#dfdfdf;margin:0 auto;width:100%}.past-game-skeleton nav[data-v-155f1585]{background:rgba(0,0,0,.1);position:relative}.past-game-skeleton nav .background-masker[data-v-155f1585]{background:#e2e4e6}.past-game-skeleton .con[data-v-155f1585]{height:102px;position:relative}.past-game-skeleton .left[data-v-155f1585]{width:15px;top:0;bottom:0;left:0}.past-game-skeleton .right[data-v-155f1585]{width:15px;top:0;bottom:0;right:0}.past-game-skeleton .nav-top[data-v-155f1585]{height:8px;left:15px;right:15px;top:0}.past-game-skeleton .nav-right[data-v-155f1585]{top:0;bottom:0;left:95px;right:0}.past-game-skeleton .nav-bottom[data-v-155f1585]{height:8px;left:15px;right:15px;bottom:0}.past-game-skeleton .gap1[data-v-155f1585]{left:15px;right:15px;height:15px;top:0}.past-game-skeleton .gap2[data-v-155f1585]{left:15px;right:15px;height:15px;top:29px}.past-game-skeleton .gap3[data-v-155f1585]{left:15px;right:15px;height:15px;top:58px}.past-game-skeleton .gap4[data-v-155f1585]{left:15px;right:15px;height:15px;top:87px}.past-game-skeleton .gap5[data-v-155f1585]{left:15px;right:15px;height:15px;top:116px}.past-game-skeleton .gap6[data-v-155f1585]{left:15px;right:15px;height:15px;top:145px}.placeholder[data-v-155f1585]{display:inline-block;height:14px;width:80px;background:#c9c9c9;vertical-align:middle}.con .placeholder[data-v-155f1585]{display:block;margin:10px auto;width:96%;background:#dfdfdf}@-webkit-keyframes placeHolderShimmer{0%{background-position:-234px 0}to{background-position:234px 0}}@keyframes placeHolderShimmer-data-v-155f1585{0%{background-position:-234px 0}to{background-position:234px 0}}.animated-background[data-v-155f1585]{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:placeHolderShimmer-data-v-155f1585;animation-name:placeHolderShimmer-data-v-155f1585;-webkit-animation-timing-function:linear;animation-timing-function:linear;background:#dfdfdf;background:linear-gradient(90deg,#dfdfdf 8%,#c9c9c9 18%,#dfdfdf 33%);background-size:800px 104px;position:relative}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/skeleton.vue"],"names":[],"mappings":"AACA,oCACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,mBAAoB,AACpB,cAAe,AACf,UAAY,CACb,AACD,yCACE,0BAA+B,AAC/B,iBAAmB,CACpB,AACD,4DACE,kBAAoB,CACrB,AACD,0CACE,aAAc,AACd,iBAAmB,CACpB,AACD,2CACE,WAAY,AACZ,MAAO,AACP,SAAU,AACV,MAAQ,CACT,AACD,4CACE,WAAY,AACZ,MAAO,AACP,SAAU,AACV,OAAS,CACV,AACD,8CACE,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,KAAO,CACR,AACD,gDACE,MAAO,AACP,SAAU,AACV,UAAW,AACX,OAAS,CACV,AACD,iDACE,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,KAAS,CACV,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,QAAU,CACX,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AACD,2CACE,UAAW,AACX,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AACD,8BACE,qBAAsB,AACtB,YAAa,AACb,WAAY,AACZ,mBAAoB,AACpB,qBAAuB,CACxB,AACD,mCACE,cAAe,AACf,iBAAkB,AAClB,UAAW,AACX,kBAAoB,CACrB,AACD,sCACA,GACI,4BAA8B,CACjC,AACD,GACI,2BAA6B,CAChC,CACA,AACD,8CACA,GACI,4BAA8B,CACjC,AACD,GACI,2BAA6B,CAChC,CACA,AACD,sCACE,8BAA+B,AACvB,sBAAuB,AAC/B,qCAAsC,AAC9B,6BAA8B,AACtC,2CAA4C,AACpC,mCAAoC,AAC5C,0DAA2D,AACnD,kDAAmD,AAC3D,yCAA0C,AAClC,iCAAkC,AAC1C,mBAAoB,AACpB,qEAA4E,AAC5E,4BAA6B,AAC7B,iBAAmB,CACpB","file":"skeleton.vue","sourcesContent":["\n.background-masker[data-v-155f1585] {\n  background: #eff1f4;\n  position: absolute;\n}\n.past-game-skeleton[data-v-155f1585] {\n  background: #dfdfdf;\n  margin: 0 auto;\n  width: 100%;\n}\n.past-game-skeleton nav[data-v-155f1585] {\n  background: rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.past-game-skeleton nav .background-masker[data-v-155f1585] {\n  background: #e2e4e6;\n}\n.past-game-skeleton .con[data-v-155f1585] {\n  height: 102px;\n  position: relative;\n}\n.past-game-skeleton .left[data-v-155f1585] {\n  width: 15px;\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n.past-game-skeleton .right[data-v-155f1585] {\n  width: 15px;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.past-game-skeleton .nav-top[data-v-155f1585] {\n  height: 8px;\n  left: 15px;\n  right: 15px;\n  top: 0;\n}\n.past-game-skeleton .nav-right[data-v-155f1585] {\n  top: 0;\n  bottom: 0;\n  left: 95px;\n  right: 0;\n}\n.past-game-skeleton .nav-bottom[data-v-155f1585] {\n  height: 8px;\n  left: 15px;\n  right: 15px;\n  bottom: 0;\n}\n.past-game-skeleton .gap1[data-v-155f1585] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 0px;\n}\n.past-game-skeleton .gap2[data-v-155f1585] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 29px;\n}\n.past-game-skeleton .gap3[data-v-155f1585] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 58px;\n}\n.past-game-skeleton .gap4[data-v-155f1585] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 87px;\n}\n.past-game-skeleton .gap5[data-v-155f1585] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 116px;\n}\n.past-game-skeleton .gap6[data-v-155f1585] {\n  left: 15px;\n  right: 15px;\n  height: 15px;\n  top: 145px;\n}\n.placeholder[data-v-155f1585] {\n  display: inline-block;\n  height: 14px;\n  width: 80px;\n  background: #c9c9c9;\n  vertical-align: middle;\n}\n.con .placeholder[data-v-155f1585] {\n  display: block;\n  margin: 10px auto;\n  width: 96%;\n  background: #dfdfdf;\n}\n@-webkit-keyframes placeHolderShimmer {\n0% {\n    background-position: -234px 0;\n}\n100% {\n    background-position: 234px 0;\n}\n}\n@keyframes placeHolderShimmer-data-v-155f1585 {\n0% {\n    background-position: -234px 0;\n}\n100% {\n    background-position: 234px 0;\n}\n}\n.animated-background[data-v-155f1585] {\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-name: placeHolderShimmer-data-v-155f1585;\n          animation-name: placeHolderShimmer-data-v-155f1585;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  background: #dfdfdf;\n  background: linear-gradient(to right, #dfdfdf 8%, #c9c9c9 18%, #dfdfdf 33%);\n  background-size: 800px 104px;\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "past-game-skeleton background-masker"
  }, [_c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])])])
}]}

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content preview"
  }, [_c('nav', {
    staticClass: "sum"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('prediction')) + "\n            "), (_vm.voteData.total_num) ? [_vm._v(_vm._s(_vm.$tc('voteNum', 10, {
    count: _vm.voteData.total_num
  })))] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.voteData.name && _vm.isShowOverview) ? _c('p', {
    staticClass: "forecast"
  }, [_vm._v(_vm._s(_vm.voteData.name))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "vote_con"
  }, _vm._l((_vm.voteData.data), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "vote_view",
      attrs: {
        "id": item.name.toLowerCase(),
        "data-vote": "1"
      }
    }, [_c('div', {
      staticClass: "vote_box"
    }, [_c('div', {
      staticClass: "progress_con"
    }, [_c('div', {
      staticClass: "progress",
      style: ({
        'height': _vm.height(item.num) + 'px',
        'line-height': _vm.height(item.num) + 'px'
      })
    }, [_c('b', [_vm._v(_vm._s(item.percent) + "%")])])])]), _vm._v(" "), _c('div', {
      staticClass: "bottom_vote",
      class: {
        'clicked': !_vm.votable(item.id) || _vm.voted(item.id)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.vote(item.id)
        }
      }
    }, [_c('span'), _vm._v(" " + _vm._s(_vm.voted(item.id) ? _vm.$t('voted') : _vm.$t('vote')) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "vote-label"
    }, [(item.id === 1) ? _c('img', {
      attrs: {
        "src": _vm.getImgSrc(_vm.homeImgSrc)
      }
    }) : _vm._e(), _vm._v(" "), (item.id === 3) ? _c('img', {
      attrs: {
        "src": _vm.getImgSrc(_vm.awayImgSrc)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.name.toLowerCase())))])])])])
  }))]), _vm._v(" "), (_vm.analysisData) ? _c('past-games', {
    attrs: {
      "game-data": _vm.analysisData
    }
  }) : _c('skeleton'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mask"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('matchNotStart')))])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(702),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a188149",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("5b3ecdd4", content, true, {});

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "[data-v-2a188149]{box-sizing:border-box}.match-live-container[data-v-2a188149]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f5f5f5;padding:0 1.5rem 1.8125rem}.match-live-container .live-title[data-v-2a188149]{width:100%;padding:1.1875rem;text-align:center;font-size:.8125rem;font-weight:500;color:#8c969f;font-family:SF UI Display;background:inherit}.match-live-container .channel-list[data-v-2a188149]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin-bottom:.625rem;overflow-y:auto}.match-live-container .channel-list .channel-item[data-v-2a188149]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.match-live-container .channel-list .channel-item[data-v-2a188149]:not(:last-child){margin-bottom:.625rem}.match-live-container .channel-list .channel-item .channel-info[data-v-2a188149]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:16.8125rem;height:3.125rem;padding:1rem 1.1875rem;border-radius:1.5625rem;background:#fff}.match-live-container .channel-list .channel-item .channel-info .icon-living[data-v-2a188149]{margin-right:.375rem;width:1.125rem;height:1.125rem}.match-live-container .channel-list .channel-item .channel-info .channel-name[data-v-2a188149]{max-width:12rem;font-weight:700;font-size:.875rem;color:#16b13a;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.match-live-container .channel-list .channel-item .channel-info .icon-play[data-v-2a188149]{margin-left:auto;width:.375rem;height:.625rem}.match-live-container .channel-list .channel-item .channel-likes[data-v-2a188149]{margin-left:.1875rem;-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:3.125rem;height:3.125rem;border-radius:50%;background:#fff}.match-live-container .channel-list .channel-item .channel-likes .icon-like[data-v-2a188149]{width:.9375rem;height:.9375rem}.match-live-container .channel-list .channel-item .channel-likes .likes-count[data-v-2a188149]{margin-top:.1875rem;font-weight:400;font-size:.625rem;color:#8c969f}.match-live-container .data-empty[data-v-2a188149]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:1.875rem .9375rem;line-height:1.25rem;text-align:center;font-size:.875rem;color:#8c969f}.match-live-container .add-channel-btn[data-v-2a188149]{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:20.4375rem;height:3.125rem;border:none;border-radius:1.5625rem;background:#fff}.match-live-container .add-channel-btn .icon-plus[data-v-2a188149]{margin-right:.375rem;width:.75rem;height:.75rem}.match-live-container .add-channel-btn .add-channel-text[data-v-2a188149]{font-weight:700;font-size:.875rem;color:#8c969f}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/matchLive.vue"],"names":[],"mappings":"AACA,kBACE,qBAAuB,CACxB,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AACpB,0BAA4B,CAC7B,AACD,mDACE,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,mBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,qDACE,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,sBAAwB,AACxB,eAAiB,CAClB,AACD,mEACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,oFACE,qBAAwB,CACzB,AACD,iFACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAkB,AAClB,gBAAiB,AACjB,uBAAwB,AACxB,wBAAyB,AACzB,eAAoB,CACrB,AACD,8FACE,qBAAuB,AACvB,eAAgB,AAChB,eAAiB,CAClB,AACD,+FACE,gBAAiB,AACjB,gBAAkB,AAClB,kBAAoB,AACpB,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,4FACE,iBAAkB,AAClB,cAAgB,AAChB,cAAiB,CAClB,AACD,kFACE,qBAAsB,AACtB,oBAAqB,AACjB,cAAe,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,eAAoB,CACrB,AACD,6FACE,eAAiB,AACjB,eAAkB,CACnB,AACD,+FACE,oBAAsB,AACtB,gBAAiB,AACjB,kBAAoB,AACpB,aAAe,CAChB,AACD,mDACE,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,0BAA4B,AAC5B,oBAAqB,AACrB,kBAAmB,AACnB,kBAAoB,AACpB,aAAe,CAChB,AACD,wDACE,oBAAqB,AACjB,cAAe,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAkB,AAClB,gBAAiB,AACjB,YAAa,AACb,wBAAyB,AACzB,eAAoB,CACrB,AACD,mEACE,qBAAuB,AACvB,aAAe,AACf,aAAgB,CACjB,AACD,0EACE,gBAAkB,AAClB,kBAAoB,AACpB,aAAe,CAChB","file":"matchLive.vue","sourcesContent":["\n*[data-v-2a188149] {\n  box-sizing: border-box;\n}\n.match-live-container[data-v-2a188149] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #F5F5F5;\n  padding: 0 1.5rem 1.8125rem;\n}\n.match-live-container .live-title[data-v-2a188149] {\n  width: 100%;\n  padding: 1.1875rem;\n  text-align: center;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #8C969F;\n  font-family: SF UI Display;\n  background: inherit;\n}\n.match-live-container .channel-list[data-v-2a188149] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin-bottom: 0.625rem;\n  overflow-y: auto;\n}\n.match-live-container .channel-list .channel-item[data-v-2a188149] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.match-live-container .channel-list .channel-item[data-v-2a188149]:not(:last-child) {\n  margin-bottom: 0.625rem;\n}\n.match-live-container .channel-list .channel-item .channel-info[data-v-2a188149] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 16.8125rem;\n  height: 3.125rem;\n  padding: 1rem 1.1875rem;\n  border-radius: 1.5625rem;\n  background: #FFFFFF;\n}\n.match-live-container .channel-list .channel-item .channel-info .icon-living[data-v-2a188149] {\n  margin-right: 0.375rem;\n  width: 1.125rem;\n  height: 1.125rem;\n}\n.match-live-container .channel-list .channel-item .channel-info .channel-name[data-v-2a188149] {\n  max-width: 12rem;\n  font-weight: bold;\n  font-size: 0.875rem;\n  color: #16B13A;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.match-live-container .channel-list .channel-item .channel-info .icon-play[data-v-2a188149] {\n  margin-left: auto;\n  width: 0.375rem;\n  height: 0.625rem;\n}\n.match-live-container .channel-list .channel-item .channel-likes[data-v-2a188149] {\n  margin-left: .1875rem;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 50%;\n  background: #FFFFFF;\n}\n.match-live-container .channel-list .channel-item .channel-likes .icon-like[data-v-2a188149] {\n  width: 0.9375rem;\n  height: 0.9375rem;\n}\n.match-live-container .channel-list .channel-item .channel-likes .likes-count[data-v-2a188149] {\n  margin-top: 0.1875rem;\n  font-weight: 400;\n  font-size: 0.625rem;\n  color: #8C969F;\n}\n.match-live-container .data-empty[data-v-2a188149] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  padding: 1.875rem 0.9375rem;\n  line-height: 1.25rem;\n  text-align: center;\n  font-size: 0.875rem;\n  color: #8C969F;\n}\n.match-live-container .add-channel-btn[data-v-2a188149] {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 20.4375rem;\n  height: 3.125rem;\n  border: none;\n  border-radius: 1.5625rem;\n  background: #FFFFFF;\n}\n.match-live-container .add-channel-btn .icon-plus[data-v-2a188149] {\n  margin-right: 0.375rem;\n  width: 0.75rem;\n  height: 0.75rem;\n}\n.match-live-container .add-channel-btn .add-channel-text[data-v-2a188149] {\n  font-weight: bold;\n  font-size: 0.875rem;\n  color: #8C969F;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(509);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(512);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(125);

var _extends3 = _interopRequireDefault(_extends2);

var _axios = __webpack_require__(185);

var _axios2 = _interopRequireDefault(_axios);

var _AppLoading = __webpack_require__(627);

var _AppLoading2 = _interopRequireDefault(_AppLoading);

var _AppLivePopup = __webpack_require__(697);

var _AppLivePopup2 = _interopRequireDefault(_AppLivePopup);

var _common = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AppLoading: _AppLoading2.default,
        AppLivePopup: _AppLivePopup2.default
    },

    props: {
        matchId: {
            type: String,
            default: ''
        }
    },

    data: function data() {
        return {
            isLoading: false,
            popupVisible: false,
            likeNum: [621, 257, 106, 78, 0],
            channels: []
        };
    },


    computed: {
        matchLiveFormation: function matchLiveFormation() {
            return this.$store.state.matchDetailStore.matchLiveFormation;
        }
    },

    mounted: function mounted() {
        var _this = this;

        var result = (this.matchLiveFormation || []).map(function (item, i) {
            return (0, _extends3.default)({}, item, { like: false, likes: _this.likeNum[i] });
        });

        this.channels = result;
    },


    methods: {
        handleChannelClick: function handleChannelClick(channel) {
            window.open(channel.url, '_blank');
        },
        handleChannelLike: function handleChannelLike(order) {
            var channel = this.channels[order];

            channel.like = !channel.like;
            channel.like ? channel.likes++ : channel.likes--;
        },
        handleSubmit: function handleSubmit(channel) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var cid, params;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.isLoading = true;

                                _context.prev = 1;
                                cid = (0, _common.convertToFiveMillion)(_this2.matchId);
                                params = {
                                    match_id: cid,
                                    url: encodeURIComponent(channel)
                                };
                                _context.next = 6;
                                return (0, _axios2.default)({
                                    url: 'https://match.allfootballapp.com/app/live/userAdd',
                                    method: 'get',
                                    params: params
                                });

                            case 6:

                                _this2.popupVisible = false;
                                _this2.$toast('hasil baik');
                                _context.next = 14;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](1);

                                _this2.$toast('Pengiriman Gagal');
                                console.log(_context.t0);

                            case 14:
                                _context.prev = 14;

                                _this2.isLoading = false;
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[1, 10, 14, 17]]);
            }))();
        }
    }
};

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(701),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d592b352",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(699);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("68845efe", content, true, {});

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "[data-v-d592b352]{box-sizing:border-box}.container[data-v-d592b352]{width:100%}.container .input-field[data-v-d592b352]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:2.0625rem;margin-bottom:.5625rem}.container .input-field .input[data-v-d592b352]{-webkit-box-flex:1;-ms-flex:1;flex:1;height:100%;padding:.5625rem .5rem;border:1px solid #ccc;border-radius:.3125rem;outline:none;box-shadow:none}.container .input-field .submit-btn[data-v-d592b352]{margin-left:.625rem;height:100%;padding:0 .6875rem;font-size:.9375rem;font-weight:500;color:#fff;border:none;border-radius:.0625rem;background:#16b13a;-webkit-tap-highlight-color:transparent}.container .input-field .submit-btn.disabled[data-v-d592b352]{opacity:.8}.container .note[data-v-d592b352]{text-align:center;font-size:.625rem;font-weight:400;color:#8c969f;font-family:SF UI Display}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/AppLivePopup.vue"],"names":[],"mappings":"AACA,kBACE,qBAAuB,CACxB,AACD,4BACE,UAAY,CACb,AACD,yCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAkB,AAClB,sBAAyB,CAC1B,AACD,gDACE,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,uBAA0B,AAC1B,sBAAuB,AACvB,uBAAyB,AAEzB,aAAc,AACd,eAAiB,CAClB,AACD,qDACE,oBAAqB,AACrB,YAAa,AACb,mBAAoB,AACpB,mBAAqB,AACrB,gBAAiB,AACjB,WAAe,AACf,YAAa,AACb,uBAAyB,AACzB,mBAAoB,AACpB,uCAAyC,CAC1C,AACD,8DACE,UAAa,CACd,AACD,kCACE,kBAAmB,AACnB,kBAAoB,AACpB,gBAAiB,AACjB,cAAe,AACf,yBAA2B,CAC5B","file":"AppLivePopup.vue","sourcesContent":["\n*[data-v-d592b352] {\n  box-sizing: border-box;\n}\n.container[data-v-d592b352] {\n  width: 100%;\n}\n.container .input-field[data-v-d592b352] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 2.0625rem;\n  margin-bottom: 0.5625rem;\n}\n.container .input-field .input[data-v-d592b352] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 100%;\n  padding: 0.5625rem 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 0.3125rem;\n  /* 去除获取焦点时的默认样式 */\n  outline: none;\n  box-shadow: none;\n}\n.container .input-field .submit-btn[data-v-d592b352] {\n  margin-left: .625rem;\n  height: 100%;\n  padding: 0 .6875rem;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 0.0625rem;\n  background: #16B13A;\n  -webkit-tap-highlight-color: transparent;\n}\n.container .input-field .submit-btn.disabled[data-v-d592b352] {\n  opacity: 0.8;\n}\n.container .note[data-v-d592b352] {\n  text-align: center;\n  font-size: 0.625rem;\n  font-weight: 400;\n  color: #8C969F;\n  font-family: SF UI Display;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BasicPopup = __webpack_require__(628);

var _BasicPopup2 = _interopRequireDefault(_BasicPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        BasicPopup: _BasicPopup2.default
    },

    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    data: function data() {
        return {
            inputVal: ''
        };
    },


    watch: {
        visible: function visible() {
            this.inputVal = '';
        }
    },

    methods: {
        handleClose: function handleClose() {
            this.$emit('close');
        },
        handleSubmit: function handleSubmit() {
            if (!this.inputVal) return;

            this.$emit('submit', this.inputVal);
        }
    }
};

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasicPopup', {
    attrs: {
      "title": "Saya ada siaran langsung gratis",
      "visible": _vm.visible
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputVal),
      expression: "inputVal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Silakan masukan"
    },
    domProps: {
      "value": (_vm.inputVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "submit-btn",
    class: {
      disabled: !_vm.inputVal
    },
    attrs: {
      "disabled": !_vm.inputVal
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n                Memasuki\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Tampilan sumber langsung setelah ditinjau")])])])
},staticRenderFns: []}

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-live-container"
  }, [_c('h2', {
    staticClass: "live-title"
  }, [_vm._v("Saya ada siaran langsung gratis")]), _vm._v(" "), (_vm.channels.length || _vm.isLoading) ? _c('ul', {
    staticClass: "channel-list"
  }, _vm._l((_vm.channels), function(channel, index) {
    return _c('li', {
      key: channel.cname,
      staticClass: "channel-item"
    }, [_c('div', {
      staticClass: "channel-info",
      on: {
        "click": function($event) {
          _vm.handleChannelClick(channel)
        }
      }
    }, [_c('img', {
      staticClass: "icon-living",
      attrs: {
        "src": __webpack_require__(568)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "channel-name"
    }, [_vm._v(_vm._s(channel.cname))]), _vm._v(" "), _c('img', {
      staticClass: "icon-play",
      attrs: {
        "src": __webpack_require__(703)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "channel-likes",
      on: {
        "click": function($event) {
          _vm.handleChannelLike(index)
        }
      }
    }, [(channel.like) ? _c('img', {
      staticClass: "icon-like",
      attrs: {
        "src": __webpack_require__(704)
      }
    }) : _c('img', {
      staticClass: "icon-like",
      attrs: {
        "src": __webpack_require__(705)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "likes-count"
    }, [_vm._v(_vm._s(channel.likes))])])])
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.channels.length) ? _c('div', {
    staticClass: "data-empty"
  }, [_vm._v("\n        Siaran langsung streaming gratis sedang dipersiapkan untuk Anda simak sebelum pertandingan dimulai!\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "add-channel-btn",
    on: {
      "click": function($event) {
        _vm.popupVisible = true
      }
    }
  }, [_c('img', {
    staticClass: "icon-plus",
    attrs: {
      "src": __webpack_require__(706)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "add-channel-text"
  }, [_vm._v("Saya ada siaran langsung gratis")])]), _vm._v(" "), _c('AppLoading', {
    attrs: {
      "loading": _vm.isLoading
    }
  }), _vm._v(" "), _c('AppLivePopup', {
    attrs: {
      "visible": _vm.popupVisible
    },
    on: {
      "close": function($event) {
        _vm.popupVisible = false
      },
      "submit": _vm.handleSubmit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABBCAMAAACO5/ZDAAAAk1BMVEUAAAAwtUQyu0kwtkUwtUQxuUIwtUQvt0EwtkQwtUQwtUQwtUQwtUQss0UwtUQwtkQvtUMwtUMyt0UwtUQwtUMwtUQwtUQwtUMwtUMwtkQwtkMwtUMvtUQwtUIwtUQwtUQwtUQvtkQwtUQwtUQwtUQwtkUwtkQwtEMvtUQwtUQwtUQwtkQvtkQvtkQvtUMxtUQwtUREX9TgAAAAMHRSTlMA+QUc8wdSD7F25d0uC+/GvyMU9W5k6cytoX5oNRjt4V5G14yEV0Mo09CTO7mcSz7WIcajAAABwklEQVRIx6VW2ZKCMBAkBsJpELlvEOXw2OX/v25rN2H1pcXSPHd1w0xPzyivPY2yPGiK7VMQZYkdxZnzFMUMyyfqeHO0J6CgJvM8+4fjZYNBJv8FzcTOPMwVTv78+/y48yDXpbPJH4rHpoNQ+sWwZsE1BSVQ3OzbVBVc6s6kCkKdkkigol04KOCVX7tqllyhvgFc9JQIKlIZ4V5BqPzKBVednChS9JpYFSieMNRGzcuvAkSilOkINZiu5LLTtkSKTnAgAhWde9TGrZO5UrE+f+sIVRxHX8Cm7rJHisWxlopWVsBmF+dRKh6O0NB6f7Yll5s5OlJsb5HksnPY7H2f2rLZsQkNrbPUkt2+Btj2zOBSccTNpmwxNN/lJapEGRqVNHTSUKSohUuzVbeFJvQaaWhi3VoFWtV0l9LnCkZ1RAqaHzG98k1as/53ZZgsdTJEnd6sODOqh96tu2DYvu+n/mYtzgyG9z2uF90EpgXNHZrg6WGC17OgBzM3gFTB+fR+0tH/zKzumYnT1zjRtRznIMfxRsC7BW4pvral9O/Hfbf5YHOG4ws72FTBNsd3Ab4wyP3CwOFX87VbRaMsMMXV89H7Aa3RYZsrpM3ZAAAAAElFTkSuQmCC"

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-tread.22fe7a0.png";

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-like.a5f85cc.png";

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-add.155cef2.png";

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixed"
    }
  }, [(_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("Untuk memberi Anda pengalaman yang lebih baik, silakan unduh\n            aplikasi profesional kami.")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "navBread"
  }, [_c('a', {
    staticClass: "match",
    attrs: {
      "href": "/matchs"
    }
  }, [_vm._v("Match")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/matchs/' + _vm.subtitleName,
      "id": "matchSubtitJump"
    }
  }, [_vm._v(_vm._s(_vm.subtitleName))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerInformWrap clearfix",
    attrs: {
      "id": "teamWrap"
    }
  }, [_c('div', {
    staticClass: "banner-left"
  }, [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "team-logo",
    attrs: {
      "src": _vm.getImgSrc(_vm.idData.team_A_logo),
      "alt": _vm.idData.team_A_name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "team-name"
  }, [_vm._v(_vm._s(_vm.idData.team_A_name))])]), _vm._v(" "), _c('div', {
    staticClass: "bannerCenterWrap"
  }, [(_vm.competeStatus === 'Played') ? _c('div', {
    staticClass: "w-full status_ended"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _c('b', {
    staticClass: "rowLine"
  }), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])]) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Playing') ? _c('div', {
    staticClass: "w-full status_playing"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v("\n                        " + _vm._s(_vm.idData.competition_name) + "\n                        "), (_vm.idData.livingFlag) ? _c('span', {
    staticClass: "text-green"
  }, [_vm._v(_vm._s(_vm.idData.minute) + "'")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "scorewrap clearfix"
  }, [_c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.idData.fs_A))]), _vm._v(" "), _c('b', {
    staticClass: "rowLine"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.idData.fs_B))])]), _vm._v(" "), (_vm.matchTagFormation.type) ? _c('AppMatchTag', {
    attrs: {
      "type": _vm.matchTagFormation.type
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.idData.livingFlag) ? _c('p', {
    staticClass: "unlive"
  }, [_vm._v(_vm._s(_vm.idData.minute) + "'")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Fixture') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [(_vm.idData.livingFlag) ? [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))] : _vm._e(), _vm._v("\n                        " + _vm._s(_vm.idData.competition_name) + "\n                    ")], 2), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), (_vm.matchTagFormation.type) ? _c('AppMatchTag', {
    attrs: {
      "type": _vm.matchTagFormation.type
    }
  }) : _c('div', {
    staticClass: "unstartTime clearfix"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.local_month_day) + " " + _vm._s(_vm.tran12(_vm.local_hour_minite)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.competeStatus === 'Postponed' || _vm.competeStatus === 'Cancelled' || _vm.competeStatus === 'Suspended') ? _c('div', {
    staticClass: "status_unstart"
  }, [_c('p', {
    staticClass: "competename"
  }, [_vm._v(_vm._s(_vm.idData.competition_name))]), _vm._v(" "), _c('p', {
    staticClass: "vs"
  }, [_vm._v("VS")]), _vm._v(" "), _c('div', {
    staticClass: "unstartTime clearfix"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.competeStatus))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "banner-right"
  }, [_c('img', {
    directives: [{
      name: "team-logo",
      rawName: "v-team-logo"
    }],
    staticClass: "team-logo",
    attrs: {
      "alt": _vm.idData.team_B_name,
      "src": _vm.getImgSrc(_vm.idData.team_B_logo)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "team-name"
  }, [_vm._v(_vm._s(_vm.idData.team_B_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "tabWrap"
  }, [_c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Ikhtisar'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Ikhtisar')
      }
    }
  }, [_vm._v("Ikhtisar")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Analisis'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Analisis')
      }
    }
  }, [_vm._v("Analysis")]), _vm._v(" "), _c('span', {
    class: {
      'selected': _vm.toggleSelect === 'Live'
    },
    on: {
      "click": function($event) {
        _vm.toggle('Live')
      }
    }
  }, [_vm._v("Langsung HD")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('match-overview', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Ikhtisar'),
      expression: "toggleSelect === 'Ikhtisar'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('match-analysis', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Analisis'),
      expression: "toggleSelect === 'Analisis'"
    }],
    staticClass: "tabContent",
    attrs: {
      "matchId": _vm.competeId
    }
  }), _vm._v(" "), _c('match-live', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSelect === 'Live'),
      expression: "toggleSelect === 'Live'"
    }],
    style: ({
      height: _vm.contentHeight
    }),
    attrs: {
      "matchId": _vm.competeId
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.5c19433c9f2e9b813565.js